/* tslint:disable */
/* eslint-disable */
/**
 * Case Management Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Data for action completion events.
 * @export
 * @interface ActionCompletedEventData
 */
export interface ActionCompletedEventData {
    /**
     * 
     * @type {string}
     * @memberof ActionCompletedEventData
     */
    'event_type'?: ActionCompletedEventDataEventTypeEnum;
    /**
     * Properties that were updated with their new values
     * @type {{ [key: string]: UpdatedPropertiesValue; }}
     * @memberof ActionCompletedEventData
     */
    'updated_properties': { [key: string]: UpdatedPropertiesValue; };
    /**
     * 
     * @type {Array<FormUpdate>}
     * @memberof ActionCompletedEventData
     */
    'task_form_updates'?: Array<FormUpdate> | null;
    /**
     * 
     * @type {Array<FormUpdate>}
     * @memberof ActionCompletedEventData
     */
    'action_form_updates'?: Array<FormUpdate> | null;
    /**
     * 
     * @type {{ [key: string]: ActionCompletedEventDataBlocksPatchOperationsValue; }}
     * @memberof ActionCompletedEventData
     */
    'blocks_patch_operations'?: { [key: string]: ActionCompletedEventDataBlocksPatchOperationsValue; } | null;
    /**
     * 
     * @type {string}
     * @memberof ActionCompletedEventData
     */
    'running_action_id'?: string | null;
}

export const ActionCompletedEventDataEventTypeEnum = {
    ACTION_COMPLETED: 'action_completed'
} as const;

export type ActionCompletedEventDataEventTypeEnum = typeof ActionCompletedEventDataEventTypeEnum[keyof typeof ActionCompletedEventDataEventTypeEnum];

/**
 * 
 * @export
 * @interface ActionCompletedEventDataBlocksPatchOperationsValue
 */
export interface ActionCompletedEventDataBlocksPatchOperationsValue {
    /**
     * 
     * @type {Data3}
     * @memberof ActionCompletedEventDataBlocksPatchOperationsValue
     */
    'data'?: Data3 | null;
    /**
     * 
     * @type {PinnedEntities}
     * @memberof ActionCompletedEventDataBlocksPatchOperationsValue
     */
    'pinned_entities'?: PinnedEntities;
    /**
     * 
     * @type {PinnedEvents}
     * @memberof ActionCompletedEventDataBlocksPatchOperationsValue
     */
    'pinned_events'?: PinnedEvents;
}
/**
 * Data for action failure events.
 * @export
 * @interface ActionFailedEventData
 */
export interface ActionFailedEventData {
    /**
     * 
     * @type {string}
     * @memberof ActionFailedEventData
     */
    'event_type'?: ActionFailedEventDataEventTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ActionFailedEventData
     */
    'error_message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionFailedEventData
     */
    'decision_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionFailedEventData
     */
    'running_action_id'?: string | null;
}

export const ActionFailedEventDataEventTypeEnum = {
    ACTION_FAILED: 'action_failed'
} as const;

export type ActionFailedEventDataEventTypeEnum = typeof ActionFailedEventDataEventTypeEnum[keyof typeof ActionFailedEventDataEventTypeEnum];

/**
 * Data for action triggered events.
 * @export
 * @interface ActionTriggeredEventData
 */
export interface ActionTriggeredEventData {
    /**
     * 
     * @type {string}
     * @memberof ActionTriggeredEventData
     */
    'event_type'?: ActionTriggeredEventDataEventTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ActionTriggeredEventData
     */
    'decision_id'?: string | null;
    /**
     * Key of the triggered action
     * @type {string}
     * @memberof ActionTriggeredEventData
     */
    'action_key': string;
    /**
     * Display name of the action
     * @type {string}
     * @memberof ActionTriggeredEventData
     */
    'action_display_name': string;
    /**
     * 
     * @type {string}
     * @memberof ActionTriggeredEventData
     */
    'running_action_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionTriggeredEventData
     */
    'action_flow_slug'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionTriggeredEventData
     */
    'action_flow_version_name'?: string | null;
    /**
     * Whether the action was retried
     * @type {boolean}
     * @memberof ActionTriggeredEventData
     */
    'is_retry': boolean;
    /**
     * 
     * @type {string}
     * @memberof ActionTriggeredEventData
     */
    'retried_by'?: string | null;
    /**
     * 
     * @type {{ [key: string]: ActionTriggeredEventDataActionFormDataValue; }}
     * @memberof ActionTriggeredEventData
     */
    'action_form_data'?: { [key: string]: ActionTriggeredEventDataActionFormDataValue; } | null;
}

export const ActionTriggeredEventDataEventTypeEnum = {
    ACTION_TRIGGERED: 'action_triggered'
} as const;

export type ActionTriggeredEventDataEventTypeEnum = typeof ActionTriggeredEventDataEventTypeEnum[keyof typeof ActionTriggeredEventDataEventTypeEnum];

/**
 * 
 * @export
 * @interface ActionTriggeredEventDataActionFormDataValue
 */
export interface ActionTriggeredEventDataActionFormDataValue {
}
/**
 * 
 * @export
 * @interface AssigneeIdentifier
 */
export interface AssigneeIdentifier {
    /**
     * 
     * @type {string}
     * @memberof AssigneeIdentifier
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssigneeIdentifier
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssigneeIdentifier
     */
    'lid'?: string | null;
}
/**
 * 
 * @export
 * @interface Attributes
 */
export interface Attributes {
    /**
     * 
     * @type {Array<PinnedEntity>}
     * @memberof Attributes
     */
    'pinned_entities': Array<PinnedEntity>;
    /**
     * 
     * @type {Array<PinnedEvent>}
     * @memberof Attributes
     */
    'pinned_events': Array<PinnedEvent>;
}
/**
 * 
 * @export
 * @interface Attributes1
 */
export interface Attributes1 {
    /**
     * 
     * @type {CaseRunningActionStatus}
     * @memberof Attributes1
     */
    'status': CaseRunningActionStatus;
    /**
     * 
     * @type {string}
     * @memberof Attributes1
     */
    'action_key': string;
    /**
     * 
     * @type {string}
     * @memberof Attributes1
     */
    'sub_status'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Attributes1
     */
    'is_completed': boolean;
    /**
     * 
     * @type {string}
     * @memberof Attributes1
     */
    'display_name': string;
    /**
     * 
     * @type {string}
     * @memberof Attributes1
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof Attributes1
     */
    'category_key': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Attributes1
     */
    'file_ids'?: Array<string>;
    /**
     * 
     * @type {CaseRunningActionType}
     * @memberof Attributes1
     */
    'type': CaseRunningActionType;
    /**
     * 
     * @type {string}
     * @memberof Attributes1
     */
    'action_id'?: string;
    /**
     * 
     * @type {Array<CaseTemplateWorkflowRuleActionAutomation>}
     * @memberof Attributes1
     */
    'automation'?: Array<CaseTemplateWorkflowRuleActionAutomation>;
    /**
     * 
     * @type {string}
     * @memberof Attributes1
     */
    'error_message'?: string;
    /**
     * 
     * @type {string}
     * @memberof Attributes1
     */
    'kind'?: Attributes1KindEnum;
    /**
     * 
     * @type {EntityObject}
     * @memberof Attributes1
     */
    'entity': EntityObject;
    /**
     * 
     * @type {EventObject}
     * @memberof Attributes1
     */
    'event': EventObject;
    /**
     * 
     * @type {Array<PinnedEntity>}
     * @memberof Attributes1
     */
    'pinned_entities': Array<PinnedEntity>;
    /**
     * 
     * @type {Array<PinnedEvent>}
     * @memberof Attributes1
     */
    'pinned_events': Array<PinnedEvent>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Attributes1
     */
    'event_types'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Attributes1
     */
    'content'?: string;
    /**
     * 
     * @type {Record}
     * @memberof Attributes1
     */
    'record': Record;
    /**
     * 
     * @type {string}
     * @memberof Attributes1
     */
    'template_name': string;
    /**
     * 
     * @type {string}
     * @memberof Attributes1
     */
    'icon'?: string;
    /**
     * 
     * @type {string}
     * @memberof Attributes1
     */
    'etag'?: string;
    /**
     * 
     * @type {string}
     * @memberof Attributes1
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof Attributes1
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof Attributes1
     */
    'version_name': string;
    /**
     * 
     * @type {{ [key: string]: CasePropertiesValue; }}
     * @memberof Attributes1
     */
    'case_properties': { [key: string]: CasePropertiesValue; };
    /**
     * 
     * @type {{ [key: string]: CaseTemplateReviewRole; }}
     * @memberof Attributes1
     */
    'review_roles': { [key: string]: CaseTemplateReviewRole; };
    /**
     * 
     * @type {{ [key: string]: CaseTemplateAdditionalInput; }}
     * @memberof Attributes1
     */
    'additional_inputs': { [key: string]: CaseTemplateAdditionalInput; };
    /**
     * 
     * @type {{ [key: string]: CaseBlockConfigOutput; }}
     * @memberof Attributes1
     */
    'case_blocks_configs': { [key: string]: CaseBlockConfigOutput; };
    /**
     * 
     * @type {{ [key: string]: CaseTemplateFileCategoryDefinition; }}
     * @memberof Attributes1
     */
    'file_categories': { [key: string]: CaseTemplateFileCategoryDefinition; };
    /**
     * 
     * @type {number}
     * @memberof Attributes1
     */
    'schema_version'?: number;
    /**
     * 
     * @type {CaseTemplateVersionPublishState}
     * @memberof Attributes1
     */
    'publish_state': CaseTemplateVersionPublishState;
    /**
     * 
     * @type {string}
     * @memberof Attributes1
     */
    'published_at'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Attributes1
     */
    'archived': boolean;
    /**
     * 
     * @type {CaseTemplateCaseCreationFlowDetails}
     * @memberof Attributes1
     */
    'case_creation_flow_details'?: CaseTemplateCaseCreationFlowDetails;
    /**
     * 
     * @type {{ [key: string]: CaseTemplateActionOutput; }}
     * @memberof Attributes1
     */
    'case_actions': { [key: string]: CaseTemplateActionOutput; };
    /**
     * 
     * @type {{ [key: string]: CaseTemplateTaskOutput; }}
     * @memberof Attributes1
     */
    'case_tasks': { [key: string]: CaseTemplateTaskOutput; };
    /**
     * 
     * @type {{ [key: string]: CaseTemplateWorkflowRuleOutput; }}
     * @memberof Attributes1
     */
    'workflow_rules': { [key: string]: CaseTemplateWorkflowRuleOutput; };
    /**
     * 
     * @type {CaseTemplateVersionCopilotSettings}
     * @memberof Attributes1
     */
    'copilot_settings'?: CaseTemplateVersionCopilotSettings;
    /**
     * 
     * @type {CopilotReference}
     * @memberof Attributes1
     */
    'copilot_reference'?: CopilotReference;
    /**
     * 
     * @type {string}
     * @memberof Attributes1
     */
    'case_id': string;
}

export const Attributes1KindEnum = {
    RELATED_EVENTS: 'related_events'
} as const;

export type Attributes1KindEnum = typeof Attributes1KindEnum[keyof typeof Attributes1KindEnum];

/**
 * 
 * @export
 * @interface AttributesValue
 */
export interface AttributesValue {
}
/**
 * Attributes for a case action resource.
 * @export
 * @interface CaseActionAttributes
 */
export interface CaseActionAttributes {
    /**
     * 
     * @type {string}
     * @memberof CaseActionAttributes
     */
    'action_key': string;
    /**
     * 
     * @type {string}
     * @memberof CaseActionAttributes
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof CaseActionAttributes
     */
    'sub_status'?: string | null;
}
/**
 * Meta data for case action form resources.
 * @export
 * @interface CaseActionFormMeta
 */
export interface CaseActionFormMeta {
    /**
     * 
     * @type {string}
     * @memberof CaseActionFormMeta
     */
    'etag': string;
}
/**
 * Request model for updating case action form data.
 * @export
 * @interface CaseActionFormPatchRequest
 */
export interface CaseActionFormPatchRequest {
    /**
     * 
     * @type {ModelsCaseDataApiModelsCaseActionFormPatchRequestData}
     * @memberof CaseActionFormPatchRequest
     */
    'data': ModelsCaseDataApiModelsCaseActionFormPatchRequestData;
}
/**
 * 
 * @export
 * @interface CaseActionFormPatchResponse
 */
export interface CaseActionFormPatchResponse {
    /**
     * 
     * @type {JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseActionFormMeta}
     * @memberof CaseActionFormPatchResponse
     */
    'data': JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseActionFormMeta;
    /**
     * 
     * @type {object}
     * @memberof CaseActionFormPatchResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof CaseActionFormPatchResponse
     */
    'links': JsonApiSuccessResponseLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectBaseModelCaseActionFormMeta>}
     * @memberof CaseActionFormPatchResponse
     */
    'included'?: Array<JsonApiResourceObjectBaseModelCaseActionFormMeta> | null;
}
/**
 * Operation to update case action form directly.
 * @export
 * @interface CaseActionFormUpdateOperation
 */
export interface CaseActionFormUpdateOperation {
    /**
     * 
     * @type {string}
     * @memberof CaseActionFormUpdateOperation
     */
    'op'?: CaseActionFormUpdateOperationOpEnum;
    /**
     * 
     * @type {ModelsCaseDataApiModelsCaseActionFormPatchRequestData}
     * @memberof CaseActionFormUpdateOperation
     */
    'data': ModelsCaseDataApiModelsCaseActionFormPatchRequestData;
}

export const CaseActionFormUpdateOperationOpEnum = {
    UPDATE: 'update'
} as const;

export type CaseActionFormUpdateOperationOpEnum = typeof CaseActionFormUpdateOperationOpEnum[keyof typeof CaseActionFormUpdateOperationOpEnum];

/**
 * Request model for approving an action hint and saving form data.
 * @export
 * @interface CaseActionHintApproveRequest
 */
export interface CaseActionHintApproveRequest {
    /**
     * 
     * @type {ModelsCaseDataApiModelsCaseActionHintApproveRequestData}
     * @memberof CaseActionHintApproveRequest
     */
    'data': ModelsCaseDataApiModelsCaseActionHintApproveRequestData;
}
/**
 * Response model for approving an action hint (returns saved form state).
 * @export
 * @interface CaseActionHintApproveResponse
 */
export interface CaseActionHintApproveResponse {
    /**
     * 
     * @type {JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseActionFormMeta}
     * @memberof CaseActionHintApproveResponse
     */
    'data': JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseActionFormMeta;
    /**
     * 
     * @type {object}
     * @memberof CaseActionHintApproveResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof CaseActionHintApproveResponse
     */
    'links': JsonApiSuccessResponseLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectBaseModelCaseActionFormMeta>}
     * @memberof CaseActionHintApproveResponse
     */
    'included'?: Array<JsonApiResourceObjectBaseModelCaseActionFormMeta> | null;
}
/**
 * Request model for patching a single action hint.
 * @export
 * @interface CaseActionHintPatchRequest
 */
export interface CaseActionHintPatchRequest {
    /**
     * 
     * @type {ModelsCaseDataApiModelsCaseActionHintPatchRequestData}
     * @memberof CaseActionHintPatchRequest
     */
    'data': ModelsCaseDataApiModelsCaseActionHintPatchRequestData;
}
/**
 * Response model for patching a single action hint.
 * @export
 * @interface CaseActionHintPatchResponse
 */
export interface CaseActionHintPatchResponse {
    /**
     * 
     * @type {JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeBaseModel}
     * @memberof CaseActionHintPatchResponse
     */
    'data': JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeBaseModel;
    /**
     * 
     * @type {object}
     * @memberof CaseActionHintPatchResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof CaseActionHintPatchResponse
     */
    'links': JsonApiSuccessResponseLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectBaseModelBaseModel>}
     * @memberof CaseActionHintPatchResponse
     */
    'included'?: Array<JsonApiResourceObjectBaseModelBaseModel> | null;
}
/**
 * 
 * @export
 * @interface CaseAdditionalInputResource
 */
export interface CaseAdditionalInputResource {
    /**
     * 
     * @type {string}
     * @memberof CaseAdditionalInputResource
     */
    'type': CaseAdditionalInputResourceTypeEnum;
    /**
     * 
     * @type {{ [key: string]: AttributesValue; }}
     * @memberof CaseAdditionalInputResource
     */
    'attributes': { [key: string]: AttributesValue; };
}

export const CaseAdditionalInputResourceTypeEnum = {
    ADDITIONAL_INPUTS: 'additional_inputs'
} as const;

export type CaseAdditionalInputResourceTypeEnum = typeof CaseAdditionalInputResourceTypeEnum[keyof typeof CaseAdditionalInputResourceTypeEnum];

/**
 * 
 * @export
 * @interface CaseArchiveAtomicOperation
 */
export interface CaseArchiveAtomicOperation {
    /**
     * 
     * @type {string}
     * @memberof CaseArchiveAtomicOperation
     */
    'op'?: CaseArchiveAtomicOperationOpEnum;
    /**
     * 
     * @type {CaseBulkRef}
     * @memberof CaseArchiveAtomicOperation
     */
    'ref': CaseBulkRef;
    /**
     * 
     * @type {CaseArchiveMeta}
     * @memberof CaseArchiveAtomicOperation
     */
    'meta': CaseArchiveMeta;
}

export const CaseArchiveAtomicOperationOpEnum = {
    UPDATE: 'update'
} as const;

export type CaseArchiveAtomicOperationOpEnum = typeof CaseArchiveAtomicOperationOpEnum[keyof typeof CaseArchiveAtomicOperationOpEnum];

/**
 * 
 * @export
 * @interface CaseArchiveMeta
 */
export interface CaseArchiveMeta {
    /**
     * 
     * @type {string}
     * @memberof CaseArchiveMeta
     */
    'action': CaseArchiveMetaActionEnum;
}

export const CaseArchiveMetaActionEnum = {
    ARCHIVE: 'archive'
} as const;

export type CaseArchiveMetaActionEnum = typeof CaseArchiveMetaActionEnum[keyof typeof CaseArchiveMetaActionEnum];

/**
 * Data for case assignment events.
 * @export
 * @interface CaseAssignedEventData
 */
export interface CaseAssignedEventData {
    /**
     * 
     * @type {string}
     * @memberof CaseAssignedEventData
     */
    'event_type'?: CaseAssignedEventDataEventTypeEnum;
    /**
     * User assigned to the case
     * @type {string}
     * @memberof CaseAssignedEventData
     */
    'assigned_to_user_id': string;
    /**
     * 
     * @type {string}
     * @memberof CaseAssignedEventData
     */
    'assigned_by_user_id'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CaseAssignedEventData
     */
    'is_self_assignment'?: boolean | null;
}

export const CaseAssignedEventDataEventTypeEnum = {
    CASE_ASSIGNED: 'case_assigned'
} as const;

export type CaseAssignedEventDataEventTypeEnum = typeof CaseAssignedEventDataEventTypeEnum[keyof typeof CaseAssignedEventDataEventTypeEnum];

/**
 * Operation to update a case\'s assignee relationship.
 * @export
 * @interface CaseAssigneeUpdateOperation
 */
export interface CaseAssigneeUpdateOperation {
    /**
     * 
     * @type {string}
     * @memberof CaseAssigneeUpdateOperation
     */
    'op'?: CaseAssigneeUpdateOperationOpEnum;
    /**
     * 
     * @type {JsonApiAtomicRelationshipRef}
     * @memberof CaseAssigneeUpdateOperation
     */
    'ref': JsonApiAtomicRelationshipRef;
    /**
     * 
     * @type {AssigneeIdentifier}
     * @memberof CaseAssigneeUpdateOperation
     */
    'data'?: AssigneeIdentifier | null;
}

export const CaseAssigneeUpdateOperationOpEnum = {
    UPDATE: 'update'
} as const;

export type CaseAssigneeUpdateOperationOpEnum = typeof CaseAssigneeUpdateOperationOpEnum[keyof typeof CaseAssigneeUpdateOperationOpEnum];

/**
 * Request model for atomic operations on cases.
 * @export
 * @interface CaseAtomicOperationsRequest
 */
export interface CaseAtomicOperationsRequest {
    /**
     * 
     * @type {Array<CaseAtomicOperationsRequestAtomicOperationsInner>}
     * @memberof CaseAtomicOperationsRequest
     */
    'atomic:operations': Array<CaseAtomicOperationsRequestAtomicOperationsInner>;
}
/**
 * @type CaseAtomicOperationsRequestAtomicOperationsInner
 * @export
 */
export type CaseAtomicOperationsRequestAtomicOperationsInner = CaseActionFormUpdateOperation | CaseAssigneeUpdateOperation | CaseBlockConfigUpdateOperation | CaseBlockDataUpdateOperation | CasePropertiesUpdateOperation | CaseQueueUpdateOperation | CaseTaskFormUpdateOperation;

/**
 * Response model for atomic operations results.
 * @export
 * @interface CaseAtomicResultsResponse
 */
export interface CaseAtomicResultsResponse {
    /**
     * 
     * @type {Array<JsonApiAtomicResult>}
     * @memberof CaseAtomicResultsResponse
     */
    'atomic:results': Array<JsonApiAtomicResult>;
}
/**
 * CaseAttributes only include specific fields from the Case model. Extra fields are automatically ignored.
 * @export
 * @interface CaseAttributes
 */
export interface CaseAttributes {
    /**
     * 
     * @type {CaseEnvironment}
     * @memberof CaseAttributes
     */
    'env': CaseEnvironment;
    /**
     * 
     * @type {string}
     * @memberof CaseAttributes
     */
    'template_version_etag': string;
    /**
     * 
     * @type {number}
     * @memberof CaseAttributes
     */
    'template_schema_version': number;
    /**
     * 
     * @type {string}
     * @memberof CaseAttributes
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof CaseAttributes
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof CaseAttributes
     */
    'etag': string;
}


/**
 * 
 * @export
 * @interface CaseBlockConfigInput
 */
export interface CaseBlockConfigInput {
    /**
     * 
     * @type {CaseBlockPositioning}
     * @memberof CaseBlockConfigInput
     */
    'case_block_positioning': CaseBlockPositioning;
    /**
     * Block title to display
     * @type {string}
     * @memberof CaseBlockConfigInput
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CaseBlockConfigInput
     */
    'icon'?: string | null;
    /**
     * 
     * @type {Config}
     * @memberof CaseBlockConfigInput
     */
    'config': Config;
}
/**
 * 
 * @export
 * @interface CaseBlockConfigOutput
 */
export interface CaseBlockConfigOutput {
    /**
     * 
     * @type {CaseBlockPositioning}
     * @memberof CaseBlockConfigOutput
     */
    'case_block_positioning': CaseBlockPositioning;
    /**
     * Block title to display
     * @type {string}
     * @memberof CaseBlockConfigOutput
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CaseBlockConfigOutput
     */
    'icon'?: string | null;
    /**
     * 
     * @type {Config1}
     * @memberof CaseBlockConfigOutput
     */
    'config': Config1;
}
/**
 * Case block config patch resource for atomic operations.  Only RelatedEntities and RelatedEvents blocks can have config patches.
 * @export
 * @interface CaseBlockConfigPatchResource
 */
export interface CaseBlockConfigPatchResource {
    /**
     * 
     * @type {string}
     * @memberof CaseBlockConfigPatchResource
     */
    'type'?: CaseBlockConfigPatchResourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseBlockConfigPatchResource
     */
    'id': string;
    /**
     * 
     * @type {Attributes}
     * @memberof CaseBlockConfigPatchResource
     */
    'attributes': Attributes;
}

export const CaseBlockConfigPatchResourceTypeEnum = {
    CASE_BLOCK_CONFIGS: 'case_block_configs'
} as const;

export type CaseBlockConfigPatchResourceTypeEnum = typeof CaseBlockConfigPatchResourceTypeEnum[keyof typeof CaseBlockConfigPatchResourceTypeEnum];

/**
 * Operation to update case block config directly.
 * @export
 * @interface CaseBlockConfigUpdateOperation
 */
export interface CaseBlockConfigUpdateOperation {
    /**
     * 
     * @type {string}
     * @memberof CaseBlockConfigUpdateOperation
     */
    'op'?: CaseBlockConfigUpdateOperationOpEnum;
    /**
     * 
     * @type {CaseBlockConfigPatchResource}
     * @memberof CaseBlockConfigUpdateOperation
     */
    'data': CaseBlockConfigPatchResource;
}

export const CaseBlockConfigUpdateOperationOpEnum = {
    UPDATE: 'update'
} as const;

export type CaseBlockConfigUpdateOperationOpEnum = typeof CaseBlockConfigUpdateOperationOpEnum[keyof typeof CaseBlockConfigUpdateOperationOpEnum];

/**
 * Operation to update case block data directly.
 * @export
 * @interface CaseBlockDataUpdateOperation
 */
export interface CaseBlockDataUpdateOperation {
    /**
     * 
     * @type {string}
     * @memberof CaseBlockDataUpdateOperation
     */
    'op'?: CaseBlockDataUpdateOperationOpEnum;
    /**
     * 
     * @type {Data}
     * @memberof CaseBlockDataUpdateOperation
     */
    'data': Data;
}

export const CaseBlockDataUpdateOperationOpEnum = {
    UPDATE: 'update'
} as const;

export type CaseBlockDataUpdateOperationOpEnum = typeof CaseBlockDataUpdateOperationOpEnum[keyof typeof CaseBlockDataUpdateOperationOpEnum];

/**
 * 
 * @export
 * @interface CaseBlockPositioning
 */
export interface CaseBlockPositioning {
    /**
     * Grid column position (1-6)
     * @type {number}
     * @memberof CaseBlockPositioning
     */
    'column': number;
    /**
     * Grid row position
     * @type {number}
     * @memberof CaseBlockPositioning
     */
    'row': number;
    /**
     * Block width in grid units (1-6)
     * @type {number}
     * @memberof CaseBlockPositioning
     */
    'width': number;
    /**
     * Block height in grid units
     * @type {number}
     * @memberof CaseBlockPositioning
     */
    'height': number;
}
/**
 * 
 * @export
 * @interface CaseBulkAtomicOperationsRequest
 */
export interface CaseBulkAtomicOperationsRequest {
    /**
     * 
     * @type {Array<CaseBulkAtomicOperationsRequestAtomicOperationsInner>}
     * @memberof CaseBulkAtomicOperationsRequest
     */
    'atomic:operations': Array<CaseBulkAtomicOperationsRequestAtomicOperationsInner>;
}
/**
 * @type CaseBulkAtomicOperationsRequestAtomicOperationsInner
 * @export
 */
export type CaseBulkAtomicOperationsRequestAtomicOperationsInner = CaseArchiveAtomicOperation | CaseAssigneeUpdateOperation | CaseRunActionAtomicOperation;

/**
 * 
 * @export
 * @interface CaseBulkRef
 */
export interface CaseBulkRef {
    /**
     * 
     * @type {string}
     * @memberof CaseBulkRef
     */
    'type': CaseBulkRefTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseBulkRef
     */
    'relationship': string;
    /**
     * 
     * @type {string}
     * @memberof CaseBulkRef
     */
    'id'?: string | null;
}

export const CaseBulkRefTypeEnum = {
    CASES: 'cases'
} as const;

export type CaseBulkRefTypeEnum = typeof CaseBulkRefTypeEnum[keyof typeof CaseBulkRefTypeEnum];

/**
 * Attributes for creating a case comment.
 * @export
 * @interface CaseCommentCreateAttributes
 */
export interface CaseCommentCreateAttributes {
    /**
     * The text content of the comment
     * @type {string}
     * @memberof CaseCommentCreateAttributes
     */
    'comment_text': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CaseCommentCreateAttributes
     */
    'metadata'?: { [key: string]: string; } | null;
}
/**
 * Request model for creating a case comment.
 * @export
 * @interface CaseCommentCreateRequest
 */
export interface CaseCommentCreateRequest {
    /**
     * 
     * @type {CaseCommentCreateRequestData}
     * @memberof CaseCommentCreateRequest
     */
    'data': CaseCommentCreateRequestData;
}
/**
 * Request data for creating a case comment.
 * @export
 * @interface CaseCommentCreateRequestData
 */
export interface CaseCommentCreateRequestData {
    /**
     * 
     * @type {string}
     * @memberof CaseCommentCreateRequestData
     */
    'type'?: CaseCommentCreateRequestDataTypeEnum;
    /**
     * 
     * @type {CaseCommentCreateAttributes}
     * @memberof CaseCommentCreateRequestData
     */
    'attributes': CaseCommentCreateAttributes;
}

export const CaseCommentCreateRequestDataTypeEnum = {
    CASE_COMMENTS: 'case_comments'
} as const;

export type CaseCommentCreateRequestDataTypeEnum = typeof CaseCommentCreateRequestDataTypeEnum[keyof typeof CaseCommentCreateRequestDataTypeEnum];

/**
 * Response model for case comment creation.
 * @export
 * @interface CaseCommentCreateResponse
 */
export interface CaseCommentCreateResponse {
    /**
     * 
     * @type {JsonApiResourceObjectCaseCommentCreateResponseAttributesBaseModel}
     * @memberof CaseCommentCreateResponse
     */
    'data': JsonApiResourceObjectCaseCommentCreateResponseAttributesBaseModel;
    /**
     * 
     * @type {object}
     * @memberof CaseCommentCreateResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof CaseCommentCreateResponse
     */
    'links': JsonApiSuccessResponseLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectBaseModelBaseModel>}
     * @memberof CaseCommentCreateResponse
     */
    'included'?: Array<JsonApiResourceObjectBaseModelBaseModel> | null;
}
/**
 * 
 * @export
 * @interface CaseCreate
 */
export interface CaseCreate {
    /**
     * 
     * @type {CaseEnvironment}
     * @memberof CaseCreate
     */
    'env': CaseEnvironment;
}


/**
 * 
 * @export
 * @interface CaseCreateAcceptedResponse
 */
export interface CaseCreateAcceptedResponse {
    /**
     * 
     * @type {object}
     * @memberof CaseCreateAcceptedResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof CaseCreateAcceptedResponse
     */
    'links': JsonApiSuccessResponseLinks;
}
/**
 * 
 * @export
 * @interface CaseCreateRequest
 */
export interface CaseCreateRequest {
    /**
     * 
     * @type {ModelsCaseDataApiModelsCaseCreateRequestData}
     * @memberof CaseCreateRequest
     */
    'data': ModelsCaseDataApiModelsCaseCreateRequestData;
    /**
     * 
     * @type {Array<CaseCreateRequestIncludedInner>}
     * @memberof CaseCreateRequest
     */
    'included': Array<CaseCreateRequestIncludedInner>;
}
/**
 * 
 * @export
 * @interface CaseCreateRequestIncludedInner
 */
export interface CaseCreateRequestIncludedInner {
    /**
     * 
     * @type {string}
     * @memberof CaseCreateRequestIncludedInner
     */
    'type': CaseCreateRequestIncludedInnerTypeEnum;
    /**
     * 
     * @type {FileCategoriesResourceAttributes}
     * @memberof CaseCreateRequestIncludedInner
     */
    'attributes': FileCategoriesResourceAttributes;
    /**
     * 
     * @type {string}
     * @memberof CaseCreateRequestIncludedInner
     */
    'id'?: string;
}

export const CaseCreateRequestIncludedInnerTypeEnum = {
    ADDITIONAL_INPUTS: 'additional_inputs',
    CASE_PROPERTIES: 'case_properties',
    FILE_CATEGORIES: 'file_categories'
} as const;

export type CaseCreateRequestIncludedInnerTypeEnum = typeof CaseCreateRequestIncludedInnerTypeEnum[keyof typeof CaseCreateRequestIncludedInnerTypeEnum];

/**
 * 
 * @export
 * @interface CaseCreateRequestRelationships
 */
export interface CaseCreateRequestRelationships {
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof CaseCreateRequestRelationships
     */
    'queue': JsonApiRelationship;
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof CaseCreateRequestRelationships
     */
    'template': JsonApiRelationship;
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof CaseCreateRequestRelationships
     */
    'template_version': JsonApiRelationship;
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof CaseCreateRequestRelationships
     */
    'additional_inputs': JsonApiRelationship;
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof CaseCreateRequestRelationships
     */
    'case_properties': JsonApiRelationship;
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof CaseCreateRequestRelationships
     */
    'file_categories'?: JsonApiRelationship | null;
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof CaseCreateRequestRelationships
     */
    'assignee'?: JsonApiRelationship | null;
}
/**
 * Data for case creation events.
 * @export
 * @interface CaseCreatedEventData
 */
export interface CaseCreatedEventData {
    /**
     * 
     * @type {string}
     * @memberof CaseCreatedEventData
     */
    'event_type'?: CaseCreatedEventDataEventTypeEnum;
    /**
     * Initial case properties
     * @type {{ [key: string]: UpdatedPropertiesValue; }}
     * @memberof CaseCreatedEventData
     */
    'case_properties': { [key: string]: UpdatedPropertiesValue; };
    /**
     * Template used for case creation
     * @type {string}
     * @memberof CaseCreatedEventData
     */
    'template_id': string;
    /**
     * Version of template used
     * @type {string}
     * @memberof CaseCreatedEventData
     */
    'template_version_id': string;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof CaseCreatedEventData
     */
    'files'?: { [key: string]: Array<string>; } | null;
    /**
     * Queue ID where the case was created
     * @type {string}
     * @memberof CaseCreatedEventData
     */
    'queue_id': string;
}

export const CaseCreatedEventDataEventTypeEnum = {
    CASE_CREATED: 'case_created'
} as const;

export type CaseCreatedEventDataEventTypeEnum = typeof CaseCreatedEventDataEventTypeEnum[keyof typeof CaseCreatedEventDataEventTypeEnum];

/**
 * Data for flow initiation events.
 * @export
 * @interface CaseCreationFlowInitiatedEventData
 */
export interface CaseCreationFlowInitiatedEventData {
    /**
     * 
     * @type {string}
     * @memberof CaseCreationFlowInitiatedEventData
     */
    'event_type'?: CaseCreationFlowInitiatedEventDataEventTypeEnum;
    /**
     * Decision ID of the flow initiation
     * @type {string}
     * @memberof CaseCreationFlowInitiatedEventData
     */
    'decision_id': string;
    /**
     * Running action ID of the flow initiation
     * @type {string}
     * @memberof CaseCreationFlowInitiatedEventData
     */
    'running_action_id': string;
    /**
     * Whether the flow was retried
     * @type {boolean}
     * @memberof CaseCreationFlowInitiatedEventData
     */
    'retry': boolean;
    /**
     * 
     * @type {string}
     * @memberof CaseCreationFlowInitiatedEventData
     */
    'retried_by'?: string | null;
    /**
     * Slug of the decision flow that was triggered
     * @type {string}
     * @memberof CaseCreationFlowInitiatedEventData
     */
    'case_creation_flow_slug': string;
    /**
     * Version name of the decision flow
     * @type {string}
     * @memberof CaseCreationFlowInitiatedEventData
     */
    'case_creation_flow_version_name': string;
}

export const CaseCreationFlowInitiatedEventDataEventTypeEnum = {
    CASE_CREATION_FLOW_INITIATED: 'case_creation_flow_initiated'
} as const;

export type CaseCreationFlowInitiatedEventDataEventTypeEnum = typeof CaseCreationFlowInitiatedEventDataEventTypeEnum[keyof typeof CaseCreationFlowInitiatedEventDataEventTypeEnum];

/**
 * Attributes for case details case blocks - only contains kind.
 * @export
 * @interface CaseDetailsCaseBlockAttributes
 */
export interface CaseDetailsCaseBlockAttributes {
    /**
     * 
     * @type {string}
     * @memberof CaseDetailsCaseBlockAttributes
     */
    'kind'?: CaseDetailsCaseBlockAttributesKindEnum;
}

export const CaseDetailsCaseBlockAttributesKindEnum = {
    CASE_DETAILS: 'case_details'
} as const;

export type CaseDetailsCaseBlockAttributesKindEnum = typeof CaseDetailsCaseBlockAttributesKindEnum[keyof typeof CaseDetailsCaseBlockAttributesKindEnum];

/**
 * Configuration attributes for case details case blocks.
 * @export
 * @interface CaseDetailsCaseBlockConfigAttributes
 */
export interface CaseDetailsCaseBlockConfigAttributes {
    /**
     * 
     * @type {string}
     * @memberof CaseDetailsCaseBlockConfigAttributes
     */
    'case_id': string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CaseEnvironment = {
    SANDBOX: 'sandbox',
    LIVE: 'live'
} as const;

export type CaseEnvironment = typeof CaseEnvironment[keyof typeof CaseEnvironment];


/**
 * 
 * @export
 * @interface CaseFileCategoriesResource
 */
export interface CaseFileCategoriesResource {
    /**
     * 
     * @type {string}
     * @memberof CaseFileCategoriesResource
     */
    'type'?: CaseFileCategoriesResourceTypeEnum;
    /**
     * 
     * @type {FileCategoriesResourceAttributes}
     * @memberof CaseFileCategoriesResource
     */
    'attributes': FileCategoriesResourceAttributes;
}

export const CaseFileCategoriesResourceTypeEnum = {
    FILE_CATEGORIES: 'file_categories'
} as const;

export type CaseFileCategoriesResourceTypeEnum = typeof CaseFileCategoriesResourceTypeEnum[keyof typeof CaseFileCategoriesResourceTypeEnum];

/**
 * Attributes for case hints resource.
 * @export
 * @interface CaseHintsAttributes
 */
export interface CaseHintsAttributes {
    /**
     * 
     * @type {{ [key: string]: { [key: string]: { [key: string]: ActionTriggeredEventDataActionFormDataValue; }; }; }}
     * @memberof CaseHintsAttributes
     */
    'action_form_hints': { [key: string]: { [key: string]: { [key: string]: ActionTriggeredEventDataActionFormDataValue; }; }; };
    /**
     * 
     * @type {{ [key: string]: { [key: string]: { [key: string]: ActionTriggeredEventDataActionFormDataValue; }; }; }}
     * @memberof CaseHintsAttributes
     */
    'task_form_hints': { [key: string]: { [key: string]: { [key: string]: ActionTriggeredEventDataActionFormDataValue; }; }; };
}
/**
 * Response model for case hints.
 * @export
 * @interface CaseHintsResponse
 */
export interface CaseHintsResponse {
    /**
     * 
     * @type {JsonApiResourceObjectCaseHintsAttributesBaseModel}
     * @memberof CaseHintsResponse
     */
    'data': JsonApiResourceObjectCaseHintsAttributesBaseModel;
    /**
     * 
     * @type {object}
     * @memberof CaseHintsResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof CaseHintsResponse
     */
    'links': JsonApiSuccessResponseLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectBaseModelBaseModel>}
     * @memberof CaseHintsResponse
     */
    'included'?: Array<JsonApiResourceObjectBaseModelBaseModel> | null;
}
/**
 * Attributes for case history events in JSON:API responses.
 * @export
 * @interface CaseHistoryEventAttributes
 */
export interface CaseHistoryEventAttributes {
    /**
     * Type of the history event
     * @type {string}
     * @memberof CaseHistoryEventAttributes
     */
    'event_type': string;
    /**
     * When the event occurred
     * @type {string}
     * @memberof CaseHistoryEventAttributes
     */
    'timestamp': string;
    /**
     * 
     * @type {string}
     * @memberof CaseHistoryEventAttributes
     */
    'user_id'?: string | null;
    /**
     * 
     * @type {EventData}
     * @memberof CaseHistoryEventAttributes
     */
    'event_data': EventData;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CaseHistoryEventAttributes
     */
    'metadata'?: { [key: string]: string; } | null;
}
/**
 * Meta information for case history events response.
 * @export
 * @interface CaseHistoryEventsMeta
 */
export interface CaseHistoryEventsMeta {
    /**
     * 
     * @type {object}
     * @memberof CaseHistoryEventsMeta
     */
    'page': object;
}
/**
 * Response model for paginated case history events.
 * @export
 * @interface CaseHistoryEventsResponse
 */
export interface CaseHistoryEventsResponse {
    /**
     * 
     * @type {Array<JsonApiResourceObjectCaseHistoryEventAttributesBaseModel>}
     * @memberof CaseHistoryEventsResponse
     */
    'data': Array<JsonApiResourceObjectCaseHistoryEventAttributesBaseModel>;
    /**
     * 
     * @type {CaseHistoryEventsMeta}
     * @memberof CaseHistoryEventsResponse
     */
    'meta'?: CaseHistoryEventsMeta | null;
    /**
     * 
     * @type {JsonApiSuccessPaginationLinks}
     * @memberof CaseHistoryEventsResponse
     */
    'links': JsonApiSuccessPaginationLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectBaseModelBaseModel>}
     * @memberof CaseHistoryEventsResponse
     */
    'included'?: Array<JsonApiResourceObjectBaseModelBaseModel> | null;
}
/**
 * 
 * @export
 * @interface CaseListAttributes
 */
export interface CaseListAttributes {
    /**
     * 
     * @type {string}
     * @memberof CaseListAttributes
     */
    'env': string;
    /**
     * 
     * @type {string}
     * @memberof CaseListAttributes
     */
    'etag': string;
    /**
     * 
     * @type {string}
     * @memberof CaseListAttributes
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof CaseListAttributes
     */
    'updated_at': string;
    /**
     * 
     * @type {number}
     * @memberof CaseListAttributes
     */
    'template_schema_version': number;
    /**
     * 
     * @type {string}
     * @memberof CaseListAttributes
     */
    'template_version_etag': string;
    /**
     * 
     * @type {string}
     * @memberof CaseListAttributes
     */
    'archived_at': string | null;
}
/**
 * 
 * @export
 * @interface CaseListRelationships
 */
export interface CaseListRelationships {
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof CaseListRelationships
     */
    'queue': JsonApiRelationship;
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof CaseListRelationships
     */
    'template': JsonApiRelationship;
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof CaseListRelationships
     */
    'template_version': JsonApiRelationship;
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof CaseListRelationships
     */
    'case_properties': JsonApiRelationship;
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof CaseListRelationships
     */
    'assignee': JsonApiRelationship;
}
/**
 * 
 * @export
 * @interface CasePatchRequest
 */
export interface CasePatchRequest {
    /**
     * 
     * @type {ModelsCaseDataApiModelsCasePatchRequestData}
     * @memberof CasePatchRequest
     */
    'data': ModelsCaseDataApiModelsCasePatchRequestData;
}
/**
 * 
 * @export
 * @interface CasePatchRequestRelationships
 */
export interface CasePatchRequestRelationships {
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof CasePatchRequestRelationships
     */
    'queue'?: JsonApiRelationship | null;
    /**
     * 
     * @type {JsonApiRelationship}
     * @memberof CasePatchRequestRelationships
     */
    'assignee'?: JsonApiRelationship | null;
}
/**
 * 
 * @export
 * @interface CasePatchResponse
 */
export interface CasePatchResponse {
    /**
     * 
     * @type {JsonApiResourceObjectCaseAttributesBaseModel}
     * @memberof CasePatchResponse
     */
    'data': JsonApiResourceObjectCaseAttributesBaseModel;
    /**
     * 
     * @type {object}
     * @memberof CasePatchResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof CasePatchResponse
     */
    'links': JsonApiSuccessResponseLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectUnionCasePropertiesAttributesCaseAdditionalInputsAttributesCaseActionAttributesMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskAttributesFileCategoriesAttributesRunningActionAttributesMarkdownCaseBlockAttributesEntityDetailsCaseBlockAttributesTableCaseBlockAttributesEventViewerCaseBlockAttributesCaseDetailsCaseBlockAttributesRelatedEntitiesCaseBlockAttributesRelatedCasesCaseBlockAttributesRelatedEventsCaseBlockAttributesEntityDetailsCaseBlockConfigAttributesEventViewerCaseBlockConfigAttributesRelatedEntitiesCaseBlockConfigAttributesRelatedCasesCaseBlockConfigAttributesRelatedEventsCaseBlockConfigAttributesMarkdownDataAttributesEntityDetailsExternalDataAttributesTableDataAttributesEventViewerExternalDataAttributesRelatedEntitiesExternalDataAttributesRelatedCasesExternalDataAttributesRelatedEventsExternalDataAttributesCaseDetailsDataAttributesCaseTemplateAttributesCaseTemplateVersionAttributesCaseDetailsCaseBlockConfigAttributesRelatedCasesDataAttributesBaseModel>}
     * @memberof CasePatchResponse
     */
    'included'?: Array<JsonApiResourceObjectUnionCasePropertiesAttributesCaseAdditionalInputsAttributesCaseActionAttributesMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskAttributesFileCategoriesAttributesRunningActionAttributesMarkdownCaseBlockAttributesEntityDetailsCaseBlockAttributesTableCaseBlockAttributesEventViewerCaseBlockAttributesCaseDetailsCaseBlockAttributesRelatedEntitiesCaseBlockAttributesRelatedCasesCaseBlockAttributesRelatedEventsCaseBlockAttributesEntityDetailsCaseBlockConfigAttributesEventViewerCaseBlockConfigAttributesRelatedEntitiesCaseBlockConfigAttributesRelatedCasesCaseBlockConfigAttributesRelatedEventsCaseBlockConfigAttributesMarkdownDataAttributesEntityDetailsExternalDataAttributesTableDataAttributesEventViewerExternalDataAttributesRelatedEntitiesExternalDataAttributesRelatedCasesExternalDataAttributesRelatedEventsExternalDataAttributesCaseDetailsDataAttributesCaseTemplateAttributesCaseTemplateVersionAttributesCaseDetailsCaseBlockConfigAttributesRelatedCasesDataAttributesBaseModel> | null;
}
/**
 * 
 * @export
 * @interface CasePropertiesAttributes
 */
export interface CasePropertiesAttributes {
    /**
     * 
     * @type {Status}
     * @memberof CasePropertiesAttributes
     */
    'status': Status | null;
}
/**
 * 
 * @export
 * @interface CasePropertiesPatchRequest
 */
export interface CasePropertiesPatchRequest {
    /**
     * 
     * @type {ModelsCaseDataApiModelsCasePropertiesPatchRequestData}
     * @memberof CasePropertiesPatchRequest
     */
    'data': ModelsCaseDataApiModelsCasePropertiesPatchRequestData;
}
/**
 * 
 * @export
 * @interface CasePropertiesPatchResponse
 */
export interface CasePropertiesPatchResponse {
    /**
     * 
     * @type {JsonApiResourceObjectCasePropertiesResourceAttributesBaseModel}
     * @memberof CasePropertiesPatchResponse
     */
    'data': JsonApiResourceObjectCasePropertiesResourceAttributesBaseModel;
    /**
     * 
     * @type {object}
     * @memberof CasePropertiesPatchResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof CasePropertiesPatchResponse
     */
    'links': JsonApiSuccessResponseLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectBaseModelBaseModel>}
     * @memberof CasePropertiesPatchResponse
     */
    'included'?: Array<JsonApiResourceObjectBaseModelBaseModel> | null;
}
/**
 * 
 * @export
 * @interface CasePropertiesResource
 */
export interface CasePropertiesResource {
    /**
     * 
     * @type {string}
     * @memberof CasePropertiesResource
     */
    'type': CasePropertiesResourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CasePropertiesResource
     */
    'id'?: string | null;
    /**
     * 
     * @type {{ [key: string]: UpdatedPropertiesValue; }}
     * @memberof CasePropertiesResource
     */
    'attributes': { [key: string]: UpdatedPropertiesValue; };
}

export const CasePropertiesResourceTypeEnum = {
    CASE_PROPERTIES: 'case_properties'
} as const;

export type CasePropertiesResourceTypeEnum = typeof CasePropertiesResourceTypeEnum[keyof typeof CasePropertiesResourceTypeEnum];

/**
 * Operation to update case properties data directly.
 * @export
 * @interface CasePropertiesUpdateOperation
 */
export interface CasePropertiesUpdateOperation {
    /**
     * 
     * @type {string}
     * @memberof CasePropertiesUpdateOperation
     */
    'op'?: CasePropertiesUpdateOperationOpEnum;
    /**
     * 
     * @type {CasePropertiesResource}
     * @memberof CasePropertiesUpdateOperation
     */
    'data': CasePropertiesResource;
}

export const CasePropertiesUpdateOperationOpEnum = {
    UPDATE: 'update'
} as const;

export type CasePropertiesUpdateOperationOpEnum = typeof CasePropertiesUpdateOperationOpEnum[keyof typeof CasePropertiesUpdateOperationOpEnum];

/**
 * @type CasePropertiesValue
 * @export
 */
export type CasePropertiesValue = { type: 'datetime' } & DateTimeProperty | { type: 'entity_ref' } & EntityRefProperty | { type: 'enum' } & EnumPropertyOutput | { type: 'event_ref' } & EventRefProperty | { type: 'integer' } & IntegerProperty | { type: 'number' } & NumberProperty | { type: 'string' } & StringProperty | { type: 'tags' } & TagsProperty;

/**
 * Operation to update a case\'s queue relationship.
 * @export
 * @interface CaseQueueUpdateOperation
 */
export interface CaseQueueUpdateOperation {
    /**
     * 
     * @type {string}
     * @memberof CaseQueueUpdateOperation
     */
    'op'?: CaseQueueUpdateOperationOpEnum;
    /**
     * 
     * @type {JsonApiAtomicRelationshipRef}
     * @memberof CaseQueueUpdateOperation
     */
    'ref': JsonApiAtomicRelationshipRef;
    /**
     * 
     * @type {QueueIdentifier}
     * @memberof CaseQueueUpdateOperation
     */
    'data': QueueIdentifier;
}

export const CaseQueueUpdateOperationOpEnum = {
    UPDATE: 'update'
} as const;

export type CaseQueueUpdateOperationOpEnum = typeof CaseQueueUpdateOperationOpEnum[keyof typeof CaseQueueUpdateOperationOpEnum];

/**
 * 
 * @export
 * @interface CaseResponse
 */
export interface CaseResponse {
    /**
     * 
     * @type {JsonApiResourceObjectCaseAttributesUnionBaseModelCaseActionFormMetaCaseTaskFormMeta}
     * @memberof CaseResponse
     */
    'data': JsonApiResourceObjectCaseAttributesUnionBaseModelCaseActionFormMetaCaseTaskFormMeta;
    /**
     * 
     * @type {Meta}
     * @memberof CaseResponse
     */
    'meta'?: Meta | null;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof CaseResponse
     */
    'links': JsonApiSuccessResponseLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectUnionCasePropertiesAttributesCaseAdditionalInputsAttributesCaseActionAttributesMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskAttributesFileCategoriesAttributesRunningActionAttributesMarkdownCaseBlockAttributesEntityDetailsCaseBlockAttributesTableCaseBlockAttributesEventViewerCaseBlockAttributesCaseDetailsCaseBlockAttributesRelatedEntitiesCaseBlockAttributesRelatedCasesCaseBlockAttributesRelatedEventsCaseBlockAttributesEntityDetailsCaseBlockConfigAttributesEventViewerCaseBlockConfigAttributesRelatedEntitiesCaseBlockConfigAttributesRelatedCasesCaseBlockConfigAttributesRelatedEventsCaseBlockConfigAttributesMarkdownDataAttributesEntityDetailsExternalDataAttributesTableDataAttributesEventViewerExternalDataAttributesRelatedEntitiesExternalDataAttributesRelatedCasesExternalDataAttributesRelatedEventsExternalDataAttributesCaseDetailsDataAttributesCaseTemplateAttributesCaseTemplateVersionAttributesCaseDetailsCaseBlockConfigAttributesRelatedCasesDataAttributesUnionBaseModelCaseActionFormMetaCaseTaskFormMeta>}
     * @memberof CaseResponse
     */
    'included'?: Array<JsonApiResourceObjectUnionCasePropertiesAttributesCaseAdditionalInputsAttributesCaseActionAttributesMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskAttributesFileCategoriesAttributesRunningActionAttributesMarkdownCaseBlockAttributesEntityDetailsCaseBlockAttributesTableCaseBlockAttributesEventViewerCaseBlockAttributesCaseDetailsCaseBlockAttributesRelatedEntitiesCaseBlockAttributesRelatedCasesCaseBlockAttributesRelatedEventsCaseBlockAttributesEntityDetailsCaseBlockConfigAttributesEventViewerCaseBlockConfigAttributesRelatedEntitiesCaseBlockConfigAttributesRelatedCasesCaseBlockConfigAttributesRelatedEventsCaseBlockConfigAttributesMarkdownDataAttributesEntityDetailsExternalDataAttributesTableDataAttributesEventViewerExternalDataAttributesRelatedEntitiesExternalDataAttributesRelatedCasesExternalDataAttributesRelatedEventsExternalDataAttributesCaseDetailsDataAttributesCaseTemplateAttributesCaseTemplateVersionAttributesCaseDetailsCaseBlockConfigAttributesRelatedCasesDataAttributesUnionBaseModelCaseActionFormMetaCaseTaskFormMeta> | null;
}
/**
 * Operation to run an action on a case in bulk.
 * @export
 * @interface CaseRunActionAtomicOperation
 */
export interface CaseRunActionAtomicOperation {
    /**
     * 
     * @type {string}
     * @memberof CaseRunActionAtomicOperation
     */
    'op'?: CaseRunActionAtomicOperationOpEnum;
    /**
     * 
     * @type {CaseBulkRef}
     * @memberof CaseRunActionAtomicOperation
     */
    'ref': CaseBulkRef;
    /**
     * 
     * @type {CaseRunActionMeta}
     * @memberof CaseRunActionAtomicOperation
     */
    'meta': CaseRunActionMeta;
}

export const CaseRunActionAtomicOperationOpEnum = {
    UPDATE: 'update'
} as const;

export type CaseRunActionAtomicOperationOpEnum = typeof CaseRunActionAtomicOperationOpEnum[keyof typeof CaseRunActionAtomicOperationOpEnum];

/**
 * Metadata for bulk run action operation.
 * @export
 * @interface CaseRunActionMeta
 */
export interface CaseRunActionMeta {
    /**
     * 
     * @type {string}
     * @memberof CaseRunActionMeta
     */
    'action_key': string;
    /**
     * 
     * @type {{ [key: string]: ActionTriggeredEventDataActionFormDataValue; }}
     * @memberof CaseRunActionMeta
     */
    'form_data'?: { [key: string]: ActionTriggeredEventDataActionFormDataValue; } | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CaseRunningActionStatus = {
    QUEUED: 'queued',
    SUCCESS: 'success',
    FAILED: 'failed'
} as const;

export type CaseRunningActionStatus = typeof CaseRunningActionStatus[keyof typeof CaseRunningActionStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const CaseRunningActionType = {
    CASE_CREATION: 'case_creation',
    CASE_ACTION: 'case_action'
} as const;

export type CaseRunningActionType = typeof CaseRunningActionType[keyof typeof CaseRunningActionType];


/**
 * Attributes for individual case task resources.
 * @export
 * @interface CaseTaskAttributes
 */
export interface CaseTaskAttributes {
    /**
     * 
     * @type {boolean}
     * @memberof CaseTaskAttributes
     */
    'is_completed': boolean;
}
/**
 * Request model for updating case task completion status.
 * @export
 * @interface CaseTaskCompletionPatchRequest
 */
export interface CaseTaskCompletionPatchRequest {
    /**
     * 
     * @type {ModelsCaseDataApiModelsCaseTaskCompletionPatchRequestData}
     * @memberof CaseTaskCompletionPatchRequest
     */
    'data': ModelsCaseDataApiModelsCaseTaskCompletionPatchRequestData;
}
/**
 * 
 * @export
 * @interface CaseTaskCompletionPatchResponse
 */
export interface CaseTaskCompletionPatchResponse {
    /**
     * 
     * @type {JsonApiResourceObjectCaseTaskAttributesBaseModel}
     * @memberof CaseTaskCompletionPatchResponse
     */
    'data': JsonApiResourceObjectCaseTaskAttributesBaseModel;
    /**
     * 
     * @type {object}
     * @memberof CaseTaskCompletionPatchResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof CaseTaskCompletionPatchResponse
     */
    'links': JsonApiSuccessResponseLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectBaseModelBaseModel>}
     * @memberof CaseTaskCompletionPatchResponse
     */
    'included'?: Array<JsonApiResourceObjectBaseModelBaseModel> | null;
}
/**
 * Meta data for case task form resources.
 * @export
 * @interface CaseTaskFormMeta
 */
export interface CaseTaskFormMeta {
    /**
     * 
     * @type {string}
     * @memberof CaseTaskFormMeta
     */
    'etag': string;
}
/**
 * Request model for updating case task form data.
 * @export
 * @interface CaseTaskFormPatchRequest
 */
export interface CaseTaskFormPatchRequest {
    /**
     * 
     * @type {ModelsCaseDataApiModelsCaseTaskFormPatchRequestData}
     * @memberof CaseTaskFormPatchRequest
     */
    'data': ModelsCaseDataApiModelsCaseTaskFormPatchRequestData;
}
/**
 * 
 * @export
 * @interface CaseTaskFormPatchResponse
 */
export interface CaseTaskFormPatchResponse {
    /**
     * 
     * @type {JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskFormMeta}
     * @memberof CaseTaskFormPatchResponse
     */
    'data': JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskFormMeta;
    /**
     * 
     * @type {object}
     * @memberof CaseTaskFormPatchResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof CaseTaskFormPatchResponse
     */
    'links': JsonApiSuccessResponseLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectBaseModelCaseTaskFormMeta>}
     * @memberof CaseTaskFormPatchResponse
     */
    'included'?: Array<JsonApiResourceObjectBaseModelCaseTaskFormMeta> | null;
}
/**
 * Operation to update case task form directly.
 * @export
 * @interface CaseTaskFormUpdateOperation
 */
export interface CaseTaskFormUpdateOperation {
    /**
     * 
     * @type {string}
     * @memberof CaseTaskFormUpdateOperation
     */
    'op'?: CaseTaskFormUpdateOperationOpEnum;
    /**
     * 
     * @type {ModelsCaseDataApiModelsCaseTaskFormPatchRequestData}
     * @memberof CaseTaskFormUpdateOperation
     */
    'data': ModelsCaseDataApiModelsCaseTaskFormPatchRequestData;
}

export const CaseTaskFormUpdateOperationOpEnum = {
    UPDATE: 'update'
} as const;

export type CaseTaskFormUpdateOperationOpEnum = typeof CaseTaskFormUpdateOperationOpEnum[keyof typeof CaseTaskFormUpdateOperationOpEnum];

/**
 * Request model for approving a task hint and saving form data.
 * @export
 * @interface CaseTaskHintApproveRequest
 */
export interface CaseTaskHintApproveRequest {
    /**
     * 
     * @type {ModelsCaseDataApiModelsCaseTaskHintApproveRequestData}
     * @memberof CaseTaskHintApproveRequest
     */
    'data': ModelsCaseDataApiModelsCaseTaskHintApproveRequestData;
}
/**
 * Response model for approving a task hint (returns saved form state).
 * @export
 * @interface CaseTaskHintApproveResponse
 */
export interface CaseTaskHintApproveResponse {
    /**
     * 
     * @type {JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskFormMeta}
     * @memberof CaseTaskHintApproveResponse
     */
    'data': JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskFormMeta;
    /**
     * 
     * @type {object}
     * @memberof CaseTaskHintApproveResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof CaseTaskHintApproveResponse
     */
    'links': JsonApiSuccessResponseLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectBaseModelCaseTaskFormMeta>}
     * @memberof CaseTaskHintApproveResponse
     */
    'included'?: Array<JsonApiResourceObjectBaseModelCaseTaskFormMeta> | null;
}
/**
 * Request model for patching a single task hint.
 * @export
 * @interface CaseTaskHintPatchRequest
 */
export interface CaseTaskHintPatchRequest {
    /**
     * 
     * @type {ModelsCaseDataApiModelsCaseTaskHintPatchRequestData}
     * @memberof CaseTaskHintPatchRequest
     */
    'data': ModelsCaseDataApiModelsCaseTaskHintPatchRequestData;
}
/**
 * Response model for patching a single task hint.
 * @export
 * @interface CaseTaskHintPatchResponse
 */
export interface CaseTaskHintPatchResponse {
    /**
     * 
     * @type {JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeBaseModel}
     * @memberof CaseTaskHintPatchResponse
     */
    'data': JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeBaseModel;
    /**
     * 
     * @type {object}
     * @memberof CaseTaskHintPatchResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof CaseTaskHintPatchResponse
     */
    'links': JsonApiSuccessResponseLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectBaseModelBaseModel>}
     * @memberof CaseTaskHintPatchResponse
     */
    'included'?: Array<JsonApiResourceObjectBaseModelBaseModel> | null;
}
/**
 * 
 * @export
 * @interface CaseTemplateActionFlow
 */
export interface CaseTemplateActionFlow {
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateActionFlow
     */
    'flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateActionFlow
     */
    'flow_version_id': string;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateActionFlow
     */
    'flow_slug': string;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateActionFlow
     */
    'flow_version_name': string;
}
/**
 * 
 * @export
 * @interface CaseTemplateActionInput
 */
export interface CaseTemplateActionInput {
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateActionInput
     */
    'display_name': string;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateActionInput
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateActionInput
     */
    'description': string;
    /**
     * 
     * @type {CaseTemplateActionFlow}
     * @memberof CaseTemplateActionInput
     */
    'flow'?: CaseTemplateActionFlow | null;
    /**
     * 
     * @type {CaseTemplateForm}
     * @memberof CaseTemplateActionInput
     */
    'form'?: CaseTemplateForm | null;
    /**
     * 
     * @type {number}
     * @memberof CaseTemplateActionInput
     */
    'order'?: number;
}
/**
 * 
 * @export
 * @interface CaseTemplateActionOutput
 */
export interface CaseTemplateActionOutput {
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateActionOutput
     */
    'display_name': string;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateActionOutput
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateActionOutput
     */
    'description': string;
    /**
     * 
     * @type {CaseTemplateActionFlow}
     * @memberof CaseTemplateActionOutput
     */
    'flow'?: CaseTemplateActionFlow | null;
    /**
     * 
     * @type {CaseTemplateForm}
     * @memberof CaseTemplateActionOutput
     */
    'form'?: CaseTemplateForm | null;
    /**
     * 
     * @type {number}
     * @memberof CaseTemplateActionOutput
     */
    'order'?: number;
}
/**
 * 
 * @export
 * @interface CaseTemplateActionTask
 */
export interface CaseTemplateActionTask {
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateActionTask
     */
    'task_key': string;
}
/**
 * 
 * @export
 * @interface CaseTemplateAdditionalInput
 */
export interface CaseTemplateAdditionalInput {
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateAdditionalInput
     */
    'type': CaseTemplateAdditionalInputTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateAdditionalInput
     */
    'display_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateAdditionalInput
     */
    'description'?: string | null;
}

export const CaseTemplateAdditionalInputTypeEnum = {
    ARRAY: 'array',
    OBJECT: 'object',
    STRING: 'string'
} as const;

export type CaseTemplateAdditionalInputTypeEnum = typeof CaseTemplateAdditionalInputTypeEnum[keyof typeof CaseTemplateAdditionalInputTypeEnum];

/**
 * 
 * @export
 * @interface CaseTemplateAttributes
 */
export interface CaseTemplateAttributes {
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateAttributes
     */
    'template_name': string;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateAttributes
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateAttributes
     */
    'icon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateAttributes
     */
    'etag'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateAttributes
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateAttributes
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface CaseTemplateCaseCreationFlowDetails
 */
export interface CaseTemplateCaseCreationFlowDetails {
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateCaseCreationFlowDetails
     */
    'version_name': string;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateCaseCreationFlowDetails
     */
    'flow_slug': string;
}
/**
 * 
 * @export
 * @interface CaseTemplateCreate
 */
export interface CaseTemplateCreate {
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateCreate
     */
    'template_name': string;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateCreate
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateCreate
     */
    'icon'?: string | null;
}
/**
 * 
 * @export
 * @interface CaseTemplateCreateRequest
 */
export interface CaseTemplateCreateRequest {
    /**
     * 
     * @type {ModelsCaseTemplatesApiModelsCaseTemplateCreateRequestData}
     * @memberof CaseTemplateCreateRequest
     */
    'data': ModelsCaseTemplatesApiModelsCaseTemplateCreateRequestData;
}
/**
 * 
 * @export
 * @interface CaseTemplateFileCategoryDefinition
 */
export interface CaseTemplateFileCategoryDefinition {
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateFileCategoryDefinition
     */
    'display_name': string;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateFileCategoryDefinition
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface CaseTemplateForm
 */
export interface CaseTemplateForm {
    /**
     * 
     * @type {Array<CaseTemplateFormFieldsInner>}
     * @memberof CaseTemplateForm
     */
    'fields': Array<CaseTemplateFormFieldsInner>;
}
/**
 * @type CaseTemplateFormFieldsInner
 * @export
 */
export type CaseTemplateFormFieldsInner = { type: 'date' } & FormFieldDate | { type: 'integer' } & FormFieldInteger | { type: 'multi_select' } & FormFieldMultiSelect | { type: 'number' } & FormFieldNumber | { type: 'select' } & FormFieldSelect | { type: 'text' } & FormFieldText;

/**
 * 
 * @export
 * @interface CaseTemplateJsonSchemaAttributes
 */
export interface CaseTemplateJsonSchemaAttributes {
    /**
     * 
     * @type {object}
     * @memberof CaseTemplateJsonSchemaAttributes
     */
    'case_json_schema': object;
}
/**
 * 
 * @export
 * @interface CaseTemplateJsonSchemaResponse
 */
export interface CaseTemplateJsonSchemaResponse {
    /**
     * 
     * @type {JsonApiResourceObjectCaseTemplateJsonSchemaAttributesBaseModel}
     * @memberof CaseTemplateJsonSchemaResponse
     */
    'data': JsonApiResourceObjectCaseTemplateJsonSchemaAttributesBaseModel;
    /**
     * 
     * @type {object}
     * @memberof CaseTemplateJsonSchemaResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof CaseTemplateJsonSchemaResponse
     */
    'links': JsonApiSuccessResponseLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectCaseTemplateVersionAttributesBaseModel>}
     * @memberof CaseTemplateJsonSchemaResponse
     */
    'included'?: Array<JsonApiResourceObjectCaseTemplateVersionAttributesBaseModel> | null;
}
/**
 * 
 * @export
 * @interface CaseTemplateMetadataUpdate
 */
export interface CaseTemplateMetadataUpdate {
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateMetadataUpdate
     */
    'template_name': string;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateMetadataUpdate
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateMetadataUpdate
     */
    'icon'?: string | null;
}
/**
 * 
 * @export
 * @interface CaseTemplateMetadataUpdateRequest
 */
export interface CaseTemplateMetadataUpdateRequest {
    /**
     * 
     * @type {ModelsCaseTemplatesApiModelsCaseTemplateMetadataUpdateRequestData}
     * @memberof CaseTemplateMetadataUpdateRequest
     */
    'data': ModelsCaseTemplatesApiModelsCaseTemplateMetadataUpdateRequestData;
}
/**
 * 
 * @export
 * @interface CaseTemplateResponse
 */
export interface CaseTemplateResponse {
    /**
     * 
     * @type {JsonApiResourceObjectCaseTemplateAttributesBaseModel}
     * @memberof CaseTemplateResponse
     */
    'data': JsonApiResourceObjectCaseTemplateAttributesBaseModel;
    /**
     * 
     * @type {object}
     * @memberof CaseTemplateResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof CaseTemplateResponse
     */
    'links': JsonApiSuccessResponseLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectCaseTemplateVersionAttributesBaseModel>}
     * @memberof CaseTemplateResponse
     */
    'included'?: Array<JsonApiResourceObjectCaseTemplateVersionAttributesBaseModel> | null;
}
/**
 * 
 * @export
 * @interface CaseTemplateReviewRole
 */
export interface CaseTemplateReviewRole {
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateReviewRole
     */
    'display_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateReviewRole
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface CaseTemplateTaskInput
 */
export interface CaseTemplateTaskInput {
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateTaskInput
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateTaskInput
     */
    'display_name': string;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateTaskInput
     */
    'description'?: string | null;
    /**
     * 
     * @type {CaseTemplateForm}
     * @memberof CaseTemplateTaskInput
     */
    'form'?: CaseTemplateForm | null;
    /**
     * 
     * @type {number}
     * @memberof CaseTemplateTaskInput
     */
    'order'?: number;
}
/**
 * 
 * @export
 * @interface CaseTemplateTaskOutput
 */
export interface CaseTemplateTaskOutput {
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateTaskOutput
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateTaskOutput
     */
    'display_name': string;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateTaskOutput
     */
    'description'?: string | null;
    /**
     * 
     * @type {CaseTemplateForm}
     * @memberof CaseTemplateTaskOutput
     */
    'form'?: CaseTemplateForm | null;
    /**
     * 
     * @type {number}
     * @memberof CaseTemplateTaskOutput
     */
    'order'?: number;
}
/**
 * 
 * @export
 * @interface CaseTemplateVersionAttributes
 */
export interface CaseTemplateVersionAttributes {
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateVersionAttributes
     */
    'version_name': string;
    /**
     * 
     * @type {{ [key: string]: CasePropertiesValue; }}
     * @memberof CaseTemplateVersionAttributes
     */
    'case_properties': { [key: string]: CasePropertiesValue; };
    /**
     * 
     * @type {{ [key: string]: CaseTemplateReviewRole; }}
     * @memberof CaseTemplateVersionAttributes
     */
    'review_roles': { [key: string]: CaseTemplateReviewRole; };
    /**
     * 
     * @type {{ [key: string]: CaseTemplateAdditionalInput; }}
     * @memberof CaseTemplateVersionAttributes
     */
    'additional_inputs': { [key: string]: CaseTemplateAdditionalInput; };
    /**
     * 
     * @type {{ [key: string]: CaseBlockConfigOutput; }}
     * @memberof CaseTemplateVersionAttributes
     */
    'case_blocks_configs': { [key: string]: CaseBlockConfigOutput; };
    /**
     * 
     * @type {{ [key: string]: CaseTemplateFileCategoryDefinition; }}
     * @memberof CaseTemplateVersionAttributes
     */
    'file_categories': { [key: string]: CaseTemplateFileCategoryDefinition; };
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateVersionAttributes
     */
    'etag'?: string;
    /**
     * 
     * @type {number}
     * @memberof CaseTemplateVersionAttributes
     */
    'schema_version'?: number;
    /**
     * 
     * @type {CaseTemplateVersionPublishState}
     * @memberof CaseTemplateVersionAttributes
     */
    'publish_state': CaseTemplateVersionPublishState;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateVersionAttributes
     */
    'published_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateVersionAttributes
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateVersionAttributes
     */
    'updated_at': string;
    /**
     * 
     * @type {boolean}
     * @memberof CaseTemplateVersionAttributes
     */
    'archived': boolean;
    /**
     * 
     * @type {CaseTemplateCaseCreationFlowDetails}
     * @memberof CaseTemplateVersionAttributes
     */
    'case_creation_flow_details'?: CaseTemplateCaseCreationFlowDetails | null;
    /**
     * 
     * @type {{ [key: string]: CaseTemplateActionOutput; }}
     * @memberof CaseTemplateVersionAttributes
     */
    'case_actions': { [key: string]: CaseTemplateActionOutput; };
    /**
     * 
     * @type {{ [key: string]: CaseTemplateTaskOutput; }}
     * @memberof CaseTemplateVersionAttributes
     */
    'case_tasks': { [key: string]: CaseTemplateTaskOutput; };
    /**
     * 
     * @type {{ [key: string]: CaseTemplateWorkflowRuleOutput; }}
     * @memberof CaseTemplateVersionAttributes
     */
    'workflow_rules': { [key: string]: CaseTemplateWorkflowRuleOutput; };
    /**
     * 
     * @type {CaseTemplateVersionCopilotSettings}
     * @memberof CaseTemplateVersionAttributes
     */
    'copilot_settings'?: CaseTemplateVersionCopilotSettings | null;
    /**
     * 
     * @type {CopilotReference}
     * @memberof CaseTemplateVersionAttributes
     */
    'copilot_reference'?: CopilotReference | null;
}


/**
 * 
 * @export
 * @interface CaseTemplateVersionCopilotSettings
 */
export interface CaseTemplateVersionCopilotSettings {
    /**
     * 
     * @type {boolean}
     * @memberof CaseTemplateVersionCopilotSettings
     */
    'copilot_enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateVersionCopilotSettings
     */
    'copilot_prompt': string;
    /**
     * 
     * @type {boolean}
     * @memberof CaseTemplateVersionCopilotSettings
     */
    'websearch_tool_enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateVersionCopilotSettings
     */
    'operating_mode': CaseTemplateVersionCopilotSettingsOperatingModeEnum;
}

export const CaseTemplateVersionCopilotSettingsOperatingModeEnum = {
    EAGER: 'eager',
    LAZY: 'lazy'
} as const;

export type CaseTemplateVersionCopilotSettingsOperatingModeEnum = typeof CaseTemplateVersionCopilotSettingsOperatingModeEnum[keyof typeof CaseTemplateVersionCopilotSettingsOperatingModeEnum];

/**
 * 
 * @export
 * @interface CaseTemplateVersionDuplicate
 */
export interface CaseTemplateVersionDuplicate {
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateVersionDuplicate
     */
    'new_version_name': string;
}
/**
 * 
 * @export
 * @interface CaseTemplateVersionDuplicateRequest
 */
export interface CaseTemplateVersionDuplicateRequest {
    /**
     * 
     * @type {ModelsCaseTemplatesApiModelsCaseTemplateVersionDuplicateRequestData}
     * @memberof CaseTemplateVersionDuplicateRequest
     */
    'data': ModelsCaseTemplatesApiModelsCaseTemplateVersionDuplicateRequestData;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CaseTemplateVersionPublishState = {
    DRAFT: 'draft',
    PUBLISHED: 'published'
} as const;

export type CaseTemplateVersionPublishState = typeof CaseTemplateVersionPublishState[keyof typeof CaseTemplateVersionPublishState];


/**
 * 
 * @export
 * @interface CaseTemplateVersionResponse
 */
export interface CaseTemplateVersionResponse {
    /**
     * 
     * @type {JsonApiResourceObjectCaseTemplateVersionAttributesBaseModel}
     * @memberof CaseTemplateVersionResponse
     */
    'data': JsonApiResourceObjectCaseTemplateVersionAttributesBaseModel;
    /**
     * 
     * @type {object}
     * @memberof CaseTemplateVersionResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof CaseTemplateVersionResponse
     */
    'links': JsonApiSuccessResponseLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectBaseModelBaseModel>}
     * @memberof CaseTemplateVersionResponse
     */
    'included'?: Array<JsonApiResourceObjectBaseModelBaseModel> | null;
}
/**
 * Presentation layer model for updating a case template version. This model distinguishes between fields that are not provided vs explicitly set to None.
 * @export
 * @interface CaseTemplateVersionUpdatePresentationModel
 */
export interface CaseTemplateVersionUpdatePresentationModel {
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateVersionUpdatePresentationModel
     */
    'version_name'?: string | null;
    /**
     * 
     * @type {{ [key: string]: CaseTemplateVersionUpdatePresentationModelCasePropertiesValue; }}
     * @memberof CaseTemplateVersionUpdatePresentationModel
     */
    'case_properties'?: { [key: string]: CaseTemplateVersionUpdatePresentationModelCasePropertiesValue; } | null;
    /**
     * 
     * @type {{ [key: string]: CaseTemplateReviewRole; }}
     * @memberof CaseTemplateVersionUpdatePresentationModel
     */
    'review_roles'?: { [key: string]: CaseTemplateReviewRole; } | null;
    /**
     * 
     * @type {{ [key: string]: CaseTemplateFileCategoryDefinition; }}
     * @memberof CaseTemplateVersionUpdatePresentationModel
     */
    'file_categories'?: { [key: string]: CaseTemplateFileCategoryDefinition; } | null;
    /**
     * 
     * @type {{ [key: string]: CaseBlockConfigInput; }}
     * @memberof CaseTemplateVersionUpdatePresentationModel
     */
    'case_blocks_configs'?: { [key: string]: CaseBlockConfigInput; } | null;
    /**
     * 
     * @type {CaseTemplateVersionPublishState}
     * @memberof CaseTemplateVersionUpdatePresentationModel
     */
    'publish_state'?: CaseTemplateVersionPublishState | null;
    /**
     * 
     * @type {boolean}
     * @memberof CaseTemplateVersionUpdatePresentationModel
     */
    'archived'?: boolean | null;
    /**
     * 
     * @type {CaseTemplateCaseCreationFlowDetails}
     * @memberof CaseTemplateVersionUpdatePresentationModel
     */
    'case_creation_flow_details'?: CaseTemplateCaseCreationFlowDetails | null;
    /**
     * 
     * @type {{ [key: string]: CaseTemplateActionInput; }}
     * @memberof CaseTemplateVersionUpdatePresentationModel
     */
    'case_actions'?: { [key: string]: CaseTemplateActionInput; } | null;
    /**
     * 
     * @type {{ [key: string]: CaseTemplateTaskInput; }}
     * @memberof CaseTemplateVersionUpdatePresentationModel
     */
    'case_tasks'?: { [key: string]: CaseTemplateTaskInput; } | null;
    /**
     * 
     * @type {{ [key: string]: CaseTemplateWorkflowRuleInput; }}
     * @memberof CaseTemplateVersionUpdatePresentationModel
     */
    'workflow_rules'?: { [key: string]: CaseTemplateWorkflowRuleInput; } | null;
    /**
     * 
     * @type {CaseTemplateVersionCopilotSettings}
     * @memberof CaseTemplateVersionUpdatePresentationModel
     */
    'copilot_settings'?: CaseTemplateVersionCopilotSettings | null;
}


/**
 * @type CaseTemplateVersionUpdatePresentationModelCasePropertiesValue
 * @export
 */
export type CaseTemplateVersionUpdatePresentationModelCasePropertiesValue = { type: 'datetime' } & DateTimeProperty | { type: 'entity_ref' } & EntityRefProperty | { type: 'enum' } & EnumPropertyInput | { type: 'event_ref' } & EventRefProperty | { type: 'integer' } & IntegerProperty | { type: 'number' } & NumberProperty | { type: 'string' } & StringProperty | { type: 'tags' } & TagsProperty;

/**
 * 
 * @export
 * @interface CaseTemplateVersionUpdateRequest
 */
export interface CaseTemplateVersionUpdateRequest {
    /**
     * 
     * @type {ModelsCaseTemplatesApiModelsCaseTemplateVersionUpdateRequestData}
     * @memberof CaseTemplateVersionUpdateRequest
     */
    'data': ModelsCaseTemplatesApiModelsCaseTemplateVersionUpdateRequestData;
}
/**
 * 
 * @export
 * @interface CaseTemplateWorkflowRuleAction
 */
export interface CaseTemplateWorkflowRuleAction {
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateWorkflowRuleAction
     */
    'action_key': string;
    /**
     * 
     * @type {Array<CaseTemplateWorkflowRuleActionAutomation>}
     * @memberof CaseTemplateWorkflowRuleAction
     */
    'automation': Array<CaseTemplateWorkflowRuleActionAutomation>;
    /**
     * 
     * @type {Array<CaseTemplateActionTask>}
     * @memberof CaseTemplateWorkflowRuleAction
     */
    'required_tasks_keys'?: Array<CaseTemplateActionTask> | null;
}
/**
 * 
 * @export
 * @interface CaseTemplateWorkflowRuleActionAutomation
 */
export interface CaseTemplateWorkflowRuleActionAutomation {
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateWorkflowRuleActionAutomation
     */
    'field': string;
    /**
     * 
     * @type {Value}
     * @memberof CaseTemplateWorkflowRuleActionAutomation
     */
    'value': Value;
}
/**
 * 
 * @export
 * @interface CaseTemplateWorkflowRuleInput
 */
export interface CaseTemplateWorkflowRuleInput {
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateWorkflowRuleInput
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateWorkflowRuleInput
     */
    'sub_status'?: string | null;
    /**
     * 
     * @type {Array<CaseTemplateWorkflowRuleAction>}
     * @memberof CaseTemplateWorkflowRuleInput
     */
    'actions': Array<CaseTemplateWorkflowRuleAction>;
    /**
     * 
     * @type {Array<CaseTemplateWorkflowRuleTask>}
     * @memberof CaseTemplateWorkflowRuleInput
     */
    'workflow_tasks_keys'?: Array<CaseTemplateWorkflowRuleTask> | null;
}
/**
 * 
 * @export
 * @interface CaseTemplateWorkflowRuleOutput
 */
export interface CaseTemplateWorkflowRuleOutput {
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateWorkflowRuleOutput
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateWorkflowRuleOutput
     */
    'sub_status'?: string | null;
    /**
     * 
     * @type {Array<CaseTemplateWorkflowRuleAction>}
     * @memberof CaseTemplateWorkflowRuleOutput
     */
    'actions': Array<CaseTemplateWorkflowRuleAction>;
    /**
     * 
     * @type {Array<CaseTemplateWorkflowRuleTask>}
     * @memberof CaseTemplateWorkflowRuleOutput
     */
    'workflow_tasks_keys'?: Array<CaseTemplateWorkflowRuleTask> | null;
}
/**
 * 
 * @export
 * @interface CaseTemplateWorkflowRuleTask
 */
export interface CaseTemplateWorkflowRuleTask {
    /**
     * 
     * @type {string}
     * @memberof CaseTemplateWorkflowRuleTask
     */
    'task_key': string;
    /**
     * 
     * @type {number}
     * @memberof CaseTemplateWorkflowRuleTask
     */
    'order'?: number;
}
/**
 * 
 * @export
 * @interface CaseTemplatesResponse
 */
export interface CaseTemplatesResponse {
    /**
     * 
     * @type {Array<JsonApiResourceObjectCaseTemplateAttributesBaseModel>}
     * @memberof CaseTemplatesResponse
     */
    'data': Array<JsonApiResourceObjectCaseTemplateAttributesBaseModel>;
    /**
     * 
     * @type {object}
     * @memberof CaseTemplatesResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessPaginationLinks}
     * @memberof CaseTemplatesResponse
     */
    'links': JsonApiSuccessPaginationLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectCaseTemplateVersionAttributesBaseModel>}
     * @memberof CaseTemplatesResponse
     */
    'included'?: Array<JsonApiResourceObjectCaseTemplateVersionAttributesBaseModel> | null;
}
/**
 * Data for case unassignment events.
 * @export
 * @interface CaseUnassignedEventData
 */
export interface CaseUnassignedEventData {
    /**
     * 
     * @type {string}
     * @memberof CaseUnassignedEventData
     */
    'event_type'?: CaseUnassignedEventDataEventTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseUnassignedEventData
     */
    'unassigned_by_user_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CaseUnassignedEventData
     */
    'unassigned_from_user_id'?: string | null;
}

export const CaseUnassignedEventDataEventTypeEnum = {
    CASE_UNASSIGNED: 'case_unassigned'
} as const;

export type CaseUnassignedEventDataEventTypeEnum = typeof CaseUnassignedEventDataEventTypeEnum[keyof typeof CaseUnassignedEventDataEventTypeEnum];

/**
 * Data for case update events.
 * @export
 * @interface CaseUpdatedEventData
 */
export interface CaseUpdatedEventData {
    /**
     * 
     * @type {string}
     * @memberof CaseUpdatedEventData
     */
    'event_type'?: CaseUpdatedEventDataEventTypeEnum;
    /**
     * Properties that were updated with their new values
     * @type {{ [key: string]: UpdatedPropertiesValue; }}
     * @memberof CaseUpdatedEventData
     */
    'updated_properties': { [key: string]: UpdatedPropertiesValue; };
}

export const CaseUpdatedEventDataEventTypeEnum = {
    CASE_UPDATED: 'case_updated'
} as const;

export type CaseUpdatedEventDataEventTypeEnum = typeof CaseUpdatedEventDataEventTypeEnum[keyof typeof CaseUpdatedEventDataEventTypeEnum];

/**
 * 
 * @export
 * @interface CasesResponse
 */
export interface CasesResponse {
    /**
     * 
     * @type {Array<JsonApiResourceObjectCaseListAttributesCaseListRelationships>}
     * @memberof CasesResponse
     */
    'data': Array<JsonApiResourceObjectCaseListAttributesCaseListRelationships>;
    /**
     * 
     * @type {object}
     * @memberof CasesResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessPaginationLinks}
     * @memberof CasesResponse
     */
    'links': JsonApiSuccessPaginationLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectCasePropertiesAttributesCaseListRelationships>}
     * @memberof CasesResponse
     */
    'included'?: Array<JsonApiResourceObjectCasePropertiesAttributesCaseListRelationships> | null;
}
/**
 * Data for comment events.
 * @export
 * @interface CommentAddedEventData
 */
export interface CommentAddedEventData {
    /**
     * 
     * @type {string}
     * @memberof CommentAddedEventData
     */
    'event_type'?: CommentAddedEventDataEventTypeEnum;
    /**
     * The comment text
     * @type {string}
     * @memberof CommentAddedEventData
     */
    'comment_text': string;
    /**
     * Unique identifier for the comment
     * @type {string}
     * @memberof CommentAddedEventData
     */
    'comment_id': string;
    /**
     * User who added the comment
     * @type {string}
     * @memberof CommentAddedEventData
     */
    'user_id': string;
}

export const CommentAddedEventDataEventTypeEnum = {
    COMMENT_ADDED: 'comment_added'
} as const;

export type CommentAddedEventDataEventTypeEnum = typeof CommentAddedEventDataEventTypeEnum[keyof typeof CommentAddedEventDataEventTypeEnum];

/**
 * @type Config
 * @export
 */
export type Config = { kind: 'case_details' } & DomainSchemasSchemasCaseBlocksModelsCaseDetailsBlockTemplateConfigInput | { kind: 'entity_details' } & DomainSchemasSchemasCaseBlocksModelsEntityDetailsBlockTemplateConfigInput | { kind: 'event_details' } & DomainSchemasSchemasCaseBlocksModelsEventDetailsBlockTemplateConfigInput | { kind: 'markdown' } & DomainSchemasSchemasCaseBlocksModelsMarkdownBlockTemplateConfigInput | { kind: 'related_cases' } & DomainSchemasSchemasCaseBlocksModelsRelatedCasesBlockTemplateConfigInput | { kind: 'related_entities' } & DomainSchemasSchemasCaseBlocksModelsRelatedEntitiesBlockTemplateConfigInput | { kind: 'related_events' } & DomainSchemasSchemasCaseBlocksModelsRelatedEventsBlockTemplateConfigInput | { kind: 'table' } & DomainSchemasSchemasCaseBlocksModelsTableBlockTemplateConfigInput;

/**
 * @type Config1
 * @export
 */
export type Config1 = { kind: 'case_details' } & DomainSchemasSchemasCaseBlocksModelsCaseDetailsBlockTemplateConfigOutput | { kind: 'entity_details' } & DomainSchemasSchemasCaseBlocksModelsEntityDetailsBlockTemplateConfigOutput | { kind: 'event_details' } & DomainSchemasSchemasCaseBlocksModelsEventDetailsBlockTemplateConfigOutput | { kind: 'markdown' } & DomainSchemasSchemasCaseBlocksModelsMarkdownBlockTemplateConfigOutput | { kind: 'related_cases' } & DomainSchemasSchemasCaseBlocksModelsRelatedCasesBlockTemplateConfigOutput | { kind: 'related_entities' } & DomainSchemasSchemasCaseBlocksModelsRelatedEntitiesBlockTemplateConfigOutput | { kind: 'related_events' } & DomainSchemasSchemasCaseBlocksModelsRelatedEventsBlockTemplateConfigOutput | { kind: 'table' } & DomainSchemasSchemasCaseBlocksModelsTableBlockTemplateConfigOutput;

/**
 * 
 * @export
 * @interface CopilotReference
 */
export interface CopilotReference {
    /**
     * 
     * @type {string}
     * @memberof CopilotReference
     */
    'agent_id': string;
}
/**
 * 
 * @export
 * @interface Data
 */
export interface Data {
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'type'?: DataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'id': string;
    /**
     * 
     * @type {TableDataAttributes}
     * @memberof Data
     */
    'attributes': TableDataAttributes;
}

export const DataTypeEnum = {
    CASE_BLOCK_DATA: 'case_block_data'
} as const;

export type DataTypeEnum = typeof DataTypeEnum[keyof typeof DataTypeEnum];

/**
 * 
 * @export
 * @interface Data1
 */
export interface Data1 {
    /**
     * 
     * @type {string}
     * @memberof Data1
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof Data1
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Data1
     */
    'lid'?: string;
}
/**
 * 
 * @export
 * @interface Data2
 */
export interface Data2 {
}
/**
 * 
 * @export
 * @interface Data3
 */
export interface Data3 {
}
/**
 * 
 * @export
 * @interface DateTimeProperty
 */
export interface DateTimeProperty {
    /**
     * 
     * @type {string}
     * @memberof DateTimeProperty
     */
    'display_name': string;
    /**
     * 
     * @type {boolean}
     * @memberof DateTimeProperty
     */
    'required'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DateTimeProperty
     */
    'type': DateTimePropertyTypeEnum;
}

export const DateTimePropertyTypeEnum = {
    DATETIME: 'datetime'
} as const;

export type DateTimePropertyTypeEnum = typeof DateTimePropertyTypeEnum[keyof typeof DateTimePropertyTypeEnum];

/**
 * 
 * @export
 * @interface DomainSchemasSchemasCaseBlocksModelsCaseDetailsBlockTemplateConfigInput
 */
export interface DomainSchemasSchemasCaseBlocksModelsCaseDetailsBlockTemplateConfigInput {
    /**
     * 
     * @type {string}
     * @memberof DomainSchemasSchemasCaseBlocksModelsCaseDetailsBlockTemplateConfigInput
     */
    'kind': DomainSchemasSchemasCaseBlocksModelsCaseDetailsBlockTemplateConfigInputKindEnum;
    /**
     * 
     * @type {LinkedBlockConfigAttribute}
     * @memberof DomainSchemasSchemasCaseBlocksModelsCaseDetailsBlockTemplateConfigInput
     */
    'case_id': LinkedBlockConfigAttribute;
}

export const DomainSchemasSchemasCaseBlocksModelsCaseDetailsBlockTemplateConfigInputKindEnum = {
    CASE_DETAILS: 'case_details'
} as const;

export type DomainSchemasSchemasCaseBlocksModelsCaseDetailsBlockTemplateConfigInputKindEnum = typeof DomainSchemasSchemasCaseBlocksModelsCaseDetailsBlockTemplateConfigInputKindEnum[keyof typeof DomainSchemasSchemasCaseBlocksModelsCaseDetailsBlockTemplateConfigInputKindEnum];

/**
 * 
 * @export
 * @interface DomainSchemasSchemasCaseBlocksModelsCaseDetailsBlockTemplateConfigOutput
 */
export interface DomainSchemasSchemasCaseBlocksModelsCaseDetailsBlockTemplateConfigOutput {
    /**
     * 
     * @type {string}
     * @memberof DomainSchemasSchemasCaseBlocksModelsCaseDetailsBlockTemplateConfigOutput
     */
    'kind': DomainSchemasSchemasCaseBlocksModelsCaseDetailsBlockTemplateConfigOutputKindEnum;
    /**
     * 
     * @type {LinkedBlockConfigAttribute}
     * @memberof DomainSchemasSchemasCaseBlocksModelsCaseDetailsBlockTemplateConfigOutput
     */
    'case_id': LinkedBlockConfigAttribute;
}

export const DomainSchemasSchemasCaseBlocksModelsCaseDetailsBlockTemplateConfigOutputKindEnum = {
    CASE_DETAILS: 'case_details'
} as const;

export type DomainSchemasSchemasCaseBlocksModelsCaseDetailsBlockTemplateConfigOutputKindEnum = typeof DomainSchemasSchemasCaseBlocksModelsCaseDetailsBlockTemplateConfigOutputKindEnum[keyof typeof DomainSchemasSchemasCaseBlocksModelsCaseDetailsBlockTemplateConfigOutputKindEnum];

/**
 * 
 * @export
 * @interface DomainSchemasSchemasCaseBlocksModelsEntityDetailsBlockTemplateConfigInput
 */
export interface DomainSchemasSchemasCaseBlocksModelsEntityDetailsBlockTemplateConfigInput {
    /**
     * 
     * @type {string}
     * @memberof DomainSchemasSchemasCaseBlocksModelsEntityDetailsBlockTemplateConfigInput
     */
    'kind': DomainSchemasSchemasCaseBlocksModelsEntityDetailsBlockTemplateConfigInputKindEnum;
    /**
     * 
     * @type {LinkedBlockConfigAttribute}
     * @memberof DomainSchemasSchemasCaseBlocksModelsEntityDetailsBlockTemplateConfigInput
     */
    'entity': LinkedBlockConfigAttribute;
}

export const DomainSchemasSchemasCaseBlocksModelsEntityDetailsBlockTemplateConfigInputKindEnum = {
    ENTITY_DETAILS: 'entity_details'
} as const;

export type DomainSchemasSchemasCaseBlocksModelsEntityDetailsBlockTemplateConfigInputKindEnum = typeof DomainSchemasSchemasCaseBlocksModelsEntityDetailsBlockTemplateConfigInputKindEnum[keyof typeof DomainSchemasSchemasCaseBlocksModelsEntityDetailsBlockTemplateConfigInputKindEnum];

/**
 * 
 * @export
 * @interface DomainSchemasSchemasCaseBlocksModelsEntityDetailsBlockTemplateConfigOutput
 */
export interface DomainSchemasSchemasCaseBlocksModelsEntityDetailsBlockTemplateConfigOutput {
    /**
     * 
     * @type {string}
     * @memberof DomainSchemasSchemasCaseBlocksModelsEntityDetailsBlockTemplateConfigOutput
     */
    'kind': DomainSchemasSchemasCaseBlocksModelsEntityDetailsBlockTemplateConfigOutputKindEnum;
    /**
     * 
     * @type {LinkedBlockConfigAttribute}
     * @memberof DomainSchemasSchemasCaseBlocksModelsEntityDetailsBlockTemplateConfigOutput
     */
    'entity': LinkedBlockConfigAttribute;
}

export const DomainSchemasSchemasCaseBlocksModelsEntityDetailsBlockTemplateConfigOutputKindEnum = {
    ENTITY_DETAILS: 'entity_details'
} as const;

export type DomainSchemasSchemasCaseBlocksModelsEntityDetailsBlockTemplateConfigOutputKindEnum = typeof DomainSchemasSchemasCaseBlocksModelsEntityDetailsBlockTemplateConfigOutputKindEnum[keyof typeof DomainSchemasSchemasCaseBlocksModelsEntityDetailsBlockTemplateConfigOutputKindEnum];

/**
 * 
 * @export
 * @interface DomainSchemasSchemasCaseBlocksModelsEventDetailsBlockTemplateConfigInput
 */
export interface DomainSchemasSchemasCaseBlocksModelsEventDetailsBlockTemplateConfigInput {
    /**
     * 
     * @type {string}
     * @memberof DomainSchemasSchemasCaseBlocksModelsEventDetailsBlockTemplateConfigInput
     */
    'kind': DomainSchemasSchemasCaseBlocksModelsEventDetailsBlockTemplateConfigInputKindEnum;
    /**
     * 
     * @type {LinkedBlockConfigAttribute}
     * @memberof DomainSchemasSchemasCaseBlocksModelsEventDetailsBlockTemplateConfigInput
     */
    'event': LinkedBlockConfigAttribute;
}

export const DomainSchemasSchemasCaseBlocksModelsEventDetailsBlockTemplateConfigInputKindEnum = {
    EVENT_DETAILS: 'event_details'
} as const;

export type DomainSchemasSchemasCaseBlocksModelsEventDetailsBlockTemplateConfigInputKindEnum = typeof DomainSchemasSchemasCaseBlocksModelsEventDetailsBlockTemplateConfigInputKindEnum[keyof typeof DomainSchemasSchemasCaseBlocksModelsEventDetailsBlockTemplateConfigInputKindEnum];

/**
 * 
 * @export
 * @interface DomainSchemasSchemasCaseBlocksModelsEventDetailsBlockTemplateConfigOutput
 */
export interface DomainSchemasSchemasCaseBlocksModelsEventDetailsBlockTemplateConfigOutput {
    /**
     * 
     * @type {string}
     * @memberof DomainSchemasSchemasCaseBlocksModelsEventDetailsBlockTemplateConfigOutput
     */
    'kind': DomainSchemasSchemasCaseBlocksModelsEventDetailsBlockTemplateConfigOutputKindEnum;
    /**
     * 
     * @type {LinkedBlockConfigAttribute}
     * @memberof DomainSchemasSchemasCaseBlocksModelsEventDetailsBlockTemplateConfigOutput
     */
    'event': LinkedBlockConfigAttribute;
}

export const DomainSchemasSchemasCaseBlocksModelsEventDetailsBlockTemplateConfigOutputKindEnum = {
    EVENT_DETAILS: 'event_details'
} as const;

export type DomainSchemasSchemasCaseBlocksModelsEventDetailsBlockTemplateConfigOutputKindEnum = typeof DomainSchemasSchemasCaseBlocksModelsEventDetailsBlockTemplateConfigOutputKindEnum[keyof typeof DomainSchemasSchemasCaseBlocksModelsEventDetailsBlockTemplateConfigOutputKindEnum];

/**
 * 
 * @export
 * @interface DomainSchemasSchemasCaseBlocksModelsMarkdownBlockPatchOperations
 */
export interface DomainSchemasSchemasCaseBlocksModelsMarkdownBlockPatchOperations {
    /**
     * 
     * @type {Data2}
     * @memberof DomainSchemasSchemasCaseBlocksModelsMarkdownBlockPatchOperations
     */
    'data'?: Data2 | null;
}
/**
 * 
 * @export
 * @interface DomainSchemasSchemasCaseBlocksModelsMarkdownBlockTemplateConfigInput
 */
export interface DomainSchemasSchemasCaseBlocksModelsMarkdownBlockTemplateConfigInput {
    /**
     * 
     * @type {string}
     * @memberof DomainSchemasSchemasCaseBlocksModelsMarkdownBlockTemplateConfigInput
     */
    'kind': DomainSchemasSchemasCaseBlocksModelsMarkdownBlockTemplateConfigInputKindEnum;
    /**
     * 
     * @type {LinkedBlockConfigAttribute}
     * @memberof DomainSchemasSchemasCaseBlocksModelsMarkdownBlockTemplateConfigInput
     */
    'source'?: LinkedBlockConfigAttribute | null;
}

export const DomainSchemasSchemasCaseBlocksModelsMarkdownBlockTemplateConfigInputKindEnum = {
    MARKDOWN: 'markdown'
} as const;

export type DomainSchemasSchemasCaseBlocksModelsMarkdownBlockTemplateConfigInputKindEnum = typeof DomainSchemasSchemasCaseBlocksModelsMarkdownBlockTemplateConfigInputKindEnum[keyof typeof DomainSchemasSchemasCaseBlocksModelsMarkdownBlockTemplateConfigInputKindEnum];

/**
 * 
 * @export
 * @interface DomainSchemasSchemasCaseBlocksModelsMarkdownBlockTemplateConfigOutput
 */
export interface DomainSchemasSchemasCaseBlocksModelsMarkdownBlockTemplateConfigOutput {
    /**
     * 
     * @type {string}
     * @memberof DomainSchemasSchemasCaseBlocksModelsMarkdownBlockTemplateConfigOutput
     */
    'kind': DomainSchemasSchemasCaseBlocksModelsMarkdownBlockTemplateConfigOutputKindEnum;
    /**
     * 
     * @type {LinkedBlockConfigAttribute}
     * @memberof DomainSchemasSchemasCaseBlocksModelsMarkdownBlockTemplateConfigOutput
     */
    'source'?: LinkedBlockConfigAttribute | null;
}

export const DomainSchemasSchemasCaseBlocksModelsMarkdownBlockTemplateConfigOutputKindEnum = {
    MARKDOWN: 'markdown'
} as const;

export type DomainSchemasSchemasCaseBlocksModelsMarkdownBlockTemplateConfigOutputKindEnum = typeof DomainSchemasSchemasCaseBlocksModelsMarkdownBlockTemplateConfigOutputKindEnum[keyof typeof DomainSchemasSchemasCaseBlocksModelsMarkdownBlockTemplateConfigOutputKindEnum];

/**
 * 
 * @export
 * @interface DomainSchemasSchemasCaseBlocksModelsRelatedCasesBlockTemplateConfigInput
 */
export interface DomainSchemasSchemasCaseBlocksModelsRelatedCasesBlockTemplateConfigInput {
    /**
     * 
     * @type {string}
     * @memberof DomainSchemasSchemasCaseBlocksModelsRelatedCasesBlockTemplateConfigInput
     */
    'kind': DomainSchemasSchemasCaseBlocksModelsRelatedCasesBlockTemplateConfigInputKindEnum;
    /**
     * 
     * @type {LinkedBlockConfigAttribute}
     * @memberof DomainSchemasSchemasCaseBlocksModelsRelatedCasesBlockTemplateConfigInput
     */
    'entity': LinkedBlockConfigAttribute;
}

export const DomainSchemasSchemasCaseBlocksModelsRelatedCasesBlockTemplateConfigInputKindEnum = {
    RELATED_CASES: 'related_cases'
} as const;

export type DomainSchemasSchemasCaseBlocksModelsRelatedCasesBlockTemplateConfigInputKindEnum = typeof DomainSchemasSchemasCaseBlocksModelsRelatedCasesBlockTemplateConfigInputKindEnum[keyof typeof DomainSchemasSchemasCaseBlocksModelsRelatedCasesBlockTemplateConfigInputKindEnum];

/**
 * 
 * @export
 * @interface DomainSchemasSchemasCaseBlocksModelsRelatedCasesBlockTemplateConfigOutput
 */
export interface DomainSchemasSchemasCaseBlocksModelsRelatedCasesBlockTemplateConfigOutput {
    /**
     * 
     * @type {string}
     * @memberof DomainSchemasSchemasCaseBlocksModelsRelatedCasesBlockTemplateConfigOutput
     */
    'kind': DomainSchemasSchemasCaseBlocksModelsRelatedCasesBlockTemplateConfigOutputKindEnum;
    /**
     * 
     * @type {LinkedBlockConfigAttribute}
     * @memberof DomainSchemasSchemasCaseBlocksModelsRelatedCasesBlockTemplateConfigOutput
     */
    'entity': LinkedBlockConfigAttribute;
}

export const DomainSchemasSchemasCaseBlocksModelsRelatedCasesBlockTemplateConfigOutputKindEnum = {
    RELATED_CASES: 'related_cases'
} as const;

export type DomainSchemasSchemasCaseBlocksModelsRelatedCasesBlockTemplateConfigOutputKindEnum = typeof DomainSchemasSchemasCaseBlocksModelsRelatedCasesBlockTemplateConfigOutputKindEnum[keyof typeof DomainSchemasSchemasCaseBlocksModelsRelatedCasesBlockTemplateConfigOutputKindEnum];

/**
 * 
 * @export
 * @interface DomainSchemasSchemasCaseBlocksModelsRelatedEntitiesBlockPatchOperations
 */
export interface DomainSchemasSchemasCaseBlocksModelsRelatedEntitiesBlockPatchOperations {
    /**
     * 
     * @type {PinnedEntities}
     * @memberof DomainSchemasSchemasCaseBlocksModelsRelatedEntitiesBlockPatchOperations
     */
    'pinned_entities'?: PinnedEntities;
}
/**
 * 
 * @export
 * @interface DomainSchemasSchemasCaseBlocksModelsRelatedEntitiesBlockTemplateConfigInput
 */
export interface DomainSchemasSchemasCaseBlocksModelsRelatedEntitiesBlockTemplateConfigInput {
    /**
     * 
     * @type {string}
     * @memberof DomainSchemasSchemasCaseBlocksModelsRelatedEntitiesBlockTemplateConfigInput
     */
    'kind': DomainSchemasSchemasCaseBlocksModelsRelatedEntitiesBlockTemplateConfigInputKindEnum;
    /**
     * 
     * @type {LinkedBlockConfigAttribute}
     * @memberof DomainSchemasSchemasCaseBlocksModelsRelatedEntitiesBlockTemplateConfigInput
     */
    'entity': LinkedBlockConfigAttribute;
}

export const DomainSchemasSchemasCaseBlocksModelsRelatedEntitiesBlockTemplateConfigInputKindEnum = {
    RELATED_ENTITIES: 'related_entities'
} as const;

export type DomainSchemasSchemasCaseBlocksModelsRelatedEntitiesBlockTemplateConfigInputKindEnum = typeof DomainSchemasSchemasCaseBlocksModelsRelatedEntitiesBlockTemplateConfigInputKindEnum[keyof typeof DomainSchemasSchemasCaseBlocksModelsRelatedEntitiesBlockTemplateConfigInputKindEnum];

/**
 * 
 * @export
 * @interface DomainSchemasSchemasCaseBlocksModelsRelatedEntitiesBlockTemplateConfigOutput
 */
export interface DomainSchemasSchemasCaseBlocksModelsRelatedEntitiesBlockTemplateConfigOutput {
    /**
     * 
     * @type {string}
     * @memberof DomainSchemasSchemasCaseBlocksModelsRelatedEntitiesBlockTemplateConfigOutput
     */
    'kind': DomainSchemasSchemasCaseBlocksModelsRelatedEntitiesBlockTemplateConfigOutputKindEnum;
    /**
     * 
     * @type {LinkedBlockConfigAttribute}
     * @memberof DomainSchemasSchemasCaseBlocksModelsRelatedEntitiesBlockTemplateConfigOutput
     */
    'entity': LinkedBlockConfigAttribute;
}

export const DomainSchemasSchemasCaseBlocksModelsRelatedEntitiesBlockTemplateConfigOutputKindEnum = {
    RELATED_ENTITIES: 'related_entities'
} as const;

export type DomainSchemasSchemasCaseBlocksModelsRelatedEntitiesBlockTemplateConfigOutputKindEnum = typeof DomainSchemasSchemasCaseBlocksModelsRelatedEntitiesBlockTemplateConfigOutputKindEnum[keyof typeof DomainSchemasSchemasCaseBlocksModelsRelatedEntitiesBlockTemplateConfigOutputKindEnum];

/**
 * 
 * @export
 * @interface DomainSchemasSchemasCaseBlocksModelsRelatedEventsBlockPatchOperations
 */
export interface DomainSchemasSchemasCaseBlocksModelsRelatedEventsBlockPatchOperations {
    /**
     * 
     * @type {PinnedEvents}
     * @memberof DomainSchemasSchemasCaseBlocksModelsRelatedEventsBlockPatchOperations
     */
    'pinned_events'?: PinnedEvents;
}
/**
 * 
 * @export
 * @interface DomainSchemasSchemasCaseBlocksModelsRelatedEventsBlockTemplateConfigInput
 */
export interface DomainSchemasSchemasCaseBlocksModelsRelatedEventsBlockTemplateConfigInput {
    /**
     * 
     * @type {string}
     * @memberof DomainSchemasSchemasCaseBlocksModelsRelatedEventsBlockTemplateConfigInput
     */
    'kind': DomainSchemasSchemasCaseBlocksModelsRelatedEventsBlockTemplateConfigInputKindEnum;
    /**
     * 
     * @type {LinkedBlockConfigAttribute}
     * @memberof DomainSchemasSchemasCaseBlocksModelsRelatedEventsBlockTemplateConfigInput
     */
    'entity': LinkedBlockConfigAttribute;
    /**
     * 
     * @type {Array<string>}
     * @memberof DomainSchemasSchemasCaseBlocksModelsRelatedEventsBlockTemplateConfigInput
     */
    'event_types'?: Array<string> | null;
}

export const DomainSchemasSchemasCaseBlocksModelsRelatedEventsBlockTemplateConfigInputKindEnum = {
    RELATED_EVENTS: 'related_events'
} as const;

export type DomainSchemasSchemasCaseBlocksModelsRelatedEventsBlockTemplateConfigInputKindEnum = typeof DomainSchemasSchemasCaseBlocksModelsRelatedEventsBlockTemplateConfigInputKindEnum[keyof typeof DomainSchemasSchemasCaseBlocksModelsRelatedEventsBlockTemplateConfigInputKindEnum];

/**
 * 
 * @export
 * @interface DomainSchemasSchemasCaseBlocksModelsRelatedEventsBlockTemplateConfigOutput
 */
export interface DomainSchemasSchemasCaseBlocksModelsRelatedEventsBlockTemplateConfigOutput {
    /**
     * 
     * @type {string}
     * @memberof DomainSchemasSchemasCaseBlocksModelsRelatedEventsBlockTemplateConfigOutput
     */
    'kind': DomainSchemasSchemasCaseBlocksModelsRelatedEventsBlockTemplateConfigOutputKindEnum;
    /**
     * 
     * @type {LinkedBlockConfigAttribute}
     * @memberof DomainSchemasSchemasCaseBlocksModelsRelatedEventsBlockTemplateConfigOutput
     */
    'entity': LinkedBlockConfigAttribute;
    /**
     * 
     * @type {Array<string>}
     * @memberof DomainSchemasSchemasCaseBlocksModelsRelatedEventsBlockTemplateConfigOutput
     */
    'event_types'?: Array<string> | null;
}

export const DomainSchemasSchemasCaseBlocksModelsRelatedEventsBlockTemplateConfigOutputKindEnum = {
    RELATED_EVENTS: 'related_events'
} as const;

export type DomainSchemasSchemasCaseBlocksModelsRelatedEventsBlockTemplateConfigOutputKindEnum = typeof DomainSchemasSchemasCaseBlocksModelsRelatedEventsBlockTemplateConfigOutputKindEnum[keyof typeof DomainSchemasSchemasCaseBlocksModelsRelatedEventsBlockTemplateConfigOutputKindEnum];

/**
 * 
 * @export
 * @interface DomainSchemasSchemasCaseBlocksModelsTableBlockPatchOperations
 */
export interface DomainSchemasSchemasCaseBlocksModelsTableBlockPatchOperations {
    /**
     * 
     * @type {Data3}
     * @memberof DomainSchemasSchemasCaseBlocksModelsTableBlockPatchOperations
     */
    'data'?: Data3 | null;
}
/**
 * 
 * @export
 * @interface DomainSchemasSchemasCaseBlocksModelsTableBlockTemplateConfigInput
 */
export interface DomainSchemasSchemasCaseBlocksModelsTableBlockTemplateConfigInput {
    /**
     * 
     * @type {string}
     * @memberof DomainSchemasSchemasCaseBlocksModelsTableBlockTemplateConfigInput
     */
    'kind': DomainSchemasSchemasCaseBlocksModelsTableBlockTemplateConfigInputKindEnum;
    /**
     * 
     * @type {LinkedBlockConfigAttribute}
     * @memberof DomainSchemasSchemasCaseBlocksModelsTableBlockTemplateConfigInput
     */
    'source'?: LinkedBlockConfigAttribute | null;
}

export const DomainSchemasSchemasCaseBlocksModelsTableBlockTemplateConfigInputKindEnum = {
    TABLE: 'table'
} as const;

export type DomainSchemasSchemasCaseBlocksModelsTableBlockTemplateConfigInputKindEnum = typeof DomainSchemasSchemasCaseBlocksModelsTableBlockTemplateConfigInputKindEnum[keyof typeof DomainSchemasSchemasCaseBlocksModelsTableBlockTemplateConfigInputKindEnum];

/**
 * 
 * @export
 * @interface DomainSchemasSchemasCaseBlocksModelsTableBlockTemplateConfigOutput
 */
export interface DomainSchemasSchemasCaseBlocksModelsTableBlockTemplateConfigOutput {
    /**
     * 
     * @type {string}
     * @memberof DomainSchemasSchemasCaseBlocksModelsTableBlockTemplateConfigOutput
     */
    'kind': DomainSchemasSchemasCaseBlocksModelsTableBlockTemplateConfigOutputKindEnum;
    /**
     * 
     * @type {LinkedBlockConfigAttribute}
     * @memberof DomainSchemasSchemasCaseBlocksModelsTableBlockTemplateConfigOutput
     */
    'source'?: LinkedBlockConfigAttribute | null;
}

export const DomainSchemasSchemasCaseBlocksModelsTableBlockTemplateConfigOutputKindEnum = {
    TABLE: 'table'
} as const;

export type DomainSchemasSchemasCaseBlocksModelsTableBlockTemplateConfigOutputKindEnum = typeof DomainSchemasSchemasCaseBlocksModelsTableBlockTemplateConfigOutputKindEnum[keyof typeof DomainSchemasSchemasCaseBlocksModelsTableBlockTemplateConfigOutputKindEnum];

/**
 * Attributes for entity details case blocks - only contains kind.
 * @export
 * @interface EntityDetailsCaseBlockAttributes
 */
export interface EntityDetailsCaseBlockAttributes {
    /**
     * 
     * @type {string}
     * @memberof EntityDetailsCaseBlockAttributes
     */
    'kind'?: EntityDetailsCaseBlockAttributesKindEnum;
}

export const EntityDetailsCaseBlockAttributesKindEnum = {
    ENTITY_DETAILS: 'entity_details'
} as const;

export type EntityDetailsCaseBlockAttributesKindEnum = typeof EntityDetailsCaseBlockAttributesKindEnum[keyof typeof EntityDetailsCaseBlockAttributesKindEnum];

/**
 * Configuration attributes for entity details case blocks.
 * @export
 * @interface EntityDetailsCaseBlockConfigAttributes
 */
export interface EntityDetailsCaseBlockConfigAttributes {
    /**
     * 
     * @type {EntityObject}
     * @memberof EntityDetailsCaseBlockConfigAttributes
     */
    'entity': EntityObject;
}
/**
 * Entity object with ID and type properties.
 * @export
 * @interface EntityObject
 */
export interface EntityObject {
    /**
     * 
     * @type {string}
     * @memberof EntityObject
     */
    'id': string | null;
    /**
     * Entity type (not nullable)
     * @type {string}
     * @memberof EntityObject
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface EntityRefProperty
 */
export interface EntityRefProperty {
    /**
     * 
     * @type {string}
     * @memberof EntityRefProperty
     */
    'display_name': string;
    /**
     * 
     * @type {boolean}
     * @memberof EntityRefProperty
     */
    'required'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EntityRefProperty
     */
    'type': EntityRefPropertyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EntityRefProperty
     */
    'entity_type': string;
}

export const EntityRefPropertyTypeEnum = {
    ENTITY_REF: 'entity_ref'
} as const;

export type EntityRefPropertyTypeEnum = typeof EntityRefPropertyTypeEnum[keyof typeof EntityRefPropertyTypeEnum];

/**
 * 
 * @export
 * @interface EnumPropertyInput
 */
export interface EnumPropertyInput {
    /**
     * 
     * @type {string}
     * @memberof EnumPropertyInput
     */
    'display_name': string;
    /**
     * 
     * @type {boolean}
     * @memberof EnumPropertyInput
     */
    'required'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EnumPropertyInput
     */
    'type': EnumPropertyInputTypeEnum;
    /**
     * 
     * @type {Array<EnumValue>}
     * @memberof EnumPropertyInput
     */
    'values': Array<EnumValue>;
}

export const EnumPropertyInputTypeEnum = {
    ENUM: 'enum'
} as const;

export type EnumPropertyInputTypeEnum = typeof EnumPropertyInputTypeEnum[keyof typeof EnumPropertyInputTypeEnum];

/**
 * 
 * @export
 * @interface EnumPropertyOutput
 */
export interface EnumPropertyOutput {
    /**
     * 
     * @type {string}
     * @memberof EnumPropertyOutput
     */
    'display_name': string;
    /**
     * 
     * @type {boolean}
     * @memberof EnumPropertyOutput
     */
    'required'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EnumPropertyOutput
     */
    'type': EnumPropertyOutputTypeEnum;
    /**
     * 
     * @type {Array<EnumValue>}
     * @memberof EnumPropertyOutput
     */
    'values': Array<EnumValue>;
}

export const EnumPropertyOutputTypeEnum = {
    ENUM: 'enum'
} as const;

export type EnumPropertyOutputTypeEnum = typeof EnumPropertyOutputTypeEnum[keyof typeof EnumPropertyOutputTypeEnum];

/**
 * 
 * @export
 * @interface EnumValue
 */
export interface EnumValue {
    /**
     * 
     * @type {string}
     * @memberof EnumValue
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof EnumValue
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnumValue
     */
    'display_name'?: string | null;
    /**
     * 
     * @type {Array<PredefinedValue>}
     * @memberof EnumValue
     */
    'sub_values'?: Array<PredefinedValue> | null;
}
/**
 * @type EventData
 * Event-specific data
 * @export
 */
export type EventData = { event_type: 'action_completed' } & ActionCompletedEventData | { event_type: 'action_failed' } & ActionFailedEventData | { event_type: 'action_triggered' } & ActionTriggeredEventData | { event_type: 'case_assigned' } & CaseAssignedEventData | { event_type: 'case_created' } & CaseCreatedEventData | { event_type: 'case_creation_flow_initiated' } & CaseCreationFlowInitiatedEventData | { event_type: 'case_unassigned' } & CaseUnassignedEventData | { event_type: 'case_updated' } & CaseUpdatedEventData | { event_type: 'comment_added' } & CommentAddedEventData | { event_type: 'file_categories_updated' } & FileCategoriesUpdatedEventData | { event_type: 'pinned_entities_updated' } & PinnedEntitiesUpdatedEventData | { event_type: 'pinned_events_updated' } & PinnedEventsUpdatedEventData | { event_type: 'task_completed' } & TaskCompletedEventData | { event_type: 'task_uncompleted' } & TaskUncompletedEventData;

/**
 * Event object with ID and type properties.
 * @export
 * @interface EventObject
 */
export interface EventObject {
    /**
     * 
     * @type {string}
     * @memberof EventObject
     */
    'id': string | null;
    /**
     * Event type (not nullable)
     * @type {string}
     * @memberof EventObject
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface EventRefProperty
 */
export interface EventRefProperty {
    /**
     * 
     * @type {string}
     * @memberof EventRefProperty
     */
    'display_name': string;
    /**
     * 
     * @type {boolean}
     * @memberof EventRefProperty
     */
    'required'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EventRefProperty
     */
    'type': EventRefPropertyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EventRefProperty
     */
    'event_type': string;
}

export const EventRefPropertyTypeEnum = {
    EVENT_REF: 'event_ref'
} as const;

export type EventRefPropertyTypeEnum = typeof EventRefPropertyTypeEnum[keyof typeof EventRefPropertyTypeEnum];

/**
 * Attributes for event viewer case blocks - only contains kind.
 * @export
 * @interface EventViewerCaseBlockAttributes
 */
export interface EventViewerCaseBlockAttributes {
    /**
     * 
     * @type {string}
     * @memberof EventViewerCaseBlockAttributes
     */
    'kind'?: EventViewerCaseBlockAttributesKindEnum;
}

export const EventViewerCaseBlockAttributesKindEnum = {
    EVENT_DETAILS: 'event_details'
} as const;

export type EventViewerCaseBlockAttributesKindEnum = typeof EventViewerCaseBlockAttributesKindEnum[keyof typeof EventViewerCaseBlockAttributesKindEnum];

/**
 * Configuration attributes for event viewer case blocks.
 * @export
 * @interface EventViewerCaseBlockConfigAttributes
 */
export interface EventViewerCaseBlockConfigAttributes {
    /**
     * 
     * @type {EventObject}
     * @memberof EventViewerCaseBlockConfigAttributes
     */
    'event': EventObject;
}
/**
 * 
 * @export
 * @interface FileCategoriesAtomicOperation
 */
export interface FileCategoriesAtomicOperation {
    /**
     * 
     * @type {string}
     * @memberof FileCategoriesAtomicOperation
     */
    'op'?: FileCategoriesAtomicOperationOpEnum;
    /**
     * 
     * @type {FileCategoriesAtomicResourceObject}
     * @memberof FileCategoriesAtomicOperation
     */
    'data': FileCategoriesAtomicResourceObject;
}

export const FileCategoriesAtomicOperationOpEnum = {
    UPDATE: 'update'
} as const;

export type FileCategoriesAtomicOperationOpEnum = typeof FileCategoriesAtomicOperationOpEnum[keyof typeof FileCategoriesAtomicOperationOpEnum];

/**
 * 
 * @export
 * @interface FileCategoriesAtomicOperationsRequest
 */
export interface FileCategoriesAtomicOperationsRequest {
    /**
     * 
     * @type {Array<FileCategoriesAtomicOperation>}
     * @memberof FileCategoriesAtomicOperationsRequest
     */
    'atomic:operations': Array<FileCategoriesAtomicOperation>;
}
/**
 * Resource object for file category atomic operations.
 * @export
 * @interface FileCategoriesAtomicResourceObject
 */
export interface FileCategoriesAtomicResourceObject {
    /**
     * 
     * @type {string}
     * @memberof FileCategoriesAtomicResourceObject
     */
    'type': FileCategoriesAtomicResourceObjectTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FileCategoriesAtomicResourceObject
     */
    'id': string;
    /**
     * 
     * @type {FileCategoriesPatchAttributes}
     * @memberof FileCategoriesAtomicResourceObject
     */
    'attributes': FileCategoriesPatchAttributes;
}

export const FileCategoriesAtomicResourceObjectTypeEnum = {
    FILE_CATEGORIES: 'file_categories'
} as const;

export type FileCategoriesAtomicResourceObjectTypeEnum = typeof FileCategoriesAtomicResourceObjectTypeEnum[keyof typeof FileCategoriesAtomicResourceObjectTypeEnum];

/**
 * 
 * @export
 * @interface FileCategoriesAtomicResultsResponse
 */
export interface FileCategoriesAtomicResultsResponse {
    /**
     * 
     * @type {Array<JsonApiAtomicResult>}
     * @memberof FileCategoriesAtomicResultsResponse
     */
    'atomic:results': Array<JsonApiAtomicResult>;
}
/**
 * 
 * @export
 * @interface FileCategoriesAttributes
 */
export interface FileCategoriesAttributes {
    /**
     * 
     * @type {string}
     * @memberof FileCategoriesAttributes
     */
    'display_name': string;
    /**
     * 
     * @type {string}
     * @memberof FileCategoriesAttributes
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileCategoriesAttributes
     */
    'category_key': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FileCategoriesAttributes
     */
    'file_ids'?: Array<string>;
}
/**
 * Patch attributes for file categories - allows updating file_ids.
 * @export
 * @interface FileCategoriesPatchAttributes
 */
export interface FileCategoriesPatchAttributes {
    /**
     * 
     * @type {Array<string>}
     * @memberof FileCategoriesPatchAttributes
     */
    'file_ids': Array<string>;
}
/**
 * Request model for updating file category file_ids.
 * @export
 * @interface FileCategoriesPatchRequest
 */
export interface FileCategoriesPatchRequest {
    /**
     * 
     * @type {ModelsCaseDataApiModelsFileCategoriesPatchRequestData}
     * @memberof FileCategoriesPatchRequest
     */
    'data': ModelsCaseDataApiModelsFileCategoriesPatchRequestData;
}
/**
 * 
 * @export
 * @interface FileCategoriesPatchResponse
 */
export interface FileCategoriesPatchResponse {
    /**
     * 
     * @type {JsonApiResourceObjectFileCategoriesAttributesBaseModel}
     * @memberof FileCategoriesPatchResponse
     */
    'data': JsonApiResourceObjectFileCategoriesAttributesBaseModel;
    /**
     * 
     * @type {object}
     * @memberof FileCategoriesPatchResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof FileCategoriesPatchResponse
     */
    'links': JsonApiSuccessResponseLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectBaseModelBaseModel>}
     * @memberof FileCategoriesPatchResponse
     */
    'included'?: Array<JsonApiResourceObjectBaseModelBaseModel> | null;
}
/**
 * 
 * @export
 * @interface FileCategoriesResourceAttributes
 */
export interface FileCategoriesResourceAttributes {
    /**
     * 
     * @type {Array<string>}
     * @memberof FileCategoriesResourceAttributes
     */
    'file_ids': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FileCategoriesResourceAttributes
     */
    'category_key': string;
}
/**
 * Data for file categories updated events.
 * @export
 * @interface FileCategoriesUpdatedEventData
 */
export interface FileCategoriesUpdatedEventData {
    /**
     * 
     * @type {string}
     * @memberof FileCategoriesUpdatedEventData
     */
    'event_type'?: FileCategoriesUpdatedEventDataEventTypeEnum;
    /**
     * Map of category_key -> list of file_ids that were added to that category
     * @type {{ [key: string]: Array<string>; }}
     * @memberof FileCategoriesUpdatedEventData
     */
    'added_files': { [key: string]: Array<string>; };
    /**
     * Map of category_key -> list of file_ids that were removed from that category
     * @type {{ [key: string]: Array<string>; }}
     * @memberof FileCategoriesUpdatedEventData
     */
    'removed_files': { [key: string]: Array<string>; };
    /**
     * 
     * @type {string}
     * @memberof FileCategoriesUpdatedEventData
     */
    'updated_by_user_id'?: string | null;
}

export const FileCategoriesUpdatedEventDataEventTypeEnum = {
    FILE_CATEGORIES_UPDATED: 'file_categories_updated'
} as const;

export type FileCategoriesUpdatedEventDataEventTypeEnum = typeof FileCategoriesUpdatedEventDataEventTypeEnum[keyof typeof FileCategoriesUpdatedEventDataEventTypeEnum];

/**
 * 
 * @export
 * @interface FormFieldDate
 */
export interface FormFieldDate {
    /**
     * 
     * @type {string}
     * @memberof FormFieldDate
     */
    'display_name': string;
    /**
     * 
     * @type {string}
     * @memberof FormFieldDate
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof FormFieldDate
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof FormFieldDate
     */
    'required': boolean;
    /**
     * 
     * @type {string}
     * @memberof FormFieldDate
     */
    'type'?: FormFieldDateTypeEnum;
}

export const FormFieldDateTypeEnum = {
    DATE: 'date'
} as const;

export type FormFieldDateTypeEnum = typeof FormFieldDateTypeEnum[keyof typeof FormFieldDateTypeEnum];

/**
 * 
 * @export
 * @interface FormFieldInteger
 */
export interface FormFieldInteger {
    /**
     * 
     * @type {string}
     * @memberof FormFieldInteger
     */
    'display_name': string;
    /**
     * 
     * @type {string}
     * @memberof FormFieldInteger
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof FormFieldInteger
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof FormFieldInteger
     */
    'required': boolean;
    /**
     * 
     * @type {string}
     * @memberof FormFieldInteger
     */
    'type'?: FormFieldIntegerTypeEnum;
}

export const FormFieldIntegerTypeEnum = {
    INTEGER: 'integer'
} as const;

export type FormFieldIntegerTypeEnum = typeof FormFieldIntegerTypeEnum[keyof typeof FormFieldIntegerTypeEnum];

/**
 * 
 * @export
 * @interface FormFieldMultiSelect
 */
export interface FormFieldMultiSelect {
    /**
     * 
     * @type {string}
     * @memberof FormFieldMultiSelect
     */
    'display_name': string;
    /**
     * 
     * @type {string}
     * @memberof FormFieldMultiSelect
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof FormFieldMultiSelect
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof FormFieldMultiSelect
     */
    'required': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormFieldMultiSelect
     */
    'options': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FormFieldMultiSelect
     */
    'type'?: FormFieldMultiSelectTypeEnum;
}

export const FormFieldMultiSelectTypeEnum = {
    MULTI_SELECT: 'multi_select'
} as const;

export type FormFieldMultiSelectTypeEnum = typeof FormFieldMultiSelectTypeEnum[keyof typeof FormFieldMultiSelectTypeEnum];

/**
 * 
 * @export
 * @interface FormFieldNumber
 */
export interface FormFieldNumber {
    /**
     * 
     * @type {string}
     * @memberof FormFieldNumber
     */
    'display_name': string;
    /**
     * 
     * @type {string}
     * @memberof FormFieldNumber
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof FormFieldNumber
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof FormFieldNumber
     */
    'required': boolean;
    /**
     * 
     * @type {string}
     * @memberof FormFieldNumber
     */
    'type'?: FormFieldNumberTypeEnum;
}

export const FormFieldNumberTypeEnum = {
    NUMBER: 'number'
} as const;

export type FormFieldNumberTypeEnum = typeof FormFieldNumberTypeEnum[keyof typeof FormFieldNumberTypeEnum];

/**
 * 
 * @export
 * @interface FormFieldSelect
 */
export interface FormFieldSelect {
    /**
     * 
     * @type {string}
     * @memberof FormFieldSelect
     */
    'display_name': string;
    /**
     * 
     * @type {string}
     * @memberof FormFieldSelect
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof FormFieldSelect
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof FormFieldSelect
     */
    'required': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormFieldSelect
     */
    'options': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FormFieldSelect
     */
    'type'?: FormFieldSelectTypeEnum;
}

export const FormFieldSelectTypeEnum = {
    SELECT: 'select'
} as const;

export type FormFieldSelectTypeEnum = typeof FormFieldSelectTypeEnum[keyof typeof FormFieldSelectTypeEnum];

/**
 * 
 * @export
 * @interface FormFieldText
 */
export interface FormFieldText {
    /**
     * 
     * @type {string}
     * @memberof FormFieldText
     */
    'display_name': string;
    /**
     * 
     * @type {string}
     * @memberof FormFieldText
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof FormFieldText
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof FormFieldText
     */
    'required': boolean;
    /**
     * 
     * @type {string}
     * @memberof FormFieldText
     */
    'type'?: FormFieldTextTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof FormFieldText
     */
    'display_as_textarea'?: boolean;
}

export const FormFieldTextTypeEnum = {
    TEXT: 'text'
} as const;

export type FormFieldTextTypeEnum = typeof FormFieldTextTypeEnum[keyof typeof FormFieldTextTypeEnum];

/**
 * Represents an update to an action or task form.
 * @export
 * @interface FormUpdate
 */
export interface FormUpdate {
    /**
     * 
     * @type {string}
     * @memberof FormUpdate
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof FormUpdate
     */
    'sub_status': string | null;
    /**
     * 
     * @type {string}
     * @memberof FormUpdate
     */
    'key': string;
    /**
     * 
     * @type {{ [key: string]: ActionTriggeredEventDataActionFormDataValue; }}
     * @memberof FormUpdate
     */
    'form_data': { [key: string]: ActionTriggeredEventDataActionFormDataValue; };
}
/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @interface Id
 */
export interface Id {
}
/**
 * 
 * @export
 * @interface IntegerProperty
 */
export interface IntegerProperty {
    /**
     * 
     * @type {string}
     * @memberof IntegerProperty
     */
    'display_name': string;
    /**
     * 
     * @type {boolean}
     * @memberof IntegerProperty
     */
    'required'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IntegerProperty
     */
    'type': IntegerPropertyTypeEnum;
}

export const IntegerPropertyTypeEnum = {
    INTEGER: 'integer'
} as const;

export type IntegerPropertyTypeEnum = typeof IntegerPropertyTypeEnum[keyof typeof IntegerPropertyTypeEnum];

/**
 * Reference to a relationship for atomic operations.
 * @export
 * @interface JsonApiAtomicRelationshipRef
 */
export interface JsonApiAtomicRelationshipRef {
    /**
     * 
     * @type {string}
     * @memberof JsonApiAtomicRelationshipRef
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiAtomicRelationshipRef
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonApiAtomicRelationshipRef
     */
    'lid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonApiAtomicRelationshipRef
     */
    'relationship': string;
}
/**
 * Result object for atomic operations supporting per-operation errors.
 * @export
 * @interface JsonApiAtomicResult
 */
export interface JsonApiAtomicResult {
    /**
     * 
     * @type {object}
     * @memberof JsonApiAtomicResult
     */
    'data'?: object | null;
    /**
     * 
     * @type {object}
     * @memberof JsonApiAtomicResult
     */
    'meta'?: object | null;
    /**
     * 
     * @type {Array<JsonApiError>}
     * @memberof JsonApiAtomicResult
     */
    'errors'?: Array<JsonApiError> | null;
}
/**
 * Represents an error object in JSON:API format.
 * @export
 * @interface JsonApiError
 */
export interface JsonApiError {
    /**
     * 
     * @type {string}
     * @memberof JsonApiError
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonApiError
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiError
     */
    'title': string;
    /**
     * 
     * @type {any}
     * @memberof JsonApiError
     */
    'detail': any;
    /**
     * 
     * @type {JsonApiErrorSource}
     * @memberof JsonApiError
     */
    'source'?: JsonApiErrorSource | null;
}
/**
 * An object containing references to the source of the error.
 * @export
 * @interface JsonApiErrorSource
 */
export interface JsonApiErrorSource {
    /**
     * 
     * @type {string}
     * @memberof JsonApiErrorSource
     */
    'pointer'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonApiErrorSource
     */
    'parameter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonApiErrorSource
     */
    'header'?: string | null;
}
/**
 * Resource identifier object
 * @export
 * @interface JsonApiIdentifier
 */
export interface JsonApiIdentifier {
    /**
     * 
     * @type {string}
     * @memberof JsonApiIdentifier
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiIdentifier
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonApiIdentifier
     */
    'lid'?: string | null;
}
/**
 * A relationship object.
 * @export
 * @interface JsonApiRelationship
 */
export interface JsonApiRelationship {
    /**
     * 
     * @type {Data1}
     * @memberof JsonApiRelationship
     */
    'data'?: Data1 | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectBaseModelBaseModel
 */
export interface JsonApiResourceObjectBaseModelBaseModel {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectBaseModelBaseModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectBaseModelBaseModel
     */
    'id': string;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectBaseModelBaseModel
     */
    'attributes': object;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectBaseModelBaseModel
     */
    'meta'?: object;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectBaseModelBaseModel
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectBaseModelCaseActionFormMeta
 */
export interface JsonApiResourceObjectBaseModelCaseActionFormMeta {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectBaseModelCaseActionFormMeta
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectBaseModelCaseActionFormMeta
     */
    'id': string;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectBaseModelCaseActionFormMeta
     */
    'attributes': object;
    /**
     * 
     * @type {CaseActionFormMeta}
     * @memberof JsonApiResourceObjectBaseModelCaseActionFormMeta
     */
    'meta'?: CaseActionFormMeta | null;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectBaseModelCaseActionFormMeta
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectBaseModelCaseTaskFormMeta
 */
export interface JsonApiResourceObjectBaseModelCaseTaskFormMeta {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectBaseModelCaseTaskFormMeta
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectBaseModelCaseTaskFormMeta
     */
    'id': string;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectBaseModelCaseTaskFormMeta
     */
    'attributes': object;
    /**
     * 
     * @type {CaseTaskFormMeta}
     * @memberof JsonApiResourceObjectBaseModelCaseTaskFormMeta
     */
    'meta'?: CaseTaskFormMeta | null;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectBaseModelCaseTaskFormMeta
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectCaseAttributesBaseModel
 */
export interface JsonApiResourceObjectCaseAttributesBaseModel {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCaseAttributesBaseModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCaseAttributesBaseModel
     */
    'id': string;
    /**
     * 
     * @type {CaseAttributes}
     * @memberof JsonApiResourceObjectCaseAttributesBaseModel
     */
    'attributes': CaseAttributes;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectCaseAttributesBaseModel
     */
    'meta'?: object;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectCaseAttributesBaseModel
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectCaseAttributesUnionBaseModelCaseActionFormMetaCaseTaskFormMeta
 */
export interface JsonApiResourceObjectCaseAttributesUnionBaseModelCaseActionFormMetaCaseTaskFormMeta {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCaseAttributesUnionBaseModelCaseActionFormMetaCaseTaskFormMeta
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCaseAttributesUnionBaseModelCaseActionFormMetaCaseTaskFormMeta
     */
    'id': string;
    /**
     * 
     * @type {CaseAttributes}
     * @memberof JsonApiResourceObjectCaseAttributesUnionBaseModelCaseActionFormMetaCaseTaskFormMeta
     */
    'attributes': CaseAttributes;
    /**
     * 
     * @type {Meta}
     * @memberof JsonApiResourceObjectCaseAttributesUnionBaseModelCaseActionFormMetaCaseTaskFormMeta
     */
    'meta'?: Meta | null;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectCaseAttributesUnionBaseModelCaseActionFormMetaCaseTaskFormMeta
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectCaseCommentCreateResponseAttributesBaseModel
 */
export interface JsonApiResourceObjectCaseCommentCreateResponseAttributesBaseModel {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCaseCommentCreateResponseAttributesBaseModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCaseCommentCreateResponseAttributesBaseModel
     */
    'id': string;
    /**
     * Attributes for creating a case comment.
     * @type {object}
     * @memberof JsonApiResourceObjectCaseCommentCreateResponseAttributesBaseModel
     */
    'attributes': object;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectCaseCommentCreateResponseAttributesBaseModel
     */
    'meta'?: object;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectCaseCommentCreateResponseAttributesBaseModel
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectCaseHintsAttributesBaseModel
 */
export interface JsonApiResourceObjectCaseHintsAttributesBaseModel {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCaseHintsAttributesBaseModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCaseHintsAttributesBaseModel
     */
    'id': string;
    /**
     * 
     * @type {CaseHintsAttributes}
     * @memberof JsonApiResourceObjectCaseHintsAttributesBaseModel
     */
    'attributes': CaseHintsAttributes;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectCaseHintsAttributesBaseModel
     */
    'meta'?: object;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectCaseHintsAttributesBaseModel
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectCaseHistoryEventAttributesBaseModel
 */
export interface JsonApiResourceObjectCaseHistoryEventAttributesBaseModel {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCaseHistoryEventAttributesBaseModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCaseHistoryEventAttributesBaseModel
     */
    'id': string;
    /**
     * 
     * @type {CaseHistoryEventAttributes}
     * @memberof JsonApiResourceObjectCaseHistoryEventAttributesBaseModel
     */
    'attributes': CaseHistoryEventAttributes;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectCaseHistoryEventAttributesBaseModel
     */
    'meta'?: object;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectCaseHistoryEventAttributesBaseModel
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectCaseListAttributesCaseListRelationships
 */
export interface JsonApiResourceObjectCaseListAttributesCaseListRelationships {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCaseListAttributesCaseListRelationships
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCaseListAttributesCaseListRelationships
     */
    'id': string;
    /**
     * 
     * @type {CaseListAttributes}
     * @memberof JsonApiResourceObjectCaseListAttributesCaseListRelationships
     */
    'attributes': CaseListAttributes;
    /**
     * 
     * @type {CaseListRelationships}
     * @memberof JsonApiResourceObjectCaseListAttributesCaseListRelationships
     */
    'meta'?: CaseListRelationships | null;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectCaseListAttributesCaseListRelationships
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectCasePropertiesAttributesCaseListRelationships
 */
export interface JsonApiResourceObjectCasePropertiesAttributesCaseListRelationships {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCasePropertiesAttributesCaseListRelationships
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCasePropertiesAttributesCaseListRelationships
     */
    'id': string;
    /**
     * 
     * @type {CasePropertiesAttributes}
     * @memberof JsonApiResourceObjectCasePropertiesAttributesCaseListRelationships
     */
    'attributes': CasePropertiesAttributes;
    /**
     * 
     * @type {CaseListRelationships}
     * @memberof JsonApiResourceObjectCasePropertiesAttributesCaseListRelationships
     */
    'meta'?: CaseListRelationships | null;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectCasePropertiesAttributesCaseListRelationships
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectCasePropertiesResourceAttributesBaseModel
 */
export interface JsonApiResourceObjectCasePropertiesResourceAttributesBaseModel {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCasePropertiesResourceAttributesBaseModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCasePropertiesResourceAttributesBaseModel
     */
    'id': string;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectCasePropertiesResourceAttributesBaseModel
     */
    'attributes': object;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectCasePropertiesResourceAttributesBaseModel
     */
    'meta'?: object;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectCasePropertiesResourceAttributesBaseModel
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectCaseTaskAttributesBaseModel
 */
export interface JsonApiResourceObjectCaseTaskAttributesBaseModel {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCaseTaskAttributesBaseModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCaseTaskAttributesBaseModel
     */
    'id': string;
    /**
     * 
     * @type {CaseTaskAttributes}
     * @memberof JsonApiResourceObjectCaseTaskAttributesBaseModel
     */
    'attributes': CaseTaskAttributes;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectCaseTaskAttributesBaseModel
     */
    'meta'?: object;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectCaseTaskAttributesBaseModel
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectCaseTemplateAttributesBaseModel
 */
export interface JsonApiResourceObjectCaseTemplateAttributesBaseModel {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCaseTemplateAttributesBaseModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCaseTemplateAttributesBaseModel
     */
    'id': string;
    /**
     * 
     * @type {CaseTemplateAttributes}
     * @memberof JsonApiResourceObjectCaseTemplateAttributesBaseModel
     */
    'attributes': CaseTemplateAttributes;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectCaseTemplateAttributesBaseModel
     */
    'meta'?: object;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectCaseTemplateAttributesBaseModel
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectCaseTemplateJsonSchemaAttributesBaseModel
 */
export interface JsonApiResourceObjectCaseTemplateJsonSchemaAttributesBaseModel {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCaseTemplateJsonSchemaAttributesBaseModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCaseTemplateJsonSchemaAttributesBaseModel
     */
    'id': string;
    /**
     * 
     * @type {CaseTemplateJsonSchemaAttributes}
     * @memberof JsonApiResourceObjectCaseTemplateJsonSchemaAttributesBaseModel
     */
    'attributes': CaseTemplateJsonSchemaAttributes;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectCaseTemplateJsonSchemaAttributesBaseModel
     */
    'meta'?: object;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectCaseTemplateJsonSchemaAttributesBaseModel
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectCaseTemplateVersionAttributesBaseModel
 */
export interface JsonApiResourceObjectCaseTemplateVersionAttributesBaseModel {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCaseTemplateVersionAttributesBaseModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectCaseTemplateVersionAttributesBaseModel
     */
    'id': string;
    /**
     * 
     * @type {CaseTemplateVersionAttributes}
     * @memberof JsonApiResourceObjectCaseTemplateVersionAttributesBaseModel
     */
    'attributes': CaseTemplateVersionAttributes;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectCaseTemplateVersionAttributesBaseModel
     */
    'meta'?: object;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectCaseTemplateVersionAttributesBaseModel
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectFileCategoriesAttributesBaseModel
 */
export interface JsonApiResourceObjectFileCategoriesAttributesBaseModel {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectFileCategoriesAttributesBaseModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectFileCategoriesAttributesBaseModel
     */
    'id': string;
    /**
     * 
     * @type {FileCategoriesAttributes}
     * @memberof JsonApiResourceObjectFileCategoriesAttributesBaseModel
     */
    'attributes': FileCategoriesAttributes;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectFileCategoriesAttributesBaseModel
     */
    'meta'?: object;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectFileCategoriesAttributesBaseModel
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeBaseModel
 */
export interface JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeBaseModel {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeBaseModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeBaseModel
     */
    'id': string;
    /**
     * 
     * @type {{ [key: string]: ActionTriggeredEventDataActionFormDataValue; }}
     * @memberof JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeBaseModel
     */
    'attributes': { [key: string]: ActionTriggeredEventDataActionFormDataValue; };
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeBaseModel
     */
    'meta'?: object;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeBaseModel
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseActionFormMeta
 */
export interface JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseActionFormMeta {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseActionFormMeta
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseActionFormMeta
     */
    'id': string;
    /**
     * 
     * @type {{ [key: string]: ActionTriggeredEventDataActionFormDataValue; }}
     * @memberof JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseActionFormMeta
     */
    'attributes': { [key: string]: ActionTriggeredEventDataActionFormDataValue; };
    /**
     * 
     * @type {CaseActionFormMeta}
     * @memberof JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseActionFormMeta
     */
    'meta'?: CaseActionFormMeta | null;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseActionFormMeta
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskFormMeta
 */
export interface JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskFormMeta {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskFormMeta
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskFormMeta
     */
    'id': string;
    /**
     * 
     * @type {{ [key: string]: ActionTriggeredEventDataActionFormDataValue; }}
     * @memberof JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskFormMeta
     */
    'attributes': { [key: string]: ActionTriggeredEventDataActionFormDataValue; };
    /**
     * 
     * @type {CaseTaskFormMeta}
     * @memberof JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskFormMeta
     */
    'meta'?: CaseTaskFormMeta | null;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskFormMeta
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectMarkdownDataAttributesBaseModel
 */
export interface JsonApiResourceObjectMarkdownDataAttributesBaseModel {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectMarkdownDataAttributesBaseModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectMarkdownDataAttributesBaseModel
     */
    'id': string;
    /**
     * 
     * @type {MarkdownDataAttributes}
     * @memberof JsonApiResourceObjectMarkdownDataAttributesBaseModel
     */
    'attributes': MarkdownDataAttributes;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectMarkdownDataAttributesBaseModel
     */
    'meta'?: object;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectMarkdownDataAttributesBaseModel
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectRelatedEntitiesCaseBlockConfigPatchAttributesBaseModel
 */
export interface JsonApiResourceObjectRelatedEntitiesCaseBlockConfigPatchAttributesBaseModel {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectRelatedEntitiesCaseBlockConfigPatchAttributesBaseModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectRelatedEntitiesCaseBlockConfigPatchAttributesBaseModel
     */
    'id': string;
    /**
     * 
     * @type {RelatedEntitiesCaseBlockConfigPatchAttributes}
     * @memberof JsonApiResourceObjectRelatedEntitiesCaseBlockConfigPatchAttributesBaseModel
     */
    'attributes': RelatedEntitiesCaseBlockConfigPatchAttributes;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectRelatedEntitiesCaseBlockConfigPatchAttributesBaseModel
     */
    'meta'?: object;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectRelatedEntitiesCaseBlockConfigPatchAttributesBaseModel
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectRelatedEventsCaseBlockConfigPatchAttributesBaseModel
 */
export interface JsonApiResourceObjectRelatedEventsCaseBlockConfigPatchAttributesBaseModel {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectRelatedEventsCaseBlockConfigPatchAttributesBaseModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectRelatedEventsCaseBlockConfigPatchAttributesBaseModel
     */
    'id': string;
    /**
     * 
     * @type {RelatedEventsCaseBlockConfigPatchAttributes}
     * @memberof JsonApiResourceObjectRelatedEventsCaseBlockConfigPatchAttributesBaseModel
     */
    'attributes': RelatedEventsCaseBlockConfigPatchAttributes;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectRelatedEventsCaseBlockConfigPatchAttributesBaseModel
     */
    'meta'?: object;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectRelatedEventsCaseBlockConfigPatchAttributesBaseModel
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectRunningActionAttributesBaseModel
 */
export interface JsonApiResourceObjectRunningActionAttributesBaseModel {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectRunningActionAttributesBaseModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectRunningActionAttributesBaseModel
     */
    'id': string;
    /**
     * 
     * @type {RunningActionAttributes}
     * @memberof JsonApiResourceObjectRunningActionAttributesBaseModel
     */
    'attributes': RunningActionAttributes;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectRunningActionAttributesBaseModel
     */
    'meta'?: object;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectRunningActionAttributesBaseModel
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectTableDataAttributesBaseModel
 */
export interface JsonApiResourceObjectTableDataAttributesBaseModel {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectTableDataAttributesBaseModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectTableDataAttributesBaseModel
     */
    'id': string;
    /**
     * 
     * @type {TableDataAttributes}
     * @memberof JsonApiResourceObjectTableDataAttributesBaseModel
     */
    'attributes': TableDataAttributes;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectTableDataAttributesBaseModel
     */
    'meta'?: object;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectTableDataAttributesBaseModel
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectUnionCasePropertiesAttributesCaseAdditionalInputsAttributesCaseActionAttributesMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskAttributesFileCategoriesAttributesRunningActionAttributesMarkdownCaseBlockAttributesEntityDetailsCaseBlockAttributesTableCaseBlockAttributesEventViewerCaseBlockAttributesCaseDetailsCaseBlockAttributesRelatedEntitiesCaseBlockAttributesRelatedCasesCaseBlockAttributesRelatedEventsCaseBlockAttributesEntityDetailsCaseBlockConfigAttributesEventViewerCaseBlockConfigAttributesRelatedEntitiesCaseBlockConfigAttributesRelatedCasesCaseBlockConfigAttributesRelatedEventsCaseBlockConfigAttributesMarkdownDataAttributesEntityDetailsExternalDataAttributesTableDataAttributesEventViewerExternalDataAttributesRelatedEntitiesExternalDataAttributesRelatedCasesExternalDataAttributesRelatedEventsExternalDataAttributesCaseDetailsDataAttributesCaseTemplateAttributesCaseTemplateVersionAttributesCaseDetailsCaseBlockConfigAttributesRelatedCasesDataAttributesBaseModel
 */
export interface JsonApiResourceObjectUnionCasePropertiesAttributesCaseAdditionalInputsAttributesCaseActionAttributesMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskAttributesFileCategoriesAttributesRunningActionAttributesMarkdownCaseBlockAttributesEntityDetailsCaseBlockAttributesTableCaseBlockAttributesEventViewerCaseBlockAttributesCaseDetailsCaseBlockAttributesRelatedEntitiesCaseBlockAttributesRelatedCasesCaseBlockAttributesRelatedEventsCaseBlockAttributesEntityDetailsCaseBlockConfigAttributesEventViewerCaseBlockConfigAttributesRelatedEntitiesCaseBlockConfigAttributesRelatedCasesCaseBlockConfigAttributesRelatedEventsCaseBlockConfigAttributesMarkdownDataAttributesEntityDetailsExternalDataAttributesTableDataAttributesEventViewerExternalDataAttributesRelatedEntitiesExternalDataAttributesRelatedCasesExternalDataAttributesRelatedEventsExternalDataAttributesCaseDetailsDataAttributesCaseTemplateAttributesCaseTemplateVersionAttributesCaseDetailsCaseBlockConfigAttributesRelatedCasesDataAttributesBaseModel {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectUnionCasePropertiesAttributesCaseAdditionalInputsAttributesCaseActionAttributesMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskAttributesFileCategoriesAttributesRunningActionAttributesMarkdownCaseBlockAttributesEntityDetailsCaseBlockAttributesTableCaseBlockAttributesEventViewerCaseBlockAttributesCaseDetailsCaseBlockAttributesRelatedEntitiesCaseBlockAttributesRelatedCasesCaseBlockAttributesRelatedEventsCaseBlockAttributesEntityDetailsCaseBlockConfigAttributesEventViewerCaseBlockConfigAttributesRelatedEntitiesCaseBlockConfigAttributesRelatedCasesCaseBlockConfigAttributesRelatedEventsCaseBlockConfigAttributesMarkdownDataAttributesEntityDetailsExternalDataAttributesTableDataAttributesEventViewerExternalDataAttributesRelatedEntitiesExternalDataAttributesRelatedCasesExternalDataAttributesRelatedEventsExternalDataAttributesCaseDetailsDataAttributesCaseTemplateAttributesCaseTemplateVersionAttributesCaseDetailsCaseBlockConfigAttributesRelatedCasesDataAttributesBaseModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectUnionCasePropertiesAttributesCaseAdditionalInputsAttributesCaseActionAttributesMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskAttributesFileCategoriesAttributesRunningActionAttributesMarkdownCaseBlockAttributesEntityDetailsCaseBlockAttributesTableCaseBlockAttributesEventViewerCaseBlockAttributesCaseDetailsCaseBlockAttributesRelatedEntitiesCaseBlockAttributesRelatedCasesCaseBlockAttributesRelatedEventsCaseBlockAttributesEntityDetailsCaseBlockConfigAttributesEventViewerCaseBlockConfigAttributesRelatedEntitiesCaseBlockConfigAttributesRelatedCasesCaseBlockConfigAttributesRelatedEventsCaseBlockConfigAttributesMarkdownDataAttributesEntityDetailsExternalDataAttributesTableDataAttributesEventViewerExternalDataAttributesRelatedEntitiesExternalDataAttributesRelatedCasesExternalDataAttributesRelatedEventsExternalDataAttributesCaseDetailsDataAttributesCaseTemplateAttributesCaseTemplateVersionAttributesCaseDetailsCaseBlockConfigAttributesRelatedCasesDataAttributesBaseModel
     */
    'id': string;
    /**
     * 
     * @type {Attributes1}
     * @memberof JsonApiResourceObjectUnionCasePropertiesAttributesCaseAdditionalInputsAttributesCaseActionAttributesMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskAttributesFileCategoriesAttributesRunningActionAttributesMarkdownCaseBlockAttributesEntityDetailsCaseBlockAttributesTableCaseBlockAttributesEventViewerCaseBlockAttributesCaseDetailsCaseBlockAttributesRelatedEntitiesCaseBlockAttributesRelatedCasesCaseBlockAttributesRelatedEventsCaseBlockAttributesEntityDetailsCaseBlockConfigAttributesEventViewerCaseBlockConfigAttributesRelatedEntitiesCaseBlockConfigAttributesRelatedCasesCaseBlockConfigAttributesRelatedEventsCaseBlockConfigAttributesMarkdownDataAttributesEntityDetailsExternalDataAttributesTableDataAttributesEventViewerExternalDataAttributesRelatedEntitiesExternalDataAttributesRelatedCasesExternalDataAttributesRelatedEventsExternalDataAttributesCaseDetailsDataAttributesCaseTemplateAttributesCaseTemplateVersionAttributesCaseDetailsCaseBlockConfigAttributesRelatedCasesDataAttributesBaseModel
     */
    'attributes': Attributes1;
    /**
     * 
     * @type {object}
     * @memberof JsonApiResourceObjectUnionCasePropertiesAttributesCaseAdditionalInputsAttributesCaseActionAttributesMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskAttributesFileCategoriesAttributesRunningActionAttributesMarkdownCaseBlockAttributesEntityDetailsCaseBlockAttributesTableCaseBlockAttributesEventViewerCaseBlockAttributesCaseDetailsCaseBlockAttributesRelatedEntitiesCaseBlockAttributesRelatedCasesCaseBlockAttributesRelatedEventsCaseBlockAttributesEntityDetailsCaseBlockConfigAttributesEventViewerCaseBlockConfigAttributesRelatedEntitiesCaseBlockConfigAttributesRelatedCasesCaseBlockConfigAttributesRelatedEventsCaseBlockConfigAttributesMarkdownDataAttributesEntityDetailsExternalDataAttributesTableDataAttributesEventViewerExternalDataAttributesRelatedEntitiesExternalDataAttributesRelatedCasesExternalDataAttributesRelatedEventsExternalDataAttributesCaseDetailsDataAttributesCaseTemplateAttributesCaseTemplateVersionAttributesCaseDetailsCaseBlockConfigAttributesRelatedCasesDataAttributesBaseModel
     */
    'meta'?: object;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectUnionCasePropertiesAttributesCaseAdditionalInputsAttributesCaseActionAttributesMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskAttributesFileCategoriesAttributesRunningActionAttributesMarkdownCaseBlockAttributesEntityDetailsCaseBlockAttributesTableCaseBlockAttributesEventViewerCaseBlockAttributesCaseDetailsCaseBlockAttributesRelatedEntitiesCaseBlockAttributesRelatedCasesCaseBlockAttributesRelatedEventsCaseBlockAttributesEntityDetailsCaseBlockConfigAttributesEventViewerCaseBlockConfigAttributesRelatedEntitiesCaseBlockConfigAttributesRelatedCasesCaseBlockConfigAttributesRelatedEventsCaseBlockConfigAttributesMarkdownDataAttributesEntityDetailsExternalDataAttributesTableDataAttributesEventViewerExternalDataAttributesRelatedEntitiesExternalDataAttributesRelatedCasesExternalDataAttributesRelatedEventsExternalDataAttributesCaseDetailsDataAttributesCaseTemplateAttributesCaseTemplateVersionAttributesCaseDetailsCaseBlockConfigAttributesRelatedCasesDataAttributesBaseModel
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * 
 * @export
 * @interface JsonApiResourceObjectUnionCasePropertiesAttributesCaseAdditionalInputsAttributesCaseActionAttributesMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskAttributesFileCategoriesAttributesRunningActionAttributesMarkdownCaseBlockAttributesEntityDetailsCaseBlockAttributesTableCaseBlockAttributesEventViewerCaseBlockAttributesCaseDetailsCaseBlockAttributesRelatedEntitiesCaseBlockAttributesRelatedCasesCaseBlockAttributesRelatedEventsCaseBlockAttributesEntityDetailsCaseBlockConfigAttributesEventViewerCaseBlockConfigAttributesRelatedEntitiesCaseBlockConfigAttributesRelatedCasesCaseBlockConfigAttributesRelatedEventsCaseBlockConfigAttributesMarkdownDataAttributesEntityDetailsExternalDataAttributesTableDataAttributesEventViewerExternalDataAttributesRelatedEntitiesExternalDataAttributesRelatedCasesExternalDataAttributesRelatedEventsExternalDataAttributesCaseDetailsDataAttributesCaseTemplateAttributesCaseTemplateVersionAttributesCaseDetailsCaseBlockConfigAttributesRelatedCasesDataAttributesUnionBaseModelCaseActionFormMetaCaseTaskFormMeta
 */
export interface JsonApiResourceObjectUnionCasePropertiesAttributesCaseAdditionalInputsAttributesCaseActionAttributesMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskAttributesFileCategoriesAttributesRunningActionAttributesMarkdownCaseBlockAttributesEntityDetailsCaseBlockAttributesTableCaseBlockAttributesEventViewerCaseBlockAttributesCaseDetailsCaseBlockAttributesRelatedEntitiesCaseBlockAttributesRelatedCasesCaseBlockAttributesRelatedEventsCaseBlockAttributesEntityDetailsCaseBlockConfigAttributesEventViewerCaseBlockConfigAttributesRelatedEntitiesCaseBlockConfigAttributesRelatedCasesCaseBlockConfigAttributesRelatedEventsCaseBlockConfigAttributesMarkdownDataAttributesEntityDetailsExternalDataAttributesTableDataAttributesEventViewerExternalDataAttributesRelatedEntitiesExternalDataAttributesRelatedCasesExternalDataAttributesRelatedEventsExternalDataAttributesCaseDetailsDataAttributesCaseTemplateAttributesCaseTemplateVersionAttributesCaseDetailsCaseBlockConfigAttributesRelatedCasesDataAttributesUnionBaseModelCaseActionFormMetaCaseTaskFormMeta {
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectUnionCasePropertiesAttributesCaseAdditionalInputsAttributesCaseActionAttributesMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskAttributesFileCategoriesAttributesRunningActionAttributesMarkdownCaseBlockAttributesEntityDetailsCaseBlockAttributesTableCaseBlockAttributesEventViewerCaseBlockAttributesCaseDetailsCaseBlockAttributesRelatedEntitiesCaseBlockAttributesRelatedCasesCaseBlockAttributesRelatedEventsCaseBlockAttributesEntityDetailsCaseBlockConfigAttributesEventViewerCaseBlockConfigAttributesRelatedEntitiesCaseBlockConfigAttributesRelatedCasesCaseBlockConfigAttributesRelatedEventsCaseBlockConfigAttributesMarkdownDataAttributesEntityDetailsExternalDataAttributesTableDataAttributesEventViewerExternalDataAttributesRelatedEntitiesExternalDataAttributesRelatedCasesExternalDataAttributesRelatedEventsExternalDataAttributesCaseDetailsDataAttributesCaseTemplateAttributesCaseTemplateVersionAttributesCaseDetailsCaseBlockConfigAttributesRelatedCasesDataAttributesUnionBaseModelCaseActionFormMetaCaseTaskFormMeta
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiResourceObjectUnionCasePropertiesAttributesCaseAdditionalInputsAttributesCaseActionAttributesMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskAttributesFileCategoriesAttributesRunningActionAttributesMarkdownCaseBlockAttributesEntityDetailsCaseBlockAttributesTableCaseBlockAttributesEventViewerCaseBlockAttributesCaseDetailsCaseBlockAttributesRelatedEntitiesCaseBlockAttributesRelatedCasesCaseBlockAttributesRelatedEventsCaseBlockAttributesEntityDetailsCaseBlockConfigAttributesEventViewerCaseBlockConfigAttributesRelatedEntitiesCaseBlockConfigAttributesRelatedCasesCaseBlockConfigAttributesRelatedEventsCaseBlockConfigAttributesMarkdownDataAttributesEntityDetailsExternalDataAttributesTableDataAttributesEventViewerExternalDataAttributesRelatedEntitiesExternalDataAttributesRelatedCasesExternalDataAttributesRelatedEventsExternalDataAttributesCaseDetailsDataAttributesCaseTemplateAttributesCaseTemplateVersionAttributesCaseDetailsCaseBlockConfigAttributesRelatedCasesDataAttributesUnionBaseModelCaseActionFormMetaCaseTaskFormMeta
     */
    'id': string;
    /**
     * 
     * @type {Attributes1}
     * @memberof JsonApiResourceObjectUnionCasePropertiesAttributesCaseAdditionalInputsAttributesCaseActionAttributesMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskAttributesFileCategoriesAttributesRunningActionAttributesMarkdownCaseBlockAttributesEntityDetailsCaseBlockAttributesTableCaseBlockAttributesEventViewerCaseBlockAttributesCaseDetailsCaseBlockAttributesRelatedEntitiesCaseBlockAttributesRelatedCasesCaseBlockAttributesRelatedEventsCaseBlockAttributesEntityDetailsCaseBlockConfigAttributesEventViewerCaseBlockConfigAttributesRelatedEntitiesCaseBlockConfigAttributesRelatedCasesCaseBlockConfigAttributesRelatedEventsCaseBlockConfigAttributesMarkdownDataAttributesEntityDetailsExternalDataAttributesTableDataAttributesEventViewerExternalDataAttributesRelatedEntitiesExternalDataAttributesRelatedCasesExternalDataAttributesRelatedEventsExternalDataAttributesCaseDetailsDataAttributesCaseTemplateAttributesCaseTemplateVersionAttributesCaseDetailsCaseBlockConfigAttributesRelatedCasesDataAttributesUnionBaseModelCaseActionFormMetaCaseTaskFormMeta
     */
    'attributes': Attributes1;
    /**
     * 
     * @type {Meta}
     * @memberof JsonApiResourceObjectUnionCasePropertiesAttributesCaseAdditionalInputsAttributesCaseActionAttributesMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskAttributesFileCategoriesAttributesRunningActionAttributesMarkdownCaseBlockAttributesEntityDetailsCaseBlockAttributesTableCaseBlockAttributesEventViewerCaseBlockAttributesCaseDetailsCaseBlockAttributesRelatedEntitiesCaseBlockAttributesRelatedCasesCaseBlockAttributesRelatedEventsCaseBlockAttributesEntityDetailsCaseBlockConfigAttributesEventViewerCaseBlockConfigAttributesRelatedEntitiesCaseBlockConfigAttributesRelatedCasesCaseBlockConfigAttributesRelatedEventsCaseBlockConfigAttributesMarkdownDataAttributesEntityDetailsExternalDataAttributesTableDataAttributesEventViewerExternalDataAttributesRelatedEntitiesExternalDataAttributesRelatedCasesExternalDataAttributesRelatedEventsExternalDataAttributesCaseDetailsDataAttributesCaseTemplateAttributesCaseTemplateVersionAttributesCaseDetailsCaseBlockConfigAttributesRelatedCasesDataAttributesUnionBaseModelCaseActionFormMetaCaseTaskFormMeta
     */
    'meta'?: Meta | null;
    /**
     * 
     * @type {{ [key: string]: JsonApiRelationship; }}
     * @memberof JsonApiResourceObjectUnionCasePropertiesAttributesCaseAdditionalInputsAttributesCaseActionAttributesMappingStrUnionStrListStrFloatIntDatetimeNoneTypeCaseTaskAttributesFileCategoriesAttributesRunningActionAttributesMarkdownCaseBlockAttributesEntityDetailsCaseBlockAttributesTableCaseBlockAttributesEventViewerCaseBlockAttributesCaseDetailsCaseBlockAttributesRelatedEntitiesCaseBlockAttributesRelatedCasesCaseBlockAttributesRelatedEventsCaseBlockAttributesEntityDetailsCaseBlockConfigAttributesEventViewerCaseBlockConfigAttributesRelatedEntitiesCaseBlockConfigAttributesRelatedCasesCaseBlockConfigAttributesRelatedEventsCaseBlockConfigAttributesMarkdownDataAttributesEntityDetailsExternalDataAttributesTableDataAttributesEventViewerExternalDataAttributesRelatedEntitiesExternalDataAttributesRelatedCasesExternalDataAttributesRelatedEventsExternalDataAttributesCaseDetailsDataAttributesCaseTemplateAttributesCaseTemplateVersionAttributesCaseDetailsCaseBlockConfigAttributesRelatedCasesDataAttributesUnionBaseModelCaseActionFormMetaCaseTaskFormMeta
     */
    'relationships'?: { [key: string]: JsonApiRelationship; } | null;
}
/**
 * A JSON:API compliant response.
 * @export
 * @interface JsonApiSuccessPaginationLinks
 */
export interface JsonApiSuccessPaginationLinks {
    /**
     * 
     * @type {string}
     * @memberof JsonApiSuccessPaginationLinks
     */
    'self': string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiSuccessPaginationLinks
     */
    'next'?: string | null;
}
/**
 * A JSON:API compliant response.
 * @export
 * @interface JsonApiSuccessResponseLinks
 */
export interface JsonApiSuccessResponseLinks {
    /**
     * 
     * @type {string}
     * @memberof JsonApiSuccessResponseLinks
     */
    'self': string;
}
/**
 * 
 * @export
 * @interface LinkedBlockConfigAttribute
 */
export interface LinkedBlockConfigAttribute {
    /**
     * 
     * @type {LinkedBlockConfigAttributeKind}
     * @memberof LinkedBlockConfigAttribute
     */
    'kind': LinkedBlockConfigAttributeKind;
    /**
     * 
     * @type {string}
     * @memberof LinkedBlockConfigAttribute
     */
    'key'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const LinkedBlockConfigAttributeKind = {
    ATTRIBUTES: 'attributes',
    ADDITIONAL_INPUTS: 'additional_inputs',
    PROPERTIES: 'properties'
} as const;

export type LinkedBlockConfigAttributeKind = typeof LinkedBlockConfigAttributeKind[keyof typeof LinkedBlockConfigAttributeKind];


/**
 * Request model for patching markdown block data.
 * @export
 * @interface MarkdownBlockDataPatch
 */
export interface MarkdownBlockDataPatch {
    /**
     * 
     * @type {ModelsCaseDataApiModelsMarkdownBlockDataPatchData}
     * @memberof MarkdownBlockDataPatch
     */
    'data': ModelsCaseDataApiModelsMarkdownBlockDataPatchData;
}
/**
 * 
 * @export
 * @interface MarkdownBlockDataPatchResponse
 */
export interface MarkdownBlockDataPatchResponse {
    /**
     * 
     * @type {JsonApiResourceObjectMarkdownDataAttributesBaseModel}
     * @memberof MarkdownBlockDataPatchResponse
     */
    'data': JsonApiResourceObjectMarkdownDataAttributesBaseModel;
    /**
     * 
     * @type {object}
     * @memberof MarkdownBlockDataPatchResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof MarkdownBlockDataPatchResponse
     */
    'links': JsonApiSuccessResponseLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectBaseModelBaseModel>}
     * @memberof MarkdownBlockDataPatchResponse
     */
    'included'?: Array<JsonApiResourceObjectBaseModelBaseModel> | null;
}
/**
 * Attributes for markdown case blocks - only contains kind.
 * @export
 * @interface MarkdownCaseBlockAttributes
 */
export interface MarkdownCaseBlockAttributes {
    /**
     * 
     * @type {string}
     * @memberof MarkdownCaseBlockAttributes
     */
    'kind'?: MarkdownCaseBlockAttributesKindEnum;
}

export const MarkdownCaseBlockAttributesKindEnum = {
    MARKDOWN: 'markdown'
} as const;

export type MarkdownCaseBlockAttributesKindEnum = typeof MarkdownCaseBlockAttributesKindEnum[keyof typeof MarkdownCaseBlockAttributesKindEnum];

/**
 * Data attributes for markdown blocks.
 * @export
 * @interface MarkdownDataAttributes
 */
export interface MarkdownDataAttributes {
    /**
     * 
     * @type {string}
     * @memberof MarkdownDataAttributes
     */
    'content'?: string | null;
}
/**
 * Data resource for markdown blocks.
 * @export
 * @interface MarkdownDataResource
 */
export interface MarkdownDataResource {
    /**
     * 
     * @type {string}
     * @memberof MarkdownDataResource
     */
    'type'?: MarkdownDataResourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MarkdownDataResource
     */
    'id': string;
    /**
     * 
     * @type {MarkdownDataAttributes}
     * @memberof MarkdownDataResource
     */
    'attributes': MarkdownDataAttributes;
}

export const MarkdownDataResourceTypeEnum = {
    CASE_BLOCK_DATA: 'case_block_data'
} as const;

export type MarkdownDataResourceTypeEnum = typeof MarkdownDataResourceTypeEnum[keyof typeof MarkdownDataResourceTypeEnum];

/**
 * 
 * @export
 * @interface Meta
 */
export interface Meta {
    /**
     * 
     * @type {string}
     * @memberof Meta
     */
    'etag': string;
}
/**
 * 
 * @export
 * @interface ModelsCaseDataApiModelsCaseActionFormPatchRequestData
 */
export interface ModelsCaseDataApiModelsCaseActionFormPatchRequestData {
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseDataApiModelsCaseActionFormPatchRequestData
     */
    'type': ModelsCaseDataApiModelsCaseActionFormPatchRequestDataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseDataApiModelsCaseActionFormPatchRequestData
     */
    'id': string;
    /**
     * 
     * @type {{ [key: string]: ActionTriggeredEventDataActionFormDataValue; }}
     * @memberof ModelsCaseDataApiModelsCaseActionFormPatchRequestData
     */
    'attributes': { [key: string]: ActionTriggeredEventDataActionFormDataValue; };
}

export const ModelsCaseDataApiModelsCaseActionFormPatchRequestDataTypeEnum = {
    CASE_ACTION_FORMS: 'case_action_forms'
} as const;

export type ModelsCaseDataApiModelsCaseActionFormPatchRequestDataTypeEnum = typeof ModelsCaseDataApiModelsCaseActionFormPatchRequestDataTypeEnum[keyof typeof ModelsCaseDataApiModelsCaseActionFormPatchRequestDataTypeEnum];

/**
 * 
 * @export
 * @interface ModelsCaseDataApiModelsCaseActionHintApproveRequestData
 */
export interface ModelsCaseDataApiModelsCaseActionHintApproveRequestData {
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseDataApiModelsCaseActionHintApproveRequestData
     */
    'type'?: ModelsCaseDataApiModelsCaseActionHintApproveRequestDataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseDataApiModelsCaseActionHintApproveRequestData
     */
    'id': string;
    /**
     * 
     * @type {{ [key: string]: ActionTriggeredEventDataActionFormDataValue; }}
     * @memberof ModelsCaseDataApiModelsCaseActionHintApproveRequestData
     */
    'attributes': { [key: string]: ActionTriggeredEventDataActionFormDataValue; };
}

export const ModelsCaseDataApiModelsCaseActionHintApproveRequestDataTypeEnum = {
    CASE_ACTION_HINT_APPROVE: 'case_action_hint_approve'
} as const;

export type ModelsCaseDataApiModelsCaseActionHintApproveRequestDataTypeEnum = typeof ModelsCaseDataApiModelsCaseActionHintApproveRequestDataTypeEnum[keyof typeof ModelsCaseDataApiModelsCaseActionHintApproveRequestDataTypeEnum];

/**
 * 
 * @export
 * @interface ModelsCaseDataApiModelsCaseActionHintPatchRequestData
 */
export interface ModelsCaseDataApiModelsCaseActionHintPatchRequestData {
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseDataApiModelsCaseActionHintPatchRequestData
     */
    'type'?: ModelsCaseDataApiModelsCaseActionHintPatchRequestDataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseDataApiModelsCaseActionHintPatchRequestData
     */
    'id': string;
    /**
     * 
     * @type {{ [key: string]: ActionTriggeredEventDataActionFormDataValue; }}
     * @memberof ModelsCaseDataApiModelsCaseActionHintPatchRequestData
     */
    'attributes': { [key: string]: ActionTriggeredEventDataActionFormDataValue; };
}

export const ModelsCaseDataApiModelsCaseActionHintPatchRequestDataTypeEnum = {
    CASE_ACTION_HINT: 'case_action_hint'
} as const;

export type ModelsCaseDataApiModelsCaseActionHintPatchRequestDataTypeEnum = typeof ModelsCaseDataApiModelsCaseActionHintPatchRequestDataTypeEnum[keyof typeof ModelsCaseDataApiModelsCaseActionHintPatchRequestDataTypeEnum];

/**
 * 
 * @export
 * @interface ModelsCaseDataApiModelsCaseCreateRequestData
 */
export interface ModelsCaseDataApiModelsCaseCreateRequestData {
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseDataApiModelsCaseCreateRequestData
     */
    'type': ModelsCaseDataApiModelsCaseCreateRequestDataTypeEnum;
    /**
     * 
     * @type {CaseCreate}
     * @memberof ModelsCaseDataApiModelsCaseCreateRequestData
     */
    'attributes': CaseCreate;
    /**
     * 
     * @type {CaseCreateRequestRelationships}
     * @memberof ModelsCaseDataApiModelsCaseCreateRequestData
     */
    'relationships': CaseCreateRequestRelationships;
}

export const ModelsCaseDataApiModelsCaseCreateRequestDataTypeEnum = {
    CASES: 'cases'
} as const;

export type ModelsCaseDataApiModelsCaseCreateRequestDataTypeEnum = typeof ModelsCaseDataApiModelsCaseCreateRequestDataTypeEnum[keyof typeof ModelsCaseDataApiModelsCaseCreateRequestDataTypeEnum];

/**
 * 
 * @export
 * @interface ModelsCaseDataApiModelsCasePatchRequestData
 */
export interface ModelsCaseDataApiModelsCasePatchRequestData {
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseDataApiModelsCasePatchRequestData
     */
    'type': ModelsCaseDataApiModelsCasePatchRequestDataTypeEnum;
    /**
     * 
     * @type {CasePatchRequestRelationships}
     * @memberof ModelsCaseDataApiModelsCasePatchRequestData
     */
    'relationships': CasePatchRequestRelationships;
}

export const ModelsCaseDataApiModelsCasePatchRequestDataTypeEnum = {
    CASES: 'cases'
} as const;

export type ModelsCaseDataApiModelsCasePatchRequestDataTypeEnum = typeof ModelsCaseDataApiModelsCasePatchRequestDataTypeEnum[keyof typeof ModelsCaseDataApiModelsCasePatchRequestDataTypeEnum];

/**
 * 
 * @export
 * @interface ModelsCaseDataApiModelsCasePropertiesPatchRequestData
 */
export interface ModelsCaseDataApiModelsCasePropertiesPatchRequestData {
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseDataApiModelsCasePropertiesPatchRequestData
     */
    'type': ModelsCaseDataApiModelsCasePropertiesPatchRequestDataTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof ModelsCaseDataApiModelsCasePropertiesPatchRequestData
     */
    'attributes': object;
}

export const ModelsCaseDataApiModelsCasePropertiesPatchRequestDataTypeEnum = {
    CASE_PROPERTIES: 'case_properties'
} as const;

export type ModelsCaseDataApiModelsCasePropertiesPatchRequestDataTypeEnum = typeof ModelsCaseDataApiModelsCasePropertiesPatchRequestDataTypeEnum[keyof typeof ModelsCaseDataApiModelsCasePropertiesPatchRequestDataTypeEnum];

/**
 * 
 * @export
 * @interface ModelsCaseDataApiModelsCaseTaskCompletionPatchRequestData
 */
export interface ModelsCaseDataApiModelsCaseTaskCompletionPatchRequestData {
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseDataApiModelsCaseTaskCompletionPatchRequestData
     */
    'type': ModelsCaseDataApiModelsCaseTaskCompletionPatchRequestDataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseDataApiModelsCaseTaskCompletionPatchRequestData
     */
    'id': string;
    /**
     * 
     * @type {CaseTaskAttributes}
     * @memberof ModelsCaseDataApiModelsCaseTaskCompletionPatchRequestData
     */
    'attributes': CaseTaskAttributes;
}

export const ModelsCaseDataApiModelsCaseTaskCompletionPatchRequestDataTypeEnum = {
    CASE_TASKS: 'case_tasks'
} as const;

export type ModelsCaseDataApiModelsCaseTaskCompletionPatchRequestDataTypeEnum = typeof ModelsCaseDataApiModelsCaseTaskCompletionPatchRequestDataTypeEnum[keyof typeof ModelsCaseDataApiModelsCaseTaskCompletionPatchRequestDataTypeEnum];

/**
 * 
 * @export
 * @interface ModelsCaseDataApiModelsCaseTaskFormPatchRequestData
 */
export interface ModelsCaseDataApiModelsCaseTaskFormPatchRequestData {
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseDataApiModelsCaseTaskFormPatchRequestData
     */
    'type': ModelsCaseDataApiModelsCaseTaskFormPatchRequestDataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseDataApiModelsCaseTaskFormPatchRequestData
     */
    'id': string;
    /**
     * 
     * @type {{ [key: string]: ActionTriggeredEventDataActionFormDataValue; }}
     * @memberof ModelsCaseDataApiModelsCaseTaskFormPatchRequestData
     */
    'attributes': { [key: string]: ActionTriggeredEventDataActionFormDataValue; };
}

export const ModelsCaseDataApiModelsCaseTaskFormPatchRequestDataTypeEnum = {
    CASE_TASK_FORMS: 'case_task_forms'
} as const;

export type ModelsCaseDataApiModelsCaseTaskFormPatchRequestDataTypeEnum = typeof ModelsCaseDataApiModelsCaseTaskFormPatchRequestDataTypeEnum[keyof typeof ModelsCaseDataApiModelsCaseTaskFormPatchRequestDataTypeEnum];

/**
 * 
 * @export
 * @interface ModelsCaseDataApiModelsCaseTaskHintApproveRequestData
 */
export interface ModelsCaseDataApiModelsCaseTaskHintApproveRequestData {
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseDataApiModelsCaseTaskHintApproveRequestData
     */
    'type'?: ModelsCaseDataApiModelsCaseTaskHintApproveRequestDataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseDataApiModelsCaseTaskHintApproveRequestData
     */
    'id': string;
    /**
     * 
     * @type {{ [key: string]: ActionTriggeredEventDataActionFormDataValue; }}
     * @memberof ModelsCaseDataApiModelsCaseTaskHintApproveRequestData
     */
    'attributes': { [key: string]: ActionTriggeredEventDataActionFormDataValue; };
}

export const ModelsCaseDataApiModelsCaseTaskHintApproveRequestDataTypeEnum = {
    CASE_TASK_HINT_APPROVE: 'case_task_hint_approve'
} as const;

export type ModelsCaseDataApiModelsCaseTaskHintApproveRequestDataTypeEnum = typeof ModelsCaseDataApiModelsCaseTaskHintApproveRequestDataTypeEnum[keyof typeof ModelsCaseDataApiModelsCaseTaskHintApproveRequestDataTypeEnum];

/**
 * 
 * @export
 * @interface ModelsCaseDataApiModelsCaseTaskHintPatchRequestData
 */
export interface ModelsCaseDataApiModelsCaseTaskHintPatchRequestData {
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseDataApiModelsCaseTaskHintPatchRequestData
     */
    'type'?: ModelsCaseDataApiModelsCaseTaskHintPatchRequestDataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseDataApiModelsCaseTaskHintPatchRequestData
     */
    'id': string;
    /**
     * 
     * @type {{ [key: string]: ActionTriggeredEventDataActionFormDataValue; }}
     * @memberof ModelsCaseDataApiModelsCaseTaskHintPatchRequestData
     */
    'attributes': { [key: string]: ActionTriggeredEventDataActionFormDataValue; };
}

export const ModelsCaseDataApiModelsCaseTaskHintPatchRequestDataTypeEnum = {
    CASE_TASK_HINT: 'case_task_hint'
} as const;

export type ModelsCaseDataApiModelsCaseTaskHintPatchRequestDataTypeEnum = typeof ModelsCaseDataApiModelsCaseTaskHintPatchRequestDataTypeEnum[keyof typeof ModelsCaseDataApiModelsCaseTaskHintPatchRequestDataTypeEnum];

/**
 * 
 * @export
 * @interface ModelsCaseDataApiModelsFileCategoriesPatchRequestData
 */
export interface ModelsCaseDataApiModelsFileCategoriesPatchRequestData {
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseDataApiModelsFileCategoriesPatchRequestData
     */
    'type': ModelsCaseDataApiModelsFileCategoriesPatchRequestDataTypeEnum;
    /**
     * 
     * @type {FileCategoriesPatchAttributes}
     * @memberof ModelsCaseDataApiModelsFileCategoriesPatchRequestData
     */
    'attributes': FileCategoriesPatchAttributes;
}

export const ModelsCaseDataApiModelsFileCategoriesPatchRequestDataTypeEnum = {
    FILE_CATEGORIES: 'file_categories'
} as const;

export type ModelsCaseDataApiModelsFileCategoriesPatchRequestDataTypeEnum = typeof ModelsCaseDataApiModelsFileCategoriesPatchRequestDataTypeEnum[keyof typeof ModelsCaseDataApiModelsFileCategoriesPatchRequestDataTypeEnum];

/**
 * 
 * @export
 * @interface ModelsCaseDataApiModelsMarkdownBlockDataPatchData
 */
export interface ModelsCaseDataApiModelsMarkdownBlockDataPatchData {
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseDataApiModelsMarkdownBlockDataPatchData
     */
    'type': ModelsCaseDataApiModelsMarkdownBlockDataPatchDataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseDataApiModelsMarkdownBlockDataPatchData
     */
    'id': string;
    /**
     * 
     * @type {MarkdownDataAttributes}
     * @memberof ModelsCaseDataApiModelsMarkdownBlockDataPatchData
     */
    'attributes': MarkdownDataAttributes;
}

export const ModelsCaseDataApiModelsMarkdownBlockDataPatchDataTypeEnum = {
    CASE_BLOCK_DATA: 'case_block_data'
} as const;

export type ModelsCaseDataApiModelsMarkdownBlockDataPatchDataTypeEnum = typeof ModelsCaseDataApiModelsMarkdownBlockDataPatchDataTypeEnum[keyof typeof ModelsCaseDataApiModelsMarkdownBlockDataPatchDataTypeEnum];

/**
 * 
 * @export
 * @interface ModelsCaseDataApiModelsRelatedEntitiesBlockConfigPatchData
 */
export interface ModelsCaseDataApiModelsRelatedEntitiesBlockConfigPatchData {
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseDataApiModelsRelatedEntitiesBlockConfigPatchData
     */
    'type': ModelsCaseDataApiModelsRelatedEntitiesBlockConfigPatchDataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseDataApiModelsRelatedEntitiesBlockConfigPatchData
     */
    'id': string;
    /**
     * 
     * @type {RelatedEntitiesCaseBlockConfigPatchAttributes}
     * @memberof ModelsCaseDataApiModelsRelatedEntitiesBlockConfigPatchData
     */
    'attributes': RelatedEntitiesCaseBlockConfigPatchAttributes;
}

export const ModelsCaseDataApiModelsRelatedEntitiesBlockConfigPatchDataTypeEnum = {
    CASE_BLOCK_CONFIGS: 'case_block_configs'
} as const;

export type ModelsCaseDataApiModelsRelatedEntitiesBlockConfigPatchDataTypeEnum = typeof ModelsCaseDataApiModelsRelatedEntitiesBlockConfigPatchDataTypeEnum[keyof typeof ModelsCaseDataApiModelsRelatedEntitiesBlockConfigPatchDataTypeEnum];

/**
 * 
 * @export
 * @interface ModelsCaseDataApiModelsRelatedEventsBlockConfigPatchData
 */
export interface ModelsCaseDataApiModelsRelatedEventsBlockConfigPatchData {
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseDataApiModelsRelatedEventsBlockConfigPatchData
     */
    'type': ModelsCaseDataApiModelsRelatedEventsBlockConfigPatchDataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseDataApiModelsRelatedEventsBlockConfigPatchData
     */
    'id': string;
    /**
     * 
     * @type {RelatedEventsCaseBlockConfigPatchAttributes}
     * @memberof ModelsCaseDataApiModelsRelatedEventsBlockConfigPatchData
     */
    'attributes': RelatedEventsCaseBlockConfigPatchAttributes;
}

export const ModelsCaseDataApiModelsRelatedEventsBlockConfigPatchDataTypeEnum = {
    CASE_BLOCK_CONFIGS: 'case_block_configs'
} as const;

export type ModelsCaseDataApiModelsRelatedEventsBlockConfigPatchDataTypeEnum = typeof ModelsCaseDataApiModelsRelatedEventsBlockConfigPatchDataTypeEnum[keyof typeof ModelsCaseDataApiModelsRelatedEventsBlockConfigPatchDataTypeEnum];

/**
 * 
 * @export
 * @interface ModelsCaseDataApiModelsTableBlockDataPatchData
 */
export interface ModelsCaseDataApiModelsTableBlockDataPatchData {
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseDataApiModelsTableBlockDataPatchData
     */
    'type': ModelsCaseDataApiModelsTableBlockDataPatchDataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseDataApiModelsTableBlockDataPatchData
     */
    'id': string;
    /**
     * 
     * @type {TableDataAttributes}
     * @memberof ModelsCaseDataApiModelsTableBlockDataPatchData
     */
    'attributes': TableDataAttributes;
}

export const ModelsCaseDataApiModelsTableBlockDataPatchDataTypeEnum = {
    CASE_BLOCK_DATA: 'case_block_data'
} as const;

export type ModelsCaseDataApiModelsTableBlockDataPatchDataTypeEnum = typeof ModelsCaseDataApiModelsTableBlockDataPatchDataTypeEnum[keyof typeof ModelsCaseDataApiModelsTableBlockDataPatchDataTypeEnum];

/**
 * 
 * @export
 * @interface ModelsCaseTemplatesApiModelsCaseTemplateCreateRequestData
 */
export interface ModelsCaseTemplatesApiModelsCaseTemplateCreateRequestData {
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseTemplatesApiModelsCaseTemplateCreateRequestData
     */
    'type': ModelsCaseTemplatesApiModelsCaseTemplateCreateRequestDataTypeEnum;
    /**
     * 
     * @type {CaseTemplateCreate}
     * @memberof ModelsCaseTemplatesApiModelsCaseTemplateCreateRequestData
     */
    'attributes': CaseTemplateCreate;
}

export const ModelsCaseTemplatesApiModelsCaseTemplateCreateRequestDataTypeEnum = {
    CASE_TEMPLATES: 'case_templates'
} as const;

export type ModelsCaseTemplatesApiModelsCaseTemplateCreateRequestDataTypeEnum = typeof ModelsCaseTemplatesApiModelsCaseTemplateCreateRequestDataTypeEnum[keyof typeof ModelsCaseTemplatesApiModelsCaseTemplateCreateRequestDataTypeEnum];

/**
 * 
 * @export
 * @interface ModelsCaseTemplatesApiModelsCaseTemplateMetadataUpdateRequestData
 */
export interface ModelsCaseTemplatesApiModelsCaseTemplateMetadataUpdateRequestData {
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseTemplatesApiModelsCaseTemplateMetadataUpdateRequestData
     */
    'type': ModelsCaseTemplatesApiModelsCaseTemplateMetadataUpdateRequestDataTypeEnum;
    /**
     * 
     * @type {CaseTemplateMetadataUpdate}
     * @memberof ModelsCaseTemplatesApiModelsCaseTemplateMetadataUpdateRequestData
     */
    'attributes': CaseTemplateMetadataUpdate;
}

export const ModelsCaseTemplatesApiModelsCaseTemplateMetadataUpdateRequestDataTypeEnum = {
    CASE_TEMPLATES: 'case_templates'
} as const;

export type ModelsCaseTemplatesApiModelsCaseTemplateMetadataUpdateRequestDataTypeEnum = typeof ModelsCaseTemplatesApiModelsCaseTemplateMetadataUpdateRequestDataTypeEnum[keyof typeof ModelsCaseTemplatesApiModelsCaseTemplateMetadataUpdateRequestDataTypeEnum];

/**
 * 
 * @export
 * @interface ModelsCaseTemplatesApiModelsCaseTemplateVersionDuplicateRequestData
 */
export interface ModelsCaseTemplatesApiModelsCaseTemplateVersionDuplicateRequestData {
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseTemplatesApiModelsCaseTemplateVersionDuplicateRequestData
     */
    'type': ModelsCaseTemplatesApiModelsCaseTemplateVersionDuplicateRequestDataTypeEnum;
    /**
     * 
     * @type {CaseTemplateVersionDuplicate}
     * @memberof ModelsCaseTemplatesApiModelsCaseTemplateVersionDuplicateRequestData
     */
    'attributes': CaseTemplateVersionDuplicate;
}

export const ModelsCaseTemplatesApiModelsCaseTemplateVersionDuplicateRequestDataTypeEnum = {
    CASE_TEMPLATE_VERSIONS: 'case_template_versions'
} as const;

export type ModelsCaseTemplatesApiModelsCaseTemplateVersionDuplicateRequestDataTypeEnum = typeof ModelsCaseTemplatesApiModelsCaseTemplateVersionDuplicateRequestDataTypeEnum[keyof typeof ModelsCaseTemplatesApiModelsCaseTemplateVersionDuplicateRequestDataTypeEnum];

/**
 * 
 * @export
 * @interface ModelsCaseTemplatesApiModelsCaseTemplateVersionUpdateRequestData
 */
export interface ModelsCaseTemplatesApiModelsCaseTemplateVersionUpdateRequestData {
    /**
     * 
     * @type {string}
     * @memberof ModelsCaseTemplatesApiModelsCaseTemplateVersionUpdateRequestData
     */
    'type': ModelsCaseTemplatesApiModelsCaseTemplateVersionUpdateRequestDataTypeEnum;
    /**
     * 
     * @type {CaseTemplateVersionUpdatePresentationModel}
     * @memberof ModelsCaseTemplatesApiModelsCaseTemplateVersionUpdateRequestData
     */
    'attributes': CaseTemplateVersionUpdatePresentationModel;
}

export const ModelsCaseTemplatesApiModelsCaseTemplateVersionUpdateRequestDataTypeEnum = {
    CASE_TEMPLATE_VERSIONS: 'case_template_versions'
} as const;

export type ModelsCaseTemplatesApiModelsCaseTemplateVersionUpdateRequestDataTypeEnum = typeof ModelsCaseTemplatesApiModelsCaseTemplateVersionUpdateRequestDataTypeEnum[keyof typeof ModelsCaseTemplatesApiModelsCaseTemplateVersionUpdateRequestDataTypeEnum];

/**
 * 
 * @export
 * @interface NumberProperty
 */
export interface NumberProperty {
    /**
     * 
     * @type {string}
     * @memberof NumberProperty
     */
    'display_name': string;
    /**
     * 
     * @type {boolean}
     * @memberof NumberProperty
     */
    'required'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NumberProperty
     */
    'type': NumberPropertyTypeEnum;
}

export const NumberPropertyTypeEnum = {
    NUMBER: 'number'
} as const;

export type NumberPropertyTypeEnum = typeof NumberPropertyTypeEnum[keyof typeof NumberPropertyTypeEnum];

/**
 * 
 * @export
 * @interface Payload
 */
export interface Payload {
    /**
     * 
     * @type {ModelsCaseDataApiModelsTableBlockDataPatchData}
     * @memberof Payload
     */
    'data': ModelsCaseDataApiModelsTableBlockDataPatchData;
}
/**
 * 
 * @export
 * @interface Payload1
 */
export interface Payload1 {
    /**
     * 
     * @type {ModelsCaseDataApiModelsRelatedEventsBlockConfigPatchData}
     * @memberof Payload1
     */
    'data': ModelsCaseDataApiModelsRelatedEventsBlockConfigPatchData;
}
/**
 * 
 * @export
 * @interface PinnedEntities
 */
export interface PinnedEntities {
}
/**
 * Data for pinned entities updates on RelatedEntities blocks.
 * @export
 * @interface PinnedEntitiesUpdatedEventData
 */
export interface PinnedEntitiesUpdatedEventData {
    /**
     * 
     * @type {string}
     * @memberof PinnedEntitiesUpdatedEventData
     */
    'event_type'?: PinnedEntitiesUpdatedEventDataEventTypeEnum;
    /**
     * Block key where pins were updated
     * @type {string}
     * @memberof PinnedEntitiesUpdatedEventData
     */
    'block_key': string;
    /**
     * List of added pinned entities
     * @type {Array<PinnedEntity>}
     * @memberof PinnedEntitiesUpdatedEventData
     */
    'added_entities': Array<PinnedEntity>;
    /**
     * List of removed pinned entities
     * @type {Array<PinnedEntity>}
     * @memberof PinnedEntitiesUpdatedEventData
     */
    'removed_entities': Array<PinnedEntity>;
    /**
     * 
     * @type {string}
     * @memberof PinnedEntitiesUpdatedEventData
     */
    'updated_by_user_id'?: string | null;
}

export const PinnedEntitiesUpdatedEventDataEventTypeEnum = {
    PINNED_ENTITIES_UPDATED: 'pinned_entities_updated'
} as const;

export type PinnedEntitiesUpdatedEventDataEventTypeEnum = typeof PinnedEntitiesUpdatedEventDataEventTypeEnum[keyof typeof PinnedEntitiesUpdatedEventDataEventTypeEnum];

/**
 * Represents a pinned entity with its ID and type.
 * @export
 * @interface PinnedEntity
 */
export interface PinnedEntity {
    /**
     * 
     * @type {string}
     * @memberof PinnedEntity
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PinnedEntity
     */
    'entity_type': string;
}
/**
 * Represents a pinned event with its ID, type, and timestamp.
 * @export
 * @interface PinnedEvent
 */
export interface PinnedEvent {
    /**
     * 
     * @type {string}
     * @memberof PinnedEvent
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PinnedEvent
     */
    'event_type': string;
    /**
     * 
     * @type {string}
     * @memberof PinnedEvent
     */
    'timestamp'?: string | null;
}
/**
 * 
 * @export
 * @interface PinnedEvents
 */
export interface PinnedEvents {
}
/**
 * Data for pinned events updates on RelatedEvents blocks.
 * @export
 * @interface PinnedEventsUpdatedEventData
 */
export interface PinnedEventsUpdatedEventData {
    /**
     * 
     * @type {string}
     * @memberof PinnedEventsUpdatedEventData
     */
    'event_type'?: PinnedEventsUpdatedEventDataEventTypeEnum;
    /**
     * Block key where pins were updated
     * @type {string}
     * @memberof PinnedEventsUpdatedEventData
     */
    'block_key': string;
    /**
     * List of added pinned events
     * @type {Array<PinnedEvent>}
     * @memberof PinnedEventsUpdatedEventData
     */
    'added_events': Array<PinnedEvent>;
    /**
     * List of removed pinned events
     * @type {Array<PinnedEvent>}
     * @memberof PinnedEventsUpdatedEventData
     */
    'removed_events': Array<PinnedEvent>;
    /**
     * 
     * @type {string}
     * @memberof PinnedEventsUpdatedEventData
     */
    'updated_by_user_id'?: string | null;
}

export const PinnedEventsUpdatedEventDataEventTypeEnum = {
    PINNED_EVENTS_UPDATED: 'pinned_events_updated'
} as const;

export type PinnedEventsUpdatedEventDataEventTypeEnum = typeof PinnedEventsUpdatedEventDataEventTypeEnum[keyof typeof PinnedEventsUpdatedEventDataEventTypeEnum];

/**
 * 
 * @export
 * @interface PredefinedValue
 */
export interface PredefinedValue {
    /**
     * 
     * @type {string}
     * @memberof PredefinedValue
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof PredefinedValue
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PredefinedValue
     */
    'display_name'?: string | null;
}
/**
 * 
 * @export
 * @interface QueueIdentifier
 */
export interface QueueIdentifier {
    /**
     * 
     * @type {string}
     * @memberof QueueIdentifier
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof QueueIdentifier
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueueIdentifier
     */
    'lid'?: string | null;
}
/**
 * 
 * @export
 * @interface Record
 */
export interface Record {
}
/**
 * Attributes for related cases case blocks - only contains kind.
 * @export
 * @interface RelatedCasesCaseBlockAttributes
 */
export interface RelatedCasesCaseBlockAttributes {
    /**
     * 
     * @type {string}
     * @memberof RelatedCasesCaseBlockAttributes
     */
    'kind'?: RelatedCasesCaseBlockAttributesKindEnum;
}

export const RelatedCasesCaseBlockAttributesKindEnum = {
    RELATED_CASES: 'related_cases'
} as const;

export type RelatedCasesCaseBlockAttributesKindEnum = typeof RelatedCasesCaseBlockAttributesKindEnum[keyof typeof RelatedCasesCaseBlockAttributesKindEnum];

/**
 * Configuration attributes for related cases case blocks.
 * @export
 * @interface RelatedCasesCaseBlockConfigAttributes
 */
export interface RelatedCasesCaseBlockConfigAttributes {
    /**
     * 
     * @type {EntityObject}
     * @memberof RelatedCasesCaseBlockConfigAttributes
     */
    'entity': EntityObject;
}
/**
 * Request model for patching related entities block config.
 * @export
 * @interface RelatedEntitiesBlockConfigPatch
 */
export interface RelatedEntitiesBlockConfigPatch {
    /**
     * 
     * @type {ModelsCaseDataApiModelsRelatedEntitiesBlockConfigPatchData}
     * @memberof RelatedEntitiesBlockConfigPatch
     */
    'data': ModelsCaseDataApiModelsRelatedEntitiesBlockConfigPatchData;
}
/**
 * 
 * @export
 * @interface RelatedEntitiesBlockConfigPatchResponse
 */
export interface RelatedEntitiesBlockConfigPatchResponse {
    /**
     * 
     * @type {JsonApiResourceObjectRelatedEntitiesCaseBlockConfigPatchAttributesBaseModel}
     * @memberof RelatedEntitiesBlockConfigPatchResponse
     */
    'data': JsonApiResourceObjectRelatedEntitiesCaseBlockConfigPatchAttributesBaseModel;
    /**
     * 
     * @type {object}
     * @memberof RelatedEntitiesBlockConfigPatchResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof RelatedEntitiesBlockConfigPatchResponse
     */
    'links': JsonApiSuccessResponseLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectBaseModelBaseModel>}
     * @memberof RelatedEntitiesBlockConfigPatchResponse
     */
    'included'?: Array<JsonApiResourceObjectBaseModelBaseModel> | null;
}
/**
 * Attributes for related entities case blocks - only contains kind.
 * @export
 * @interface RelatedEntitiesCaseBlockAttributes
 */
export interface RelatedEntitiesCaseBlockAttributes {
    /**
     * 
     * @type {string}
     * @memberof RelatedEntitiesCaseBlockAttributes
     */
    'kind'?: RelatedEntitiesCaseBlockAttributesKindEnum;
}

export const RelatedEntitiesCaseBlockAttributesKindEnum = {
    RELATED_ENTITIES: 'related_entities'
} as const;

export type RelatedEntitiesCaseBlockAttributesKindEnum = typeof RelatedEntitiesCaseBlockAttributesKindEnum[keyof typeof RelatedEntitiesCaseBlockAttributesKindEnum];

/**
 * Configuration attributes for related entities case blocks.
 * @export
 * @interface RelatedEntitiesCaseBlockConfigAttributes
 */
export interface RelatedEntitiesCaseBlockConfigAttributes {
    /**
     * 
     * @type {EntityObject}
     * @memberof RelatedEntitiesCaseBlockConfigAttributes
     */
    'entity': EntityObject;
    /**
     * 
     * @type {Array<PinnedEntity>}
     * @memberof RelatedEntitiesCaseBlockConfigAttributes
     */
    'pinned_entities': Array<PinnedEntity>;
}
/**
 * Patch attributes for related entities case blocks.  Only allows pinned_entities updates.
 * @export
 * @interface RelatedEntitiesCaseBlockConfigPatchAttributes
 */
export interface RelatedEntitiesCaseBlockConfigPatchAttributes {
    /**
     * 
     * @type {Array<PinnedEntity>}
     * @memberof RelatedEntitiesCaseBlockConfigPatchAttributes
     */
    'pinned_entities': Array<PinnedEntity>;
}
/**
 * Request model for patching related events block config.
 * @export
 * @interface RelatedEventsBlockConfigPatch
 */
export interface RelatedEventsBlockConfigPatch {
    /**
     * 
     * @type {ModelsCaseDataApiModelsRelatedEventsBlockConfigPatchData}
     * @memberof RelatedEventsBlockConfigPatch
     */
    'data': ModelsCaseDataApiModelsRelatedEventsBlockConfigPatchData;
}
/**
 * 
 * @export
 * @interface RelatedEventsBlockConfigPatchResponse
 */
export interface RelatedEventsBlockConfigPatchResponse {
    /**
     * 
     * @type {JsonApiResourceObjectRelatedEventsCaseBlockConfigPatchAttributesBaseModel}
     * @memberof RelatedEventsBlockConfigPatchResponse
     */
    'data': JsonApiResourceObjectRelatedEventsCaseBlockConfigPatchAttributesBaseModel;
    /**
     * 
     * @type {object}
     * @memberof RelatedEventsBlockConfigPatchResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof RelatedEventsBlockConfigPatchResponse
     */
    'links': JsonApiSuccessResponseLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectBaseModelBaseModel>}
     * @memberof RelatedEventsBlockConfigPatchResponse
     */
    'included'?: Array<JsonApiResourceObjectBaseModelBaseModel> | null;
}
/**
 * Attributes for related events case blocks - only contains kind.
 * @export
 * @interface RelatedEventsCaseBlockAttributes
 */
export interface RelatedEventsCaseBlockAttributes {
    /**
     * 
     * @type {string}
     * @memberof RelatedEventsCaseBlockAttributes
     */
    'kind'?: RelatedEventsCaseBlockAttributesKindEnum;
}

export const RelatedEventsCaseBlockAttributesKindEnum = {
    RELATED_EVENTS: 'related_events'
} as const;

export type RelatedEventsCaseBlockAttributesKindEnum = typeof RelatedEventsCaseBlockAttributesKindEnum[keyof typeof RelatedEventsCaseBlockAttributesKindEnum];

/**
 * Configuration attributes for related events case blocks.
 * @export
 * @interface RelatedEventsCaseBlockConfigAttributes
 */
export interface RelatedEventsCaseBlockConfigAttributes {
    /**
     * 
     * @type {EntityObject}
     * @memberof RelatedEventsCaseBlockConfigAttributes
     */
    'entity': EntityObject;
    /**
     * 
     * @type {Array<PinnedEvent>}
     * @memberof RelatedEventsCaseBlockConfigAttributes
     */
    'pinned_events': Array<PinnedEvent>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RelatedEventsCaseBlockConfigAttributes
     */
    'event_types'?: Array<string> | null;
}
/**
 * Patch attributes for related events case blocks.  Only allows pinned_entities updates.
 * @export
 * @interface RelatedEventsCaseBlockConfigPatchAttributes
 */
export interface RelatedEventsCaseBlockConfigPatchAttributes {
    /**
     * 
     * @type {Array<PinnedEvent>}
     * @memberof RelatedEventsCaseBlockConfigPatchAttributes
     */
    'pinned_events': Array<PinnedEvent>;
}
/**
 * 
 * @export
 * @interface ResponsePatchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatch
 */
export interface ResponsePatchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatch {
    /**
     * 
     * @type {JsonApiResourceObjectRelatedEventsCaseBlockConfigPatchAttributesBaseModel}
     * @memberof ResponsePatchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatch
     */
    'data': JsonApiResourceObjectRelatedEventsCaseBlockConfigPatchAttributesBaseModel;
    /**
     * 
     * @type {object}
     * @memberof ResponsePatchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatch
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof ResponsePatchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatch
     */
    'links': JsonApiSuccessResponseLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectBaseModelBaseModel>}
     * @memberof ResponsePatchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatch
     */
    'included'?: Array<JsonApiResourceObjectBaseModelBaseModel>;
}
/**
 * 
 * @export
 * @interface ResponsePatchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatch
 */
export interface ResponsePatchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatch {
    /**
     * 
     * @type {JsonApiResourceObjectTableDataAttributesBaseModel}
     * @memberof ResponsePatchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatch
     */
    'data': JsonApiResourceObjectTableDataAttributesBaseModel;
    /**
     * 
     * @type {object}
     * @memberof ResponsePatchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatch
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof ResponsePatchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatch
     */
    'links': JsonApiSuccessResponseLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectBaseModelBaseModel>}
     * @memberof ResponsePatchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatch
     */
    'included'?: Array<JsonApiResourceObjectBaseModelBaseModel>;
}
/**
 * Attributes for running action resources.
 * @export
 * @interface RunningActionAttributes
 */
export interface RunningActionAttributes {
    /**
     * 
     * @type {CaseRunningActionStatus}
     * @memberof RunningActionAttributes
     */
    'status': CaseRunningActionStatus;
    /**
     * 
     * @type {CaseRunningActionType}
     * @memberof RunningActionAttributes
     */
    'type': CaseRunningActionType;
    /**
     * 
     * @type {string}
     * @memberof RunningActionAttributes
     */
    'action_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RunningActionAttributes
     */
    'action_key'?: string | null;
    /**
     * 
     * @type {Array<CaseTemplateWorkflowRuleActionAutomation>}
     * @memberof RunningActionAttributes
     */
    'automation'?: Array<CaseTemplateWorkflowRuleActionAutomation> | null;
    /**
     * 
     * @type {string}
     * @memberof RunningActionAttributes
     */
    'error_message'?: string | null;
}


/**
 * 
 * @export
 * @interface RunningActionsMeta
 */
export interface RunningActionsMeta {
    /**
     * 
     * @type {string}
     * @memberof RunningActionsMeta
     */
    'retried_action_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RunningActionsMeta
     */
    'dismissed_action_id'?: string | null;
}
/**
 * 
 * @export
 * @interface RunningActionsResponse
 */
export interface RunningActionsResponse {
    /**
     * 
     * @type {Array<JsonApiResourceObjectRunningActionAttributesBaseModel>}
     * @memberof RunningActionsResponse
     */
    'data': Array<JsonApiResourceObjectRunningActionAttributesBaseModel>;
    /**
     * 
     * @type {RunningActionsMeta}
     * @memberof RunningActionsResponse
     */
    'meta'?: RunningActionsMeta | null;
    /**
     * 
     * @type {JsonApiSuccessPaginationLinks}
     * @memberof RunningActionsResponse
     */
    'links': JsonApiSuccessPaginationLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectBaseModelBaseModel>}
     * @memberof RunningActionsResponse
     */
    'included'?: Array<JsonApiResourceObjectBaseModelBaseModel> | null;
}
/**
 * 
 * @export
 * @interface Status
 */
export interface Status {
}
/**
 * 
 * @export
 * @interface StringProperty
 */
export interface StringProperty {
    /**
     * 
     * @type {string}
     * @memberof StringProperty
     */
    'display_name': string;
    /**
     * 
     * @type {boolean}
     * @memberof StringProperty
     */
    'required'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StringProperty
     */
    'type': StringPropertyTypeEnum;
}

export const StringPropertyTypeEnum = {
    STRING: 'string'
} as const;

export type StringPropertyTypeEnum = typeof StringPropertyTypeEnum[keyof typeof StringPropertyTypeEnum];

/**
 * Request model for patching table block data.
 * @export
 * @interface TableBlockDataPatch
 */
export interface TableBlockDataPatch {
    /**
     * 
     * @type {ModelsCaseDataApiModelsTableBlockDataPatchData}
     * @memberof TableBlockDataPatch
     */
    'data': ModelsCaseDataApiModelsTableBlockDataPatchData;
}
/**
 * 
 * @export
 * @interface TableBlockDataPatchResponse
 */
export interface TableBlockDataPatchResponse {
    /**
     * 
     * @type {JsonApiResourceObjectTableDataAttributesBaseModel}
     * @memberof TableBlockDataPatchResponse
     */
    'data': JsonApiResourceObjectTableDataAttributesBaseModel;
    /**
     * 
     * @type {object}
     * @memberof TableBlockDataPatchResponse
     */
    'meta'?: object;
    /**
     * 
     * @type {JsonApiSuccessResponseLinks}
     * @memberof TableBlockDataPatchResponse
     */
    'links': JsonApiSuccessResponseLinks;
    /**
     * 
     * @type {Array<JsonApiResourceObjectBaseModelBaseModel>}
     * @memberof TableBlockDataPatchResponse
     */
    'included'?: Array<JsonApiResourceObjectBaseModelBaseModel> | null;
}
/**
 * Attributes for table case blocks - only contains kind.
 * @export
 * @interface TableCaseBlockAttributes
 */
export interface TableCaseBlockAttributes {
    /**
     * 
     * @type {string}
     * @memberof TableCaseBlockAttributes
     */
    'kind'?: TableCaseBlockAttributesKindEnum;
}

export const TableCaseBlockAttributesKindEnum = {
    TABLE: 'table'
} as const;

export type TableCaseBlockAttributesKindEnum = typeof TableCaseBlockAttributesKindEnum[keyof typeof TableCaseBlockAttributesKindEnum];

/**
 * Data attributes for table blocks.
 * @export
 * @interface TableDataAttributes
 */
export interface TableDataAttributes {
    /**
     * 
     * @type {Record}
     * @memberof TableDataAttributes
     */
    'record': Record;
}
/**
 * Data resource for table blocks.
 * @export
 * @interface TableDataResource
 */
export interface TableDataResource {
    /**
     * 
     * @type {string}
     * @memberof TableDataResource
     */
    'type'?: TableDataResourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TableDataResource
     */
    'id': string;
    /**
     * 
     * @type {TableDataAttributes}
     * @memberof TableDataResource
     */
    'attributes': TableDataAttributes;
}

export const TableDataResourceTypeEnum = {
    CASE_BLOCK_DATA: 'case_block_data'
} as const;

export type TableDataResourceTypeEnum = typeof TableDataResourceTypeEnum[keyof typeof TableDataResourceTypeEnum];

/**
 * 
 * @export
 * @interface TagsProperty
 */
export interface TagsProperty {
    /**
     * 
     * @type {string}
     * @memberof TagsProperty
     */
    'display_name': string;
    /**
     * 
     * @type {boolean}
     * @memberof TagsProperty
     */
    'required'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TagsProperty
     */
    'type': TagsPropertyTypeEnum;
    /**
     * 
     * @type {Array<PredefinedValue>}
     * @memberof TagsProperty
     */
    'values': Array<PredefinedValue>;
}

export const TagsPropertyTypeEnum = {
    TAGS: 'tags'
} as const;

export type TagsPropertyTypeEnum = typeof TagsPropertyTypeEnum[keyof typeof TagsPropertyTypeEnum];

/**
 * Data for task completion events.
 * @export
 * @interface TaskCompletedEventData
 */
export interface TaskCompletedEventData {
    /**
     * 
     * @type {string}
     * @memberof TaskCompletedEventData
     */
    'event_type'?: TaskCompletedEventDataEventTypeEnum;
    /**
     * Status key where the task is located
     * @type {string}
     * @memberof TaskCompletedEventData
     */
    'status_key': string;
    /**
     * Key of the completed task
     * @type {string}
     * @memberof TaskCompletedEventData
     */
    'task_key': string;
    /**
     * 
     * @type {{ [key: string]: ActionTriggeredEventDataActionFormDataValue; }}
     * @memberof TaskCompletedEventData
     */
    'task_form_data'?: { [key: string]: ActionTriggeredEventDataActionFormDataValue; } | null;
}

export const TaskCompletedEventDataEventTypeEnum = {
    TASK_COMPLETED: 'task_completed'
} as const;

export type TaskCompletedEventDataEventTypeEnum = typeof TaskCompletedEventDataEventTypeEnum[keyof typeof TaskCompletedEventDataEventTypeEnum];

/**
 * Data for task uncompletion events.
 * @export
 * @interface TaskUncompletedEventData
 */
export interface TaskUncompletedEventData {
    /**
     * 
     * @type {string}
     * @memberof TaskUncompletedEventData
     */
    'event_type'?: TaskUncompletedEventDataEventTypeEnum;
    /**
     * Status key where the task is located
     * @type {string}
     * @memberof TaskUncompletedEventData
     */
    'status_key': string;
    /**
     * Key of the uncompleted task
     * @type {string}
     * @memberof TaskUncompletedEventData
     */
    'task_key': string;
}

export const TaskUncompletedEventDataEventTypeEnum = {
    TASK_UNCOMPLETED: 'task_uncompleted'
} as const;

export type TaskUncompletedEventDataEventTypeEnum = typeof TaskUncompletedEventDataEventTypeEnum[keyof typeof TaskUncompletedEventDataEventTypeEnum];

/**
 * Sentinel enum for undefined values in PATCH requests.
 * @export
 * @enum {string}
 */

export const UndefinedSentinel = {
    UNDEFINED: 'UNDEFINED'
} as const;

export type UndefinedSentinel = typeof UndefinedSentinel[keyof typeof UndefinedSentinel];


/**
 * 
 * @export
 * @interface UpdatedPropertiesValue
 */
export interface UpdatedPropertiesValue {
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}
/**
 * 
 * @export
 * @interface Value
 */
export interface Value {
}

/**
 * CaseHintsApi - axios parameter creator
 * @export
 */
export const CaseHintsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Accept an AI-generated hint for a case action, save the form data, and remove the hint from storage. Requires optimistic concurrency control via If-Match header.
         * @summary Approve case action hint
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {string} actionKey The composite identifier of the action. Format: {status_key}#{action_key} (e.g., \&#39;open#approve\&#39;)
         * @param {string} ifMatch ETag value of the form state for optimistic concurrency control (required).
         * @param {CaseActionHintApproveRequest} caseActionHintApproveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveCaseActionHintApiV1CasesCaseIdActionsActionKeyHintApprovePost: async (caseId: string, actionKey: string, ifMatch: string, caseActionHintApproveRequest: CaseActionHintApproveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('approveCaseActionHintApiV1CasesCaseIdActionsActionKeyHintApprovePost', 'caseId', caseId)
            // verify required parameter 'actionKey' is not null or undefined
            assertParamExists('approveCaseActionHintApiV1CasesCaseIdActionsActionKeyHintApprovePost', 'actionKey', actionKey)
            // verify required parameter 'ifMatch' is not null or undefined
            assertParamExists('approveCaseActionHintApiV1CasesCaseIdActionsActionKeyHintApprovePost', 'ifMatch', ifMatch)
            // verify required parameter 'caseActionHintApproveRequest' is not null or undefined
            assertParamExists('approveCaseActionHintApiV1CasesCaseIdActionsActionKeyHintApprovePost', 'caseActionHintApproveRequest', caseActionHintApproveRequest)
            const localVarPath = `/api/v1/cases/{case_id}/actions/{action_key}/hint/approve`
                .replace(`{${"case_id"}}`, encodeURIComponent(String(caseId)))
                .replace(`{${"action_key"}}`, encodeURIComponent(String(actionKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(caseActionHintApproveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accept an AI-generated hint for a case task, save the form data, and remove the hint from storage. Requires optimistic concurrency control via If-Match header.
         * @summary Approve case task hint
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {string} taskKey The composite identifier of the task. Format: {status_key}#{task_key} (e.g., \&#39;open#review\&#39;)
         * @param {string} ifMatch ETag value of the form state for optimistic concurrency control (required).
         * @param {CaseTaskHintApproveRequest} caseTaskHintApproveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintApprovePost: async (caseId: string, taskKey: string, ifMatch: string, caseTaskHintApproveRequest: CaseTaskHintApproveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('approveCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintApprovePost', 'caseId', caseId)
            // verify required parameter 'taskKey' is not null or undefined
            assertParamExists('approveCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintApprovePost', 'taskKey', taskKey)
            // verify required parameter 'ifMatch' is not null or undefined
            assertParamExists('approveCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintApprovePost', 'ifMatch', ifMatch)
            // verify required parameter 'caseTaskHintApproveRequest' is not null or undefined
            assertParamExists('approveCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintApprovePost', 'caseTaskHintApproveRequest', caseTaskHintApproveRequest)
            const localVarPath = `/api/v1/cases/{case_id}/tasks/{task_key}/hint/approve`
                .replace(`{${"case_id"}}`, encodeURIComponent(String(caseId)))
                .replace(`{${"task_key"}}`, encodeURIComponent(String(taskKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(caseTaskHintApproveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all generated AI recommendations for a case.
         * @summary Get case hints
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseHintsApiV1CasesCaseIdHintsGet: async (caseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('getCaseHintsApiV1CasesCaseIdHintsGet', 'caseId', caseId)
            const localVarPath = `/api/v1/cases/{case_id}/hints`
                .replace(`{${"case_id"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update AI-generated hint (recommendation) for a specific case action. The action_key format is \'{status_key}#{action_key}\' (e.g., \'open#submit\').
         * @summary Patch case action hint
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {string} actionKey The composite identifier of the action within the case. Format: {status_key}#{action_key} where status_key is \&#39;status\&#39; or \&#39;status-sub_status\&#39; (e.g., \&#39;open#submit\&#39;, \&#39;pending_review-waiting_docs#review\&#39;)
         * @param {CaseActionHintPatchRequest} caseActionHintPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCaseActionHintApiV1CasesCaseIdActionsActionKeyHintPatch: async (caseId: string, actionKey: string, caseActionHintPatchRequest: CaseActionHintPatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('patchCaseActionHintApiV1CasesCaseIdActionsActionKeyHintPatch', 'caseId', caseId)
            // verify required parameter 'actionKey' is not null or undefined
            assertParamExists('patchCaseActionHintApiV1CasesCaseIdActionsActionKeyHintPatch', 'actionKey', actionKey)
            // verify required parameter 'caseActionHintPatchRequest' is not null or undefined
            assertParamExists('patchCaseActionHintApiV1CasesCaseIdActionsActionKeyHintPatch', 'caseActionHintPatchRequest', caseActionHintPatchRequest)
            const localVarPath = `/api/v1/cases/{case_id}/actions/{action_key}/hint`
                .replace(`{${"case_id"}}`, encodeURIComponent(String(caseId)))
                .replace(`{${"action_key"}}`, encodeURIComponent(String(actionKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(caseActionHintPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update AI-generated hint (recommendation) for a specific case task. The task_key format is \'{status_key}#{task_key}\' (e.g., \'open#review_task\').
         * @summary Patch case task hint
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {string} taskKey The composite identifier of the task within the case. Format: {status_key}#{task_key} where status_key is \&#39;status\&#39; or \&#39;status-sub_status\&#39; (e.g., \&#39;open#review_task\&#39;, \&#39;pending_review-waiting_docs#approve_task\&#39;)
         * @param {CaseTaskHintPatchRequest} caseTaskHintPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintPatch: async (caseId: string, taskKey: string, caseTaskHintPatchRequest: CaseTaskHintPatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('patchCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintPatch', 'caseId', caseId)
            // verify required parameter 'taskKey' is not null or undefined
            assertParamExists('patchCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintPatch', 'taskKey', taskKey)
            // verify required parameter 'caseTaskHintPatchRequest' is not null or undefined
            assertParamExists('patchCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintPatch', 'caseTaskHintPatchRequest', caseTaskHintPatchRequest)
            const localVarPath = `/api/v1/cases/{case_id}/tasks/{task_key}/hint`
                .replace(`{${"case_id"}}`, encodeURIComponent(String(caseId)))
                .replace(`{${"task_key"}}`, encodeURIComponent(String(taskKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(caseTaskHintPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Dismiss an AI-generated hint for a case action and remove it from storage.
         * @summary Reject case action hint
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {string} actionKey The composite identifier of the action. Format: {status_key}#{action_key} (e.g., \&#39;open#approve\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectCaseActionHintApiV1CasesCaseIdActionsActionKeyHintRejectPost: async (caseId: string, actionKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('rejectCaseActionHintApiV1CasesCaseIdActionsActionKeyHintRejectPost', 'caseId', caseId)
            // verify required parameter 'actionKey' is not null or undefined
            assertParamExists('rejectCaseActionHintApiV1CasesCaseIdActionsActionKeyHintRejectPost', 'actionKey', actionKey)
            const localVarPath = `/api/v1/cases/{case_id}/actions/{action_key}/hint/reject`
                .replace(`{${"case_id"}}`, encodeURIComponent(String(caseId)))
                .replace(`{${"action_key"}}`, encodeURIComponent(String(actionKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Dismiss an AI-generated hint for a case task and remove it from storage.
         * @summary Reject case task hint
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {string} taskKey The composite identifier of the task. Format: {status_key}#{task_key} (e.g., \&#39;open#review\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintRejectPost: async (caseId: string, taskKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('rejectCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintRejectPost', 'caseId', caseId)
            // verify required parameter 'taskKey' is not null or undefined
            assertParamExists('rejectCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintRejectPost', 'taskKey', taskKey)
            const localVarPath = `/api/v1/cases/{case_id}/tasks/{task_key}/hint/reject`
                .replace(`{${"case_id"}}`, encodeURIComponent(String(caseId)))
                .replace(`{${"task_key"}}`, encodeURIComponent(String(taskKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CaseHintsApi - functional programming interface
 * @export
 */
export const CaseHintsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CaseHintsApiAxiosParamCreator(configuration)
    return {
        /**
         * Accept an AI-generated hint for a case action, save the form data, and remove the hint from storage. Requires optimistic concurrency control via If-Match header.
         * @summary Approve case action hint
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {string} actionKey The composite identifier of the action. Format: {status_key}#{action_key} (e.g., \&#39;open#approve\&#39;)
         * @param {string} ifMatch ETag value of the form state for optimistic concurrency control (required).
         * @param {CaseActionHintApproveRequest} caseActionHintApproveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveCaseActionHintApiV1CasesCaseIdActionsActionKeyHintApprovePost(caseId: string, actionKey: string, ifMatch: string, caseActionHintApproveRequest: CaseActionHintApproveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseActionHintApproveResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveCaseActionHintApiV1CasesCaseIdActionsActionKeyHintApprovePost(caseId, actionKey, ifMatch, caseActionHintApproveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseHintsApi.approveCaseActionHintApiV1CasesCaseIdActionsActionKeyHintApprovePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Accept an AI-generated hint for a case task, save the form data, and remove the hint from storage. Requires optimistic concurrency control via If-Match header.
         * @summary Approve case task hint
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {string} taskKey The composite identifier of the task. Format: {status_key}#{task_key} (e.g., \&#39;open#review\&#39;)
         * @param {string} ifMatch ETag value of the form state for optimistic concurrency control (required).
         * @param {CaseTaskHintApproveRequest} caseTaskHintApproveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintApprovePost(caseId: string, taskKey: string, ifMatch: string, caseTaskHintApproveRequest: CaseTaskHintApproveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseTaskHintApproveResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintApprovePost(caseId, taskKey, ifMatch, caseTaskHintApproveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseHintsApi.approveCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintApprovePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all generated AI recommendations for a case.
         * @summary Get case hints
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCaseHintsApiV1CasesCaseIdHintsGet(caseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseHintsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCaseHintsApiV1CasesCaseIdHintsGet(caseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseHintsApi.getCaseHintsApiV1CasesCaseIdHintsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update AI-generated hint (recommendation) for a specific case action. The action_key format is \'{status_key}#{action_key}\' (e.g., \'open#submit\').
         * @summary Patch case action hint
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {string} actionKey The composite identifier of the action within the case. Format: {status_key}#{action_key} where status_key is \&#39;status\&#39; or \&#39;status-sub_status\&#39; (e.g., \&#39;open#submit\&#39;, \&#39;pending_review-waiting_docs#review\&#39;)
         * @param {CaseActionHintPatchRequest} caseActionHintPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCaseActionHintApiV1CasesCaseIdActionsActionKeyHintPatch(caseId: string, actionKey: string, caseActionHintPatchRequest: CaseActionHintPatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseActionHintPatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCaseActionHintApiV1CasesCaseIdActionsActionKeyHintPatch(caseId, actionKey, caseActionHintPatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseHintsApi.patchCaseActionHintApiV1CasesCaseIdActionsActionKeyHintPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update AI-generated hint (recommendation) for a specific case task. The task_key format is \'{status_key}#{task_key}\' (e.g., \'open#review_task\').
         * @summary Patch case task hint
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {string} taskKey The composite identifier of the task within the case. Format: {status_key}#{task_key} where status_key is \&#39;status\&#39; or \&#39;status-sub_status\&#39; (e.g., \&#39;open#review_task\&#39;, \&#39;pending_review-waiting_docs#approve_task\&#39;)
         * @param {CaseTaskHintPatchRequest} caseTaskHintPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintPatch(caseId: string, taskKey: string, caseTaskHintPatchRequest: CaseTaskHintPatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseTaskHintPatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintPatch(caseId, taskKey, caseTaskHintPatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseHintsApi.patchCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Dismiss an AI-generated hint for a case action and remove it from storage.
         * @summary Reject case action hint
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {string} actionKey The composite identifier of the action. Format: {status_key}#{action_key} (e.g., \&#39;open#approve\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectCaseActionHintApiV1CasesCaseIdActionsActionKeyHintRejectPost(caseId: string, actionKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectCaseActionHintApiV1CasesCaseIdActionsActionKeyHintRejectPost(caseId, actionKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseHintsApi.rejectCaseActionHintApiV1CasesCaseIdActionsActionKeyHintRejectPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Dismiss an AI-generated hint for a case task and remove it from storage.
         * @summary Reject case task hint
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {string} taskKey The composite identifier of the task. Format: {status_key}#{task_key} (e.g., \&#39;open#review\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintRejectPost(caseId: string, taskKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintRejectPost(caseId, taskKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseHintsApi.rejectCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintRejectPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CaseHintsApi - factory interface
 * @export
 */
export const CaseHintsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CaseHintsApiFp(configuration)
    return {
        /**
         * Accept an AI-generated hint for a case action, save the form data, and remove the hint from storage. Requires optimistic concurrency control via If-Match header.
         * @summary Approve case action hint
         * @param {CaseHintsApiApproveCaseActionHintApiV1CasesCaseIdActionsActionKeyHintApprovePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveCaseActionHintApiV1CasesCaseIdActionsActionKeyHintApprovePost(requestParameters: CaseHintsApiApproveCaseActionHintApiV1CasesCaseIdActionsActionKeyHintApprovePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CaseActionHintApproveResponse> {
            return localVarFp.approveCaseActionHintApiV1CasesCaseIdActionsActionKeyHintApprovePost(requestParameters.caseId, requestParameters.actionKey, requestParameters.ifMatch, requestParameters.caseActionHintApproveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Accept an AI-generated hint for a case task, save the form data, and remove the hint from storage. Requires optimistic concurrency control via If-Match header.
         * @summary Approve case task hint
         * @param {CaseHintsApiApproveCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintApprovePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintApprovePost(requestParameters: CaseHintsApiApproveCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintApprovePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CaseTaskHintApproveResponse> {
            return localVarFp.approveCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintApprovePost(requestParameters.caseId, requestParameters.taskKey, requestParameters.ifMatch, requestParameters.caseTaskHintApproveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all generated AI recommendations for a case.
         * @summary Get case hints
         * @param {CaseHintsApiGetCaseHintsApiV1CasesCaseIdHintsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseHintsApiV1CasesCaseIdHintsGet(requestParameters: CaseHintsApiGetCaseHintsApiV1CasesCaseIdHintsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CaseHintsResponse> {
            return localVarFp.getCaseHintsApiV1CasesCaseIdHintsGet(requestParameters.caseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update AI-generated hint (recommendation) for a specific case action. The action_key format is \'{status_key}#{action_key}\' (e.g., \'open#submit\').
         * @summary Patch case action hint
         * @param {CaseHintsApiPatchCaseActionHintApiV1CasesCaseIdActionsActionKeyHintPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCaseActionHintApiV1CasesCaseIdActionsActionKeyHintPatch(requestParameters: CaseHintsApiPatchCaseActionHintApiV1CasesCaseIdActionsActionKeyHintPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<CaseActionHintPatchResponse> {
            return localVarFp.patchCaseActionHintApiV1CasesCaseIdActionsActionKeyHintPatch(requestParameters.caseId, requestParameters.actionKey, requestParameters.caseActionHintPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update AI-generated hint (recommendation) for a specific case task. The task_key format is \'{status_key}#{task_key}\' (e.g., \'open#review_task\').
         * @summary Patch case task hint
         * @param {CaseHintsApiPatchCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintPatch(requestParameters: CaseHintsApiPatchCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<CaseTaskHintPatchResponse> {
            return localVarFp.patchCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintPatch(requestParameters.caseId, requestParameters.taskKey, requestParameters.caseTaskHintPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Dismiss an AI-generated hint for a case action and remove it from storage.
         * @summary Reject case action hint
         * @param {CaseHintsApiRejectCaseActionHintApiV1CasesCaseIdActionsActionKeyHintRejectPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectCaseActionHintApiV1CasesCaseIdActionsActionKeyHintRejectPost(requestParameters: CaseHintsApiRejectCaseActionHintApiV1CasesCaseIdActionsActionKeyHintRejectPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rejectCaseActionHintApiV1CasesCaseIdActionsActionKeyHintRejectPost(requestParameters.caseId, requestParameters.actionKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Dismiss an AI-generated hint for a case task and remove it from storage.
         * @summary Reject case task hint
         * @param {CaseHintsApiRejectCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintRejectPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintRejectPost(requestParameters: CaseHintsApiRejectCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintRejectPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rejectCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintRejectPost(requestParameters.caseId, requestParameters.taskKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for approveCaseActionHintApiV1CasesCaseIdActionsActionKeyHintApprovePost operation in CaseHintsApi.
 * @export
 * @interface CaseHintsApiApproveCaseActionHintApiV1CasesCaseIdActionsActionKeyHintApprovePostRequest
 */
export interface CaseHintsApiApproveCaseActionHintApiV1CasesCaseIdActionsActionKeyHintApprovePostRequest {
    /**
     * The unique identifier of the case (UUID)
     * @type {string}
     * @memberof CaseHintsApiApproveCaseActionHintApiV1CasesCaseIdActionsActionKeyHintApprovePost
     */
    readonly caseId: string

    /**
     * The composite identifier of the action. Format: {status_key}#{action_key} (e.g., \&#39;open#approve\&#39;)
     * @type {string}
     * @memberof CaseHintsApiApproveCaseActionHintApiV1CasesCaseIdActionsActionKeyHintApprovePost
     */
    readonly actionKey: string

    /**
     * ETag value of the form state for optimistic concurrency control (required).
     * @type {string}
     * @memberof CaseHintsApiApproveCaseActionHintApiV1CasesCaseIdActionsActionKeyHintApprovePost
     */
    readonly ifMatch: string

    /**
     * 
     * @type {CaseActionHintApproveRequest}
     * @memberof CaseHintsApiApproveCaseActionHintApiV1CasesCaseIdActionsActionKeyHintApprovePost
     */
    readonly caseActionHintApproveRequest: CaseActionHintApproveRequest
}

/**
 * Request parameters for approveCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintApprovePost operation in CaseHintsApi.
 * @export
 * @interface CaseHintsApiApproveCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintApprovePostRequest
 */
export interface CaseHintsApiApproveCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintApprovePostRequest {
    /**
     * The unique identifier of the case (UUID)
     * @type {string}
     * @memberof CaseHintsApiApproveCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintApprovePost
     */
    readonly caseId: string

    /**
     * The composite identifier of the task. Format: {status_key}#{task_key} (e.g., \&#39;open#review\&#39;)
     * @type {string}
     * @memberof CaseHintsApiApproveCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintApprovePost
     */
    readonly taskKey: string

    /**
     * ETag value of the form state for optimistic concurrency control (required).
     * @type {string}
     * @memberof CaseHintsApiApproveCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintApprovePost
     */
    readonly ifMatch: string

    /**
     * 
     * @type {CaseTaskHintApproveRequest}
     * @memberof CaseHintsApiApproveCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintApprovePost
     */
    readonly caseTaskHintApproveRequest: CaseTaskHintApproveRequest
}

/**
 * Request parameters for getCaseHintsApiV1CasesCaseIdHintsGet operation in CaseHintsApi.
 * @export
 * @interface CaseHintsApiGetCaseHintsApiV1CasesCaseIdHintsGetRequest
 */
export interface CaseHintsApiGetCaseHintsApiV1CasesCaseIdHintsGetRequest {
    /**
     * The unique identifier of the case (UUID)
     * @type {string}
     * @memberof CaseHintsApiGetCaseHintsApiV1CasesCaseIdHintsGet
     */
    readonly caseId: string
}

/**
 * Request parameters for patchCaseActionHintApiV1CasesCaseIdActionsActionKeyHintPatch operation in CaseHintsApi.
 * @export
 * @interface CaseHintsApiPatchCaseActionHintApiV1CasesCaseIdActionsActionKeyHintPatchRequest
 */
export interface CaseHintsApiPatchCaseActionHintApiV1CasesCaseIdActionsActionKeyHintPatchRequest {
    /**
     * The unique identifier of the case (UUID)
     * @type {string}
     * @memberof CaseHintsApiPatchCaseActionHintApiV1CasesCaseIdActionsActionKeyHintPatch
     */
    readonly caseId: string

    /**
     * The composite identifier of the action within the case. Format: {status_key}#{action_key} where status_key is \&#39;status\&#39; or \&#39;status-sub_status\&#39; (e.g., \&#39;open#submit\&#39;, \&#39;pending_review-waiting_docs#review\&#39;)
     * @type {string}
     * @memberof CaseHintsApiPatchCaseActionHintApiV1CasesCaseIdActionsActionKeyHintPatch
     */
    readonly actionKey: string

    /**
     * 
     * @type {CaseActionHintPatchRequest}
     * @memberof CaseHintsApiPatchCaseActionHintApiV1CasesCaseIdActionsActionKeyHintPatch
     */
    readonly caseActionHintPatchRequest: CaseActionHintPatchRequest
}

/**
 * Request parameters for patchCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintPatch operation in CaseHintsApi.
 * @export
 * @interface CaseHintsApiPatchCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintPatchRequest
 */
export interface CaseHintsApiPatchCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintPatchRequest {
    /**
     * The unique identifier of the case (UUID)
     * @type {string}
     * @memberof CaseHintsApiPatchCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintPatch
     */
    readonly caseId: string

    /**
     * The composite identifier of the task within the case. Format: {status_key}#{task_key} where status_key is \&#39;status\&#39; or \&#39;status-sub_status\&#39; (e.g., \&#39;open#review_task\&#39;, \&#39;pending_review-waiting_docs#approve_task\&#39;)
     * @type {string}
     * @memberof CaseHintsApiPatchCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintPatch
     */
    readonly taskKey: string

    /**
     * 
     * @type {CaseTaskHintPatchRequest}
     * @memberof CaseHintsApiPatchCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintPatch
     */
    readonly caseTaskHintPatchRequest: CaseTaskHintPatchRequest
}

/**
 * Request parameters for rejectCaseActionHintApiV1CasesCaseIdActionsActionKeyHintRejectPost operation in CaseHintsApi.
 * @export
 * @interface CaseHintsApiRejectCaseActionHintApiV1CasesCaseIdActionsActionKeyHintRejectPostRequest
 */
export interface CaseHintsApiRejectCaseActionHintApiV1CasesCaseIdActionsActionKeyHintRejectPostRequest {
    /**
     * The unique identifier of the case (UUID)
     * @type {string}
     * @memberof CaseHintsApiRejectCaseActionHintApiV1CasesCaseIdActionsActionKeyHintRejectPost
     */
    readonly caseId: string

    /**
     * The composite identifier of the action. Format: {status_key}#{action_key} (e.g., \&#39;open#approve\&#39;)
     * @type {string}
     * @memberof CaseHintsApiRejectCaseActionHintApiV1CasesCaseIdActionsActionKeyHintRejectPost
     */
    readonly actionKey: string
}

/**
 * Request parameters for rejectCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintRejectPost operation in CaseHintsApi.
 * @export
 * @interface CaseHintsApiRejectCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintRejectPostRequest
 */
export interface CaseHintsApiRejectCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintRejectPostRequest {
    /**
     * The unique identifier of the case (UUID)
     * @type {string}
     * @memberof CaseHintsApiRejectCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintRejectPost
     */
    readonly caseId: string

    /**
     * The composite identifier of the task. Format: {status_key}#{task_key} (e.g., \&#39;open#review\&#39;)
     * @type {string}
     * @memberof CaseHintsApiRejectCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintRejectPost
     */
    readonly taskKey: string
}

/**
 * CaseHintsApi - object-oriented interface
 * @export
 * @class CaseHintsApi
 * @extends {BaseAPI}
 */
export class CaseHintsApi extends BaseAPI {
    /**
     * Accept an AI-generated hint for a case action, save the form data, and remove the hint from storage. Requires optimistic concurrency control via If-Match header.
     * @summary Approve case action hint
     * @param {CaseHintsApiApproveCaseActionHintApiV1CasesCaseIdActionsActionKeyHintApprovePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseHintsApi
     */
    public approveCaseActionHintApiV1CasesCaseIdActionsActionKeyHintApprovePost(requestParameters: CaseHintsApiApproveCaseActionHintApiV1CasesCaseIdActionsActionKeyHintApprovePostRequest, options?: RawAxiosRequestConfig) {
        return CaseHintsApiFp(this.configuration).approveCaseActionHintApiV1CasesCaseIdActionsActionKeyHintApprovePost(requestParameters.caseId, requestParameters.actionKey, requestParameters.ifMatch, requestParameters.caseActionHintApproveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accept an AI-generated hint for a case task, save the form data, and remove the hint from storage. Requires optimistic concurrency control via If-Match header.
     * @summary Approve case task hint
     * @param {CaseHintsApiApproveCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintApprovePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseHintsApi
     */
    public approveCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintApprovePost(requestParameters: CaseHintsApiApproveCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintApprovePostRequest, options?: RawAxiosRequestConfig) {
        return CaseHintsApiFp(this.configuration).approveCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintApprovePost(requestParameters.caseId, requestParameters.taskKey, requestParameters.ifMatch, requestParameters.caseTaskHintApproveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve all generated AI recommendations for a case.
     * @summary Get case hints
     * @param {CaseHintsApiGetCaseHintsApiV1CasesCaseIdHintsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseHintsApi
     */
    public getCaseHintsApiV1CasesCaseIdHintsGet(requestParameters: CaseHintsApiGetCaseHintsApiV1CasesCaseIdHintsGetRequest, options?: RawAxiosRequestConfig) {
        return CaseHintsApiFp(this.configuration).getCaseHintsApiV1CasesCaseIdHintsGet(requestParameters.caseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update AI-generated hint (recommendation) for a specific case action. The action_key format is \'{status_key}#{action_key}\' (e.g., \'open#submit\').
     * @summary Patch case action hint
     * @param {CaseHintsApiPatchCaseActionHintApiV1CasesCaseIdActionsActionKeyHintPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseHintsApi
     */
    public patchCaseActionHintApiV1CasesCaseIdActionsActionKeyHintPatch(requestParameters: CaseHintsApiPatchCaseActionHintApiV1CasesCaseIdActionsActionKeyHintPatchRequest, options?: RawAxiosRequestConfig) {
        return CaseHintsApiFp(this.configuration).patchCaseActionHintApiV1CasesCaseIdActionsActionKeyHintPatch(requestParameters.caseId, requestParameters.actionKey, requestParameters.caseActionHintPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update AI-generated hint (recommendation) for a specific case task. The task_key format is \'{status_key}#{task_key}\' (e.g., \'open#review_task\').
     * @summary Patch case task hint
     * @param {CaseHintsApiPatchCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseHintsApi
     */
    public patchCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintPatch(requestParameters: CaseHintsApiPatchCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintPatchRequest, options?: RawAxiosRequestConfig) {
        return CaseHintsApiFp(this.configuration).patchCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintPatch(requestParameters.caseId, requestParameters.taskKey, requestParameters.caseTaskHintPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Dismiss an AI-generated hint for a case action and remove it from storage.
     * @summary Reject case action hint
     * @param {CaseHintsApiRejectCaseActionHintApiV1CasesCaseIdActionsActionKeyHintRejectPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseHintsApi
     */
    public rejectCaseActionHintApiV1CasesCaseIdActionsActionKeyHintRejectPost(requestParameters: CaseHintsApiRejectCaseActionHintApiV1CasesCaseIdActionsActionKeyHintRejectPostRequest, options?: RawAxiosRequestConfig) {
        return CaseHintsApiFp(this.configuration).rejectCaseActionHintApiV1CasesCaseIdActionsActionKeyHintRejectPost(requestParameters.caseId, requestParameters.actionKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Dismiss an AI-generated hint for a case task and remove it from storage.
     * @summary Reject case task hint
     * @param {CaseHintsApiRejectCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintRejectPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseHintsApi
     */
    public rejectCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintRejectPost(requestParameters: CaseHintsApiRejectCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintRejectPostRequest, options?: RawAxiosRequestConfig) {
        return CaseHintsApiFp(this.configuration).rejectCaseTaskHintApiV1CasesCaseIdTasksTaskKeyHintRejectPost(requestParameters.caseId, requestParameters.taskKey, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CaseTemplatesApi - axios parameter creator
 * @export
 */
export const CaseTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new case template.
         * @summary Create a case template
         * @param {CaseTemplateCreateRequest} caseTemplateCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCaseTemplateApiV1TemplatesPost: async (caseTemplateCreateRequest: CaseTemplateCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseTemplateCreateRequest' is not null or undefined
            assertParamExists('createCaseTemplateApiV1TemplatesPost', 'caseTemplateCreateRequest', caseTemplateCreateRequest)
            const localVarPath = `/api/v1/templates/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(caseTemplateCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Duplicate a case template version with a new name.
         * @summary Duplicate a case template version
         * @param {string} templateId The unique identifier of the template (UUID4)
         * @param {string} versionId The unique identifier of the version to duplicate (UUID4)
         * @param {CaseTemplateVersionDuplicateRequest} caseTemplateVersionDuplicateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdDuplicatePost: async (templateId: string, versionId: string, caseTemplateVersionDuplicateRequest: CaseTemplateVersionDuplicateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('duplicateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdDuplicatePost', 'templateId', templateId)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('duplicateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdDuplicatePost', 'versionId', versionId)
            // verify required parameter 'caseTemplateVersionDuplicateRequest' is not null or undefined
            assertParamExists('duplicateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdDuplicatePost', 'caseTemplateVersionDuplicateRequest', caseTemplateVersionDuplicateRequest)
            const localVarPath = `/api/v1/templates/{template_id}/versions/{version_id}/duplicate`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)))
                .replace(`{${"version_id"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(caseTemplateVersionDuplicateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a case template by id.
         * @summary Get a case template by id
         * @param {string} templateId The unique identifier of the template (UUID4)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseTemplateApiV1TemplatesTemplateIdGet: async (templateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getCaseTemplateApiV1TemplatesTemplateIdGet', 'templateId', templateId)
            const localVarPath = `/api/v1/templates/{template_id}`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a case template version by template id and version id.
         * @summary Get a case template version by id
         * @param {string} templateId The unique identifier of the template (UUID4)
         * @param {string} versionId The unique identifier of the version (UUID4)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdGet: async (templateId: string, versionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdGet', 'templateId', templateId)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('getCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdGet', 'versionId', versionId)
            const localVarPath = `/api/v1/templates/{template_id}/versions/{version_id}`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)))
                .replace(`{${"version_id"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a case template\'s data json schema by template id
         * @param {string} templateId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseTemplateVersionDataJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseDataJsonSchemaGet: async (templateId: string, versionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getCaseTemplateVersionDataJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseDataJsonSchemaGet', 'templateId', templateId)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('getCaseTemplateVersionDataJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseDataJsonSchemaGet', 'versionId', versionId)
            const localVarPath = `/api/v1/templates/{template_id}/versions/{version_id}/case_data_json_schema`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)))
                .replace(`{${"version_id"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a case template\'s input json schema by template id
         * @param {string} templateId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseTemplateVersionInputJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseJsonSchemaGet: async (templateId: string, versionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getCaseTemplateVersionInputJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseJsonSchemaGet', 'templateId', templateId)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('getCaseTemplateVersionInputJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseJsonSchemaGet', 'versionId', versionId)
            const localVarPath = `/api/v1/templates/{template_id}/versions/{version_id}/case_json_schema`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)))
                .replace(`{${"version_id"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all case templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseTemplatesApiV1TemplatesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/templates/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update case template metadata with optimistic locking.
         * @summary Update case template metadata
         * @param {string} templateId The unique identifier of the template (UUID4)
         * @param {CaseTemplateMetadataUpdateRequest} caseTemplateMetadataUpdateRequest 
         * @param {string | null} [ifMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCaseTemplateMetadataApiV1TemplatesTemplateIdPut: async (templateId: string, caseTemplateMetadataUpdateRequest: CaseTemplateMetadataUpdateRequest, ifMatch?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('updateCaseTemplateMetadataApiV1TemplatesTemplateIdPut', 'templateId', templateId)
            // verify required parameter 'caseTemplateMetadataUpdateRequest' is not null or undefined
            assertParamExists('updateCaseTemplateMetadataApiV1TemplatesTemplateIdPut', 'caseTemplateMetadataUpdateRequest', caseTemplateMetadataUpdateRequest)
            const localVarPath = `/api/v1/templates/{template_id}`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(caseTemplateMetadataUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a case template version with optimistic locking.
         * @summary Patch a case template version
         * @param {string} templateId The unique identifier of the template (UUID4)
         * @param {string} versionId The unique identifier of the version (UUID4)
         * @param {CaseTemplateVersionUpdateRequest} caseTemplateVersionUpdateRequest 
         * @param {string | null} [ifMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdPatch: async (templateId: string, versionId: string, caseTemplateVersionUpdateRequest: CaseTemplateVersionUpdateRequest, ifMatch?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('updateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdPatch', 'templateId', templateId)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('updateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdPatch', 'versionId', versionId)
            // verify required parameter 'caseTemplateVersionUpdateRequest' is not null or undefined
            assertParamExists('updateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdPatch', 'caseTemplateVersionUpdateRequest', caseTemplateVersionUpdateRequest)
            const localVarPath = `/api/v1/templates/{template_id}/versions/{version_id}`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)))
                .replace(`{${"version_id"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(caseTemplateVersionUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CaseTemplatesApi - functional programming interface
 * @export
 */
export const CaseTemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CaseTemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new case template.
         * @summary Create a case template
         * @param {CaseTemplateCreateRequest} caseTemplateCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCaseTemplateApiV1TemplatesPost(caseTemplateCreateRequest: CaseTemplateCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCaseTemplateApiV1TemplatesPost(caseTemplateCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseTemplatesApi.createCaseTemplateApiV1TemplatesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Duplicate a case template version with a new name.
         * @summary Duplicate a case template version
         * @param {string} templateId The unique identifier of the template (UUID4)
         * @param {string} versionId The unique identifier of the version to duplicate (UUID4)
         * @param {CaseTemplateVersionDuplicateRequest} caseTemplateVersionDuplicateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdDuplicatePost(templateId: string, versionId: string, caseTemplateVersionDuplicateRequest: CaseTemplateVersionDuplicateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseTemplateVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdDuplicatePost(templateId, versionId, caseTemplateVersionDuplicateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseTemplatesApi.duplicateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdDuplicatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a case template by id.
         * @summary Get a case template by id
         * @param {string} templateId The unique identifier of the template (UUID4)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCaseTemplateApiV1TemplatesTemplateIdGet(templateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCaseTemplateApiV1TemplatesTemplateIdGet(templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseTemplatesApi.getCaseTemplateApiV1TemplatesTemplateIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a case template version by template id and version id.
         * @summary Get a case template version by id
         * @param {string} templateId The unique identifier of the template (UUID4)
         * @param {string} versionId The unique identifier of the version (UUID4)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdGet(templateId: string, versionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseTemplateVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdGet(templateId, versionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseTemplatesApi.getCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a case template\'s data json schema by template id
         * @param {string} templateId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCaseTemplateVersionDataJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseDataJsonSchemaGet(templateId: string, versionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseTemplateJsonSchemaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCaseTemplateVersionDataJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseDataJsonSchemaGet(templateId, versionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseTemplatesApi.getCaseTemplateVersionDataJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseDataJsonSchemaGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a case template\'s input json schema by template id
         * @param {string} templateId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCaseTemplateVersionInputJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseJsonSchemaGet(templateId: string, versionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseTemplateJsonSchemaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCaseTemplateVersionInputJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseJsonSchemaGet(templateId, versionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseTemplatesApi.getCaseTemplateVersionInputJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseJsonSchemaGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all case templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCaseTemplatesApiV1TemplatesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseTemplatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCaseTemplatesApiV1TemplatesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseTemplatesApi.getCaseTemplatesApiV1TemplatesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update case template metadata with optimistic locking.
         * @summary Update case template metadata
         * @param {string} templateId The unique identifier of the template (UUID4)
         * @param {CaseTemplateMetadataUpdateRequest} caseTemplateMetadataUpdateRequest 
         * @param {string | null} [ifMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCaseTemplateMetadataApiV1TemplatesTemplateIdPut(templateId: string, caseTemplateMetadataUpdateRequest: CaseTemplateMetadataUpdateRequest, ifMatch?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCaseTemplateMetadataApiV1TemplatesTemplateIdPut(templateId, caseTemplateMetadataUpdateRequest, ifMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseTemplatesApi.updateCaseTemplateMetadataApiV1TemplatesTemplateIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a case template version with optimistic locking.
         * @summary Patch a case template version
         * @param {string} templateId The unique identifier of the template (UUID4)
         * @param {string} versionId The unique identifier of the version (UUID4)
         * @param {CaseTemplateVersionUpdateRequest} caseTemplateVersionUpdateRequest 
         * @param {string | null} [ifMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdPatch(templateId: string, versionId: string, caseTemplateVersionUpdateRequest: CaseTemplateVersionUpdateRequest, ifMatch?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseTemplateVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdPatch(templateId, versionId, caseTemplateVersionUpdateRequest, ifMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseTemplatesApi.updateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CaseTemplatesApi - factory interface
 * @export
 */
export const CaseTemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CaseTemplatesApiFp(configuration)
    return {
        /**
         * Create a new case template.
         * @summary Create a case template
         * @param {CaseTemplatesApiCreateCaseTemplateApiV1TemplatesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCaseTemplateApiV1TemplatesPost(requestParameters: CaseTemplatesApiCreateCaseTemplateApiV1TemplatesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CaseTemplateResponse> {
            return localVarFp.createCaseTemplateApiV1TemplatesPost(requestParameters.caseTemplateCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Duplicate a case template version with a new name.
         * @summary Duplicate a case template version
         * @param {CaseTemplatesApiDuplicateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdDuplicatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdDuplicatePost(requestParameters: CaseTemplatesApiDuplicateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdDuplicatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CaseTemplateVersionResponse> {
            return localVarFp.duplicateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdDuplicatePost(requestParameters.templateId, requestParameters.versionId, requestParameters.caseTemplateVersionDuplicateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a case template by id.
         * @summary Get a case template by id
         * @param {CaseTemplatesApiGetCaseTemplateApiV1TemplatesTemplateIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseTemplateApiV1TemplatesTemplateIdGet(requestParameters: CaseTemplatesApiGetCaseTemplateApiV1TemplatesTemplateIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CaseTemplateResponse> {
            return localVarFp.getCaseTemplateApiV1TemplatesTemplateIdGet(requestParameters.templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a case template version by template id and version id.
         * @summary Get a case template version by id
         * @param {CaseTemplatesApiGetCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdGet(requestParameters: CaseTemplatesApiGetCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CaseTemplateVersionResponse> {
            return localVarFp.getCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdGet(requestParameters.templateId, requestParameters.versionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a case template\'s data json schema by template id
         * @param {CaseTemplatesApiGetCaseTemplateVersionDataJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseDataJsonSchemaGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseTemplateVersionDataJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseDataJsonSchemaGet(requestParameters: CaseTemplatesApiGetCaseTemplateVersionDataJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseDataJsonSchemaGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CaseTemplateJsonSchemaResponse> {
            return localVarFp.getCaseTemplateVersionDataJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseDataJsonSchemaGet(requestParameters.templateId, requestParameters.versionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a case template\'s input json schema by template id
         * @param {CaseTemplatesApiGetCaseTemplateVersionInputJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseJsonSchemaGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseTemplateVersionInputJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseJsonSchemaGet(requestParameters: CaseTemplatesApiGetCaseTemplateVersionInputJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseJsonSchemaGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CaseTemplateJsonSchemaResponse> {
            return localVarFp.getCaseTemplateVersionInputJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseJsonSchemaGet(requestParameters.templateId, requestParameters.versionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all case templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseTemplatesApiV1TemplatesGet(options?: RawAxiosRequestConfig): AxiosPromise<CaseTemplatesResponse> {
            return localVarFp.getCaseTemplatesApiV1TemplatesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Update case template metadata with optimistic locking.
         * @summary Update case template metadata
         * @param {CaseTemplatesApiUpdateCaseTemplateMetadataApiV1TemplatesTemplateIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCaseTemplateMetadataApiV1TemplatesTemplateIdPut(requestParameters: CaseTemplatesApiUpdateCaseTemplateMetadataApiV1TemplatesTemplateIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CaseTemplateResponse> {
            return localVarFp.updateCaseTemplateMetadataApiV1TemplatesTemplateIdPut(requestParameters.templateId, requestParameters.caseTemplateMetadataUpdateRequest, requestParameters.ifMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a case template version with optimistic locking.
         * @summary Patch a case template version
         * @param {CaseTemplatesApiUpdateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdPatch(requestParameters: CaseTemplatesApiUpdateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<CaseTemplateVersionResponse> {
            return localVarFp.updateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdPatch(requestParameters.templateId, requestParameters.versionId, requestParameters.caseTemplateVersionUpdateRequest, requestParameters.ifMatch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createCaseTemplateApiV1TemplatesPost operation in CaseTemplatesApi.
 * @export
 * @interface CaseTemplatesApiCreateCaseTemplateApiV1TemplatesPostRequest
 */
export interface CaseTemplatesApiCreateCaseTemplateApiV1TemplatesPostRequest {
    /**
     * 
     * @type {CaseTemplateCreateRequest}
     * @memberof CaseTemplatesApiCreateCaseTemplateApiV1TemplatesPost
     */
    readonly caseTemplateCreateRequest: CaseTemplateCreateRequest
}

/**
 * Request parameters for duplicateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdDuplicatePost operation in CaseTemplatesApi.
 * @export
 * @interface CaseTemplatesApiDuplicateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdDuplicatePostRequest
 */
export interface CaseTemplatesApiDuplicateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdDuplicatePostRequest {
    /**
     * The unique identifier of the template (UUID4)
     * @type {string}
     * @memberof CaseTemplatesApiDuplicateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdDuplicatePost
     */
    readonly templateId: string

    /**
     * The unique identifier of the version to duplicate (UUID4)
     * @type {string}
     * @memberof CaseTemplatesApiDuplicateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdDuplicatePost
     */
    readonly versionId: string

    /**
     * 
     * @type {CaseTemplateVersionDuplicateRequest}
     * @memberof CaseTemplatesApiDuplicateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdDuplicatePost
     */
    readonly caseTemplateVersionDuplicateRequest: CaseTemplateVersionDuplicateRequest
}

/**
 * Request parameters for getCaseTemplateApiV1TemplatesTemplateIdGet operation in CaseTemplatesApi.
 * @export
 * @interface CaseTemplatesApiGetCaseTemplateApiV1TemplatesTemplateIdGetRequest
 */
export interface CaseTemplatesApiGetCaseTemplateApiV1TemplatesTemplateIdGetRequest {
    /**
     * The unique identifier of the template (UUID4)
     * @type {string}
     * @memberof CaseTemplatesApiGetCaseTemplateApiV1TemplatesTemplateIdGet
     */
    readonly templateId: string
}

/**
 * Request parameters for getCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdGet operation in CaseTemplatesApi.
 * @export
 * @interface CaseTemplatesApiGetCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdGetRequest
 */
export interface CaseTemplatesApiGetCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdGetRequest {
    /**
     * The unique identifier of the template (UUID4)
     * @type {string}
     * @memberof CaseTemplatesApiGetCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdGet
     */
    readonly templateId: string

    /**
     * The unique identifier of the version (UUID4)
     * @type {string}
     * @memberof CaseTemplatesApiGetCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdGet
     */
    readonly versionId: string
}

/**
 * Request parameters for getCaseTemplateVersionDataJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseDataJsonSchemaGet operation in CaseTemplatesApi.
 * @export
 * @interface CaseTemplatesApiGetCaseTemplateVersionDataJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseDataJsonSchemaGetRequest
 */
export interface CaseTemplatesApiGetCaseTemplateVersionDataJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseDataJsonSchemaGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CaseTemplatesApiGetCaseTemplateVersionDataJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseDataJsonSchemaGet
     */
    readonly templateId: string

    /**
     * 
     * @type {string}
     * @memberof CaseTemplatesApiGetCaseTemplateVersionDataJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseDataJsonSchemaGet
     */
    readonly versionId: string
}

/**
 * Request parameters for getCaseTemplateVersionInputJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseJsonSchemaGet operation in CaseTemplatesApi.
 * @export
 * @interface CaseTemplatesApiGetCaseTemplateVersionInputJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseJsonSchemaGetRequest
 */
export interface CaseTemplatesApiGetCaseTemplateVersionInputJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseJsonSchemaGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CaseTemplatesApiGetCaseTemplateVersionInputJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseJsonSchemaGet
     */
    readonly templateId: string

    /**
     * 
     * @type {string}
     * @memberof CaseTemplatesApiGetCaseTemplateVersionInputJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseJsonSchemaGet
     */
    readonly versionId: string
}

/**
 * Request parameters for updateCaseTemplateMetadataApiV1TemplatesTemplateIdPut operation in CaseTemplatesApi.
 * @export
 * @interface CaseTemplatesApiUpdateCaseTemplateMetadataApiV1TemplatesTemplateIdPutRequest
 */
export interface CaseTemplatesApiUpdateCaseTemplateMetadataApiV1TemplatesTemplateIdPutRequest {
    /**
     * The unique identifier of the template (UUID4)
     * @type {string}
     * @memberof CaseTemplatesApiUpdateCaseTemplateMetadataApiV1TemplatesTemplateIdPut
     */
    readonly templateId: string

    /**
     * 
     * @type {CaseTemplateMetadataUpdateRequest}
     * @memberof CaseTemplatesApiUpdateCaseTemplateMetadataApiV1TemplatesTemplateIdPut
     */
    readonly caseTemplateMetadataUpdateRequest: CaseTemplateMetadataUpdateRequest

    /**
     * 
     * @type {string}
     * @memberof CaseTemplatesApiUpdateCaseTemplateMetadataApiV1TemplatesTemplateIdPut
     */
    readonly ifMatch?: string | null
}

/**
 * Request parameters for updateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdPatch operation in CaseTemplatesApi.
 * @export
 * @interface CaseTemplatesApiUpdateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdPatchRequest
 */
export interface CaseTemplatesApiUpdateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdPatchRequest {
    /**
     * The unique identifier of the template (UUID4)
     * @type {string}
     * @memberof CaseTemplatesApiUpdateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdPatch
     */
    readonly templateId: string

    /**
     * The unique identifier of the version (UUID4)
     * @type {string}
     * @memberof CaseTemplatesApiUpdateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdPatch
     */
    readonly versionId: string

    /**
     * 
     * @type {CaseTemplateVersionUpdateRequest}
     * @memberof CaseTemplatesApiUpdateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdPatch
     */
    readonly caseTemplateVersionUpdateRequest: CaseTemplateVersionUpdateRequest

    /**
     * 
     * @type {string}
     * @memberof CaseTemplatesApiUpdateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdPatch
     */
    readonly ifMatch?: string | null
}

/**
 * CaseTemplatesApi - object-oriented interface
 * @export
 * @class CaseTemplatesApi
 * @extends {BaseAPI}
 */
export class CaseTemplatesApi extends BaseAPI {
    /**
     * Create a new case template.
     * @summary Create a case template
     * @param {CaseTemplatesApiCreateCaseTemplateApiV1TemplatesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseTemplatesApi
     */
    public createCaseTemplateApiV1TemplatesPost(requestParameters: CaseTemplatesApiCreateCaseTemplateApiV1TemplatesPostRequest, options?: RawAxiosRequestConfig) {
        return CaseTemplatesApiFp(this.configuration).createCaseTemplateApiV1TemplatesPost(requestParameters.caseTemplateCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Duplicate a case template version with a new name.
     * @summary Duplicate a case template version
     * @param {CaseTemplatesApiDuplicateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdDuplicatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseTemplatesApi
     */
    public duplicateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdDuplicatePost(requestParameters: CaseTemplatesApiDuplicateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdDuplicatePostRequest, options?: RawAxiosRequestConfig) {
        return CaseTemplatesApiFp(this.configuration).duplicateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdDuplicatePost(requestParameters.templateId, requestParameters.versionId, requestParameters.caseTemplateVersionDuplicateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a case template by id.
     * @summary Get a case template by id
     * @param {CaseTemplatesApiGetCaseTemplateApiV1TemplatesTemplateIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseTemplatesApi
     */
    public getCaseTemplateApiV1TemplatesTemplateIdGet(requestParameters: CaseTemplatesApiGetCaseTemplateApiV1TemplatesTemplateIdGetRequest, options?: RawAxiosRequestConfig) {
        return CaseTemplatesApiFp(this.configuration).getCaseTemplateApiV1TemplatesTemplateIdGet(requestParameters.templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a case template version by template id and version id.
     * @summary Get a case template version by id
     * @param {CaseTemplatesApiGetCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseTemplatesApi
     */
    public getCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdGet(requestParameters: CaseTemplatesApiGetCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdGetRequest, options?: RawAxiosRequestConfig) {
        return CaseTemplatesApiFp(this.configuration).getCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdGet(requestParameters.templateId, requestParameters.versionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a case template\'s data json schema by template id
     * @param {CaseTemplatesApiGetCaseTemplateVersionDataJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseDataJsonSchemaGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseTemplatesApi
     */
    public getCaseTemplateVersionDataJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseDataJsonSchemaGet(requestParameters: CaseTemplatesApiGetCaseTemplateVersionDataJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseDataJsonSchemaGetRequest, options?: RawAxiosRequestConfig) {
        return CaseTemplatesApiFp(this.configuration).getCaseTemplateVersionDataJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseDataJsonSchemaGet(requestParameters.templateId, requestParameters.versionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a case template\'s input json schema by template id
     * @param {CaseTemplatesApiGetCaseTemplateVersionInputJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseJsonSchemaGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseTemplatesApi
     */
    public getCaseTemplateVersionInputJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseJsonSchemaGet(requestParameters: CaseTemplatesApiGetCaseTemplateVersionInputJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseJsonSchemaGetRequest, options?: RawAxiosRequestConfig) {
        return CaseTemplatesApiFp(this.configuration).getCaseTemplateVersionInputJsonSchemaApiV1TemplatesTemplateIdVersionsVersionIdCaseJsonSchemaGet(requestParameters.templateId, requestParameters.versionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all case templates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseTemplatesApi
     */
    public getCaseTemplatesApiV1TemplatesGet(options?: RawAxiosRequestConfig) {
        return CaseTemplatesApiFp(this.configuration).getCaseTemplatesApiV1TemplatesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update case template metadata with optimistic locking.
     * @summary Update case template metadata
     * @param {CaseTemplatesApiUpdateCaseTemplateMetadataApiV1TemplatesTemplateIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseTemplatesApi
     */
    public updateCaseTemplateMetadataApiV1TemplatesTemplateIdPut(requestParameters: CaseTemplatesApiUpdateCaseTemplateMetadataApiV1TemplatesTemplateIdPutRequest, options?: RawAxiosRequestConfig) {
        return CaseTemplatesApiFp(this.configuration).updateCaseTemplateMetadataApiV1TemplatesTemplateIdPut(requestParameters.templateId, requestParameters.caseTemplateMetadataUpdateRequest, requestParameters.ifMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a case template version with optimistic locking.
     * @summary Patch a case template version
     * @param {CaseTemplatesApiUpdateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseTemplatesApi
     */
    public updateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdPatch(requestParameters: CaseTemplatesApiUpdateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdPatchRequest, options?: RawAxiosRequestConfig) {
        return CaseTemplatesApiFp(this.configuration).updateCaseTemplateVersionApiV1TemplatesTemplateIdVersionsVersionIdPatch(requestParameters.templateId, requestParameters.versionId, requestParameters.caseTemplateVersionUpdateRequest, requestParameters.ifMatch, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CasesApi - axios parameter creator
 * @export
 */
export const CasesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Apply atomic operations to a file category.
         * @summary Apply atomic operations to a file category
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {FileCategoriesAtomicOperationsRequest} fileCategoriesAtomicOperationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyAtomicFileCategoryOperationsApiV1CasesCaseIdFileCategoriesOperationsPost: async (caseId: string, fileCategoriesAtomicOperationsRequest: FileCategoriesAtomicOperationsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('applyAtomicFileCategoryOperationsApiV1CasesCaseIdFileCategoriesOperationsPost', 'caseId', caseId)
            // verify required parameter 'fileCategoriesAtomicOperationsRequest' is not null or undefined
            assertParamExists('applyAtomicFileCategoryOperationsApiV1CasesCaseIdFileCategoriesOperationsPost', 'fileCategoriesAtomicOperationsRequest', fileCategoriesAtomicOperationsRequest)
            const localVarPath = `/api/v1/cases/{case_id}/file_categories/operations`
                .replace(`{${"case_id"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileCategoriesAtomicOperationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Supports multiple \'update\' operations on the same case in a single request. Allowed targets: to-one relationships \'queue\' and \'assignee\', \'case_properties\' relationship (attributes map), \'case_block_data.{block_key}\' relationship for markdown and table blocks, \'case_block_config.{block_key}\' relationships for entities viewer blocks, \'case_action_forms\' for updating action form data, and \'case_task_forms\' for updating task form data.
         * @summary Apply atomic operations on a case (relationships and properties)
         * @param {string} id The unique identifier of the case (UUID4)
         * @param {CaseAtomicOperationsRequest} caseAtomicOperationsRequest 
         * @param {string | null} [runningActionID] Optional running action ID to mark action as success
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyAtomicOperationsApiV1CasesIdOperationsPost: async (id: string, caseAtomicOperationsRequest: CaseAtomicOperationsRequest, runningActionID?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('applyAtomicOperationsApiV1CasesIdOperationsPost', 'id', id)
            // verify required parameter 'caseAtomicOperationsRequest' is not null or undefined
            assertParamExists('applyAtomicOperationsApiV1CasesIdOperationsPost', 'caseAtomicOperationsRequest', caseAtomicOperationsRequest)
            const localVarPath = `/api/v1/cases/{id}/operations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (runningActionID != null) {
                localVarHeaderParameter['RunningActionID'] = String(runningActionID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(caseAtomicOperationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Supports multiple \'update\' operations across cases using JSON:API Atomic. - Assign - Archive - Run Action (execute case actions in bulk)
         * @summary Apply atomic operations across cases of the same queue
         * @param {string} queueId 
         * @param {CaseBulkAtomicOperationsRequest} caseBulkAtomicOperationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyBulkAtomicOperationsApiV1CasesOperationsQueueQueueIdPost: async (queueId: string, caseBulkAtomicOperationsRequest: CaseBulkAtomicOperationsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'queueId' is not null or undefined
            assertParamExists('applyBulkAtomicOperationsApiV1CasesOperationsQueueQueueIdPost', 'queueId', queueId)
            // verify required parameter 'caseBulkAtomicOperationsRequest' is not null or undefined
            assertParamExists('applyBulkAtomicOperationsApiV1CasesOperationsQueueQueueIdPost', 'caseBulkAtomicOperationsRequest', caseBulkAtomicOperationsRequest)
            const localVarPath = `/api/v1/cases/operations/queue/{queue_id}`
                .replace(`{${"queue_id"}}`, encodeURIComponent(String(queueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(caseBulkAtomicOperationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a case: - Validate case data against template version\'s input JSON schema - Send create case message to SQS
         * @summary Create a case from a template version
         * @param {string} idempotencyKey UUID v4 idempotency key to ensure exactly-once case creation
         * @param {CaseCreateRequest} caseCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCaseApiV1CasesPost: async (idempotencyKey: string, caseCreateRequest: CaseCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idempotencyKey' is not null or undefined
            assertParamExists('createCaseApiV1CasesPost', 'idempotencyKey', idempotencyKey)
            // verify required parameter 'caseCreateRequest' is not null or undefined
            assertParamExists('createCaseApiV1CasesPost', 'caseCreateRequest', caseCreateRequest)
            const localVarPath = `/api/v1/cases/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(caseCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a comment for a case that will be added to the case history
         * @summary Create a case comment
         * @param {string} caseId The unique identifier of the case (UUID7)
         * @param {CaseCommentCreateRequest} caseCommentCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCaseCommentApiV1CasesCaseIdCommentsPost: async (caseId: string, caseCommentCreateRequest: CaseCommentCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('createCaseCommentApiV1CasesCaseIdCommentsPost', 'caseId', caseId)
            // verify required parameter 'caseCommentCreateRequest' is not null or undefined
            assertParamExists('createCaseCommentApiV1CasesCaseIdCommentsPost', 'caseCommentCreateRequest', caseCommentCreateRequest)
            const localVarPath = `/api/v1/cases/{case_id}/comments`
                .replace(`{${"case_id"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(caseCommentCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Dismiss a specific running action for a case by removing it. Can only dismiss actions in FAILED state.
         * @summary Dismiss a running action
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {string} runningActionId The unique identifier of the running action (UUID)
         * @param {string} ifMatch ETag value for optimistic concurrency control. Required.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdDismissPost: async (caseId: string, runningActionId: string, ifMatch: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('dismissCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdDismissPost', 'caseId', caseId)
            // verify required parameter 'runningActionId' is not null or undefined
            assertParamExists('dismissCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdDismissPost', 'runningActionId', runningActionId)
            // verify required parameter 'ifMatch' is not null or undefined
            assertParamExists('dismissCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdDismissPost', 'ifMatch', ifMatch)
            const localVarPath = `/api/v1/cases/{case_id}/running_actions/{running_action_id}/dismiss`
                .replace(`{${"case_id"}}`, encodeURIComponent(String(caseId)))
                .replace(`{${"running_action_id"}}`, encodeURIComponent(String(runningActionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            if (ifMatch != null) {
                localVarHeaderParameter['If-Match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a case by id
         * @param {string} id The unique identifier of the case (UUID7)
         * @param {string | null} [include] Comma-separated list of related resources to include. Supported paths: \&#39;case_blocks.external_data\&#39; to include external data for all entity details blocks
         * @param {string | null} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseApiV1CasesIdGet: async (id: string, include?: string | null, ifNoneMatch?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCaseApiV1CasesIdGet', 'id', id)
            const localVarPath = `/api/v1/cases/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }


    
            if (ifNoneMatch != null) {
                localVarHeaderParameter['if-none-match'] = String(ifNoneMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve paginated case history events for a specific case. Returns a chronological timeline of all events that occurred during the case lifecycle. Supports cursor-based pagination and sorting by timestamp using JSON:API conventions.
         * @summary Get case history events with pagination
         * @param {string} caseId The unique identifier of the case (UUID7)
         * @param {number} [pageSize] Number of history events to return (1-200). Default: 15 events
         * @param {string | null} [pageCursor] Pagination cursor in format \&#39;timestamp,event_id\&#39; (e.g., \&#39;2024-01-15T14:30:00Z,event-abc123\&#39;). Use the cursor from the previous response\&#39;s links.next to get the next page. Start without a cursor to get the first page.
         * @param {GetCaseHistoryApiV1CasesCaseIdHistoryGetPageDirectionEnum} [pageDirection] Pagination direction. \&#39;backward\&#39; (default): Most recent events first, paginate towards older events. \&#39;forward\&#39;: Oldest events first, paginate towards newer events.
         * @param {string | null} [sort] Sort order: Only \&#39;timestamp\&#39; (ascending) is supported to guarantee ordered results. Pagination direction is controlled by the page[direction] parameter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseHistoryApiV1CasesCaseIdHistoryGet: async (caseId: string, pageSize?: number, pageCursor?: string | null, pageDirection?: GetCaseHistoryApiV1CasesCaseIdHistoryGetPageDirectionEnum, sort?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('getCaseHistoryApiV1CasesCaseIdHistoryGet', 'caseId', caseId)
            const localVarPath = `/api/v1/cases/{case_id}/history`
                .replace(`{${"case_id"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (pageSize !== undefined) {
                localVarQueryParameter['page[size]'] = pageSize;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page[cursor]'] = pageCursor;
            }

            if (pageDirection !== undefined) {
                localVarQueryParameter['page[direction]'] = pageDirection;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find cases with applied property filters. Supports filtering by any template properties using exact match or contains operations. Supports cursor-based pagination and sorting by creation date.
         * @summary List cases with property filters
         * @param {GetCasesApiV1CasesGetFilterEnvEnum} filterEnv 
         * @param {string | null} [sort] Sort order: \&#39;created_at\&#39; or \&#39;-created_at\&#39;
         * @param {number} [pageSize] Maximum number of related cases to return
         * @param {string | null} [pageCursor] Cursor for pagination
         * @param {string | null} [filterColumnEntityType] Filter by entity type in template properties
         * @param {string | null} [filterCreatedAtGt] 
         * @param {string | null} [filterCreatedAtGte] 
         * @param {string | null} [filterCreatedAtLt] 
         * @param {string | null} [filterCreatedAtLte] 
         * @param {string | null} [filterUpdatedAtGt] 
         * @param {string | null} [filterUpdatedAtGte] 
         * @param {string | null} [filterUpdatedAtLt] 
         * @param {string | null} [filterUpdatedAtLte] 
         * @param {{ [key: string]: any; }} [filterProperties]  Dynamic property filters using the pattern &#x60;filter[properties][property_name]&#x3D;value&#x60;.  **How It Works:** - Filter cases by any properties stored in the case\&#39;s JSONB properties field - Each case template defines its own set of properties - You can filter on any property that exists in your case data - Uses exact match by default  **Examples:** - &#x60;filter[properties][status]&#x3D;open&#x60; - Cases with status \&quot;open\&quot; - &#x60;filter[properties][customer]&#x3D;customer123&#x60; - Cases where customer equals \&quot;customer123\&quot; - &#x60;filter[properties][priority]&#x3D;high&#x60; - Cases with priority \&quot;high\&quot;  **Note:** All property values are treated as strings for filtering purposes.                 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCasesApiV1CasesGet: async (filterEnv: GetCasesApiV1CasesGetFilterEnvEnum, sort?: string | null, pageSize?: number, pageCursor?: string | null, filterColumnEntityType?: string | null, filterCreatedAtGt?: string | null, filterCreatedAtGte?: string | null, filterCreatedAtLt?: string | null, filterCreatedAtLte?: string | null, filterUpdatedAtGt?: string | null, filterUpdatedAtGte?: string | null, filterUpdatedAtLt?: string | null, filterUpdatedAtLte?: string | null, filterProperties?: { [key: string]: any; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filterEnv' is not null or undefined
            assertParamExists('getCasesApiV1CasesGet', 'filterEnv', filterEnv)
            const localVarPath = `/api/v1/cases/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (filterEnv !== undefined) {
                localVarQueryParameter['filter[env]'] = filterEnv;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page[size]'] = pageSize;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page[cursor]'] = pageCursor;
            }

            if (filterColumnEntityType !== undefined) {
                localVarQueryParameter['filter[column_entity_type]'] = filterColumnEntityType;
            }

            if (filterCreatedAtGt !== undefined) {
                localVarQueryParameter['filter[created_at][gt]'] = (filterCreatedAtGt as any instanceof Date) ?
                    (filterCreatedAtGt as any).toISOString() :
                    filterCreatedAtGt;
            }

            if (filterCreatedAtGte !== undefined) {
                localVarQueryParameter['filter[created_at][gte]'] = (filterCreatedAtGte as any instanceof Date) ?
                    (filterCreatedAtGte as any).toISOString() :
                    filterCreatedAtGte;
            }

            if (filterCreatedAtLt !== undefined) {
                localVarQueryParameter['filter[created_at][lt]'] = (filterCreatedAtLt as any instanceof Date) ?
                    (filterCreatedAtLt as any).toISOString() :
                    filterCreatedAtLt;
            }

            if (filterCreatedAtLte !== undefined) {
                localVarQueryParameter['filter[created_at][lte]'] = (filterCreatedAtLte as any instanceof Date) ?
                    (filterCreatedAtLte as any).toISOString() :
                    filterCreatedAtLte;
            }

            if (filterUpdatedAtGt !== undefined) {
                localVarQueryParameter['filter[updated_at][gt]'] = (filterUpdatedAtGt as any instanceof Date) ?
                    (filterUpdatedAtGt as any).toISOString() :
                    filterUpdatedAtGt;
            }

            if (filterUpdatedAtGte !== undefined) {
                localVarQueryParameter['filter[updated_at][gte]'] = (filterUpdatedAtGte as any instanceof Date) ?
                    (filterUpdatedAtGte as any).toISOString() :
                    filterUpdatedAtGte;
            }

            if (filterUpdatedAtLt !== undefined) {
                localVarQueryParameter['filter[updated_at][lt]'] = (filterUpdatedAtLt as any instanceof Date) ?
                    (filterUpdatedAtLt as any).toISOString() :
                    filterUpdatedAtLt;
            }

            if (filterUpdatedAtLte !== undefined) {
                localVarQueryParameter['filter[updated_at][lte]'] = (filterUpdatedAtLte as any instanceof Date) ?
                    (filterUpdatedAtLte as any).toISOString() :
                    filterUpdatedAtLte;
            }

            if (filterProperties !== undefined) {
                for (const [key, value] of Object.entries(filterProperties)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update form data for a specific case action. Requires optimistic concurrency control via If-Match header.
         * @summary Patch case action form state
         * @param {string} id The unique identifier of the case (UUID7)
         * @param {string} actionId The composite identifier of the action within the case. Format: {status_key}#{action_key} where status_key is \&#39;status\&#39; or \&#39;status-sub_status\&#39; (e.g., \&#39;open#submit\&#39;, \&#39;pending_review-waiting_docs#review\&#39;)
         * @param {string} ifMatch ETag value for optimistic concurrency control (required).
         * @param {CaseActionFormPatchRequest} caseActionFormPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCaseActionFormStateApiV1CasesIdActionActionIdFormStatePatch: async (id: string, actionId: string, ifMatch: string, caseActionFormPatchRequest: CaseActionFormPatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchCaseActionFormStateApiV1CasesIdActionActionIdFormStatePatch', 'id', id)
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('patchCaseActionFormStateApiV1CasesIdActionActionIdFormStatePatch', 'actionId', actionId)
            // verify required parameter 'ifMatch' is not null or undefined
            assertParamExists('patchCaseActionFormStateApiV1CasesIdActionActionIdFormStatePatch', 'ifMatch', ifMatch)
            // verify required parameter 'caseActionFormPatchRequest' is not null or undefined
            assertParamExists('patchCaseActionFormStateApiV1CasesIdActionActionIdFormStatePatch', 'caseActionFormPatchRequest', caseActionFormPatchRequest)
            const localVarPath = `/api/v1/cases/{id}/action/{action_id}/form_state`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"action_id"}}`, encodeURIComponent(String(actionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(caseActionFormPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update queue and/or assignee relationships of a case. Supports optional optimistic concurrency control via If-Match header. If If-Match header is not provided, last-write-wins semantics apply.
         * @summary Patch case queue and/or assignee relationships
         * @param {string} id The unique identifier of the case (UUID4)
         * @param {CasePatchRequest} casePatchRequest 
         * @param {string | null} [include] Comma-separated list of related resources to include. Supported paths: \&#39;case_blocks.external_data\&#39; to include external data for all entity details blocks
         * @param {string | null} [ifMatch] ETag value for optimistic concurrency control. If not provided, last-write-wins semantics apply.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCaseApiV1CasesIdPatch: async (id: string, casePatchRequest: CasePatchRequest, include?: string | null, ifMatch?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchCaseApiV1CasesIdPatch', 'id', id)
            // verify required parameter 'casePatchRequest' is not null or undefined
            assertParamExists('patchCaseApiV1CasesIdPatch', 'casePatchRequest', casePatchRequest)
            const localVarPath = `/api/v1/cases/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(casePatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the configuration of a related entities or events case block.
         * @summary Update related entities or events block config
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {string} blockKey The key of the related entities or events block to update
         * @param {Payload1} payload1 
         * @param {string | null} [ifMatch] ETag value for optimistic concurrency control. If not provided, last-write-wins semantics apply.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatch: async (caseId: string, blockKey: string, payload1: Payload1, ifMatch?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('patchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatch', 'caseId', caseId)
            // verify required parameter 'blockKey' is not null or undefined
            assertParamExists('patchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatch', 'blockKey', blockKey)
            // verify required parameter 'payload1' is not null or undefined
            assertParamExists('patchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatch', 'payload1', payload1)
            const localVarPath = `/api/v1/cases/{case_id}/blocks/{block_key}/config`
                .replace(`{${"case_id"}}`, encodeURIComponent(String(caseId)))
                .replace(`{${"block_key"}}`, encodeURIComponent(String(blockKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payload1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the data content of a markdown case block.
         * @summary Update case block data
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {string} blockKey The key of the case block to update
         * @param {Payload} payload 
         * @param {string | null} [ifMatch] ETag value for optimistic concurrency control. If not provided, last-write-wins semantics apply.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatch: async (caseId: string, blockKey: string, payload: Payload, ifMatch?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('patchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatch', 'caseId', caseId)
            // verify required parameter 'blockKey' is not null or undefined
            assertParamExists('patchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatch', 'blockKey', blockKey)
            // verify required parameter 'payload' is not null or undefined
            assertParamExists('patchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatch', 'payload', payload)
            const localVarPath = `/api/v1/cases/{case_id}/blocks/{block_key}/data`
                .replace(`{${"case_id"}}`, encodeURIComponent(String(caseId)))
                .replace(`{${"block_key"}}`, encodeURIComponent(String(blockKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update one or more properties of a case. Supports optional optimistic concurrency control via If-Match header. If If-Match header is not provided, last-write-wins semantics apply.
         * @summary Patch one case property
         * @param {string} id The unique identifier of the case (UUID7)
         * @param {CasePropertiesPatchRequest} casePropertiesPatchRequest 
         * @param {string | null} [ifMatch] ETag value for optimistic concurrency control. If not provided, last-write-wins semantics apply.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCasePropertyApiV1CasesIdPropertiesPatch: async (id: string, casePropertiesPatchRequest: CasePropertiesPatchRequest, ifMatch?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchCasePropertyApiV1CasesIdPropertiesPatch', 'id', id)
            // verify required parameter 'casePropertiesPatchRequest' is not null or undefined
            assertParamExists('patchCasePropertyApiV1CasesIdPropertiesPatch', 'casePropertiesPatchRequest', casePropertiesPatchRequest)
            const localVarPath = `/api/v1/cases/{id}/properties`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(casePropertiesPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update form data for a specific case task. Requires optimistic concurrency control via If-Match header.
         * @summary Patch case task form state
         * @param {string} caseId The unique identifier of the case (UUID7)
         * @param {string} taskKey The composite identifier of the task within the case. Format: {status_key}#{task_key} where status_key is \&#39;status\&#39; or \&#39;status-sub_status\&#39; (e.g., \&#39;open#submit\&#39;, \&#39;pending_review-waiting_docs#review\&#39;)
         * @param {string} ifMatch ETag value for optimistic concurrency control (required).
         * @param {CaseTaskFormPatchRequest} caseTaskFormPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCaseTaskFormStateApiV1CasesCaseIdTasksTaskKeyFormDataPatch: async (caseId: string, taskKey: string, ifMatch: string, caseTaskFormPatchRequest: CaseTaskFormPatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('patchCaseTaskFormStateApiV1CasesCaseIdTasksTaskKeyFormDataPatch', 'caseId', caseId)
            // verify required parameter 'taskKey' is not null or undefined
            assertParamExists('patchCaseTaskFormStateApiV1CasesCaseIdTasksTaskKeyFormDataPatch', 'taskKey', taskKey)
            // verify required parameter 'ifMatch' is not null or undefined
            assertParamExists('patchCaseTaskFormStateApiV1CasesCaseIdTasksTaskKeyFormDataPatch', 'ifMatch', ifMatch)
            // verify required parameter 'caseTaskFormPatchRequest' is not null or undefined
            assertParamExists('patchCaseTaskFormStateApiV1CasesCaseIdTasksTaskKeyFormDataPatch', 'caseTaskFormPatchRequest', caseTaskFormPatchRequest)
            const localVarPath = `/api/v1/cases/{case_id}/tasks/{task_key}/form_data`
                .replace(`{${"case_id"}}`, encodeURIComponent(String(caseId)))
                .replace(`{${"task_key"}}`, encodeURIComponent(String(taskKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(caseTaskFormPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patch the list of file IDs for a specific file category in a case
         * @summary Patch file category file IDs
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {string} categoryKey The key of the file category to update
         * @param {FileCategoriesPatchRequest} fileCategoriesPatchRequest 
         * @param {string | null} [ifMatch] ETag value for optimistic concurrency control. If not provided, last-write-wins semantics apply.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchFileCategoryApiV1CasesCaseIdFileCategoriesCategoryKeyPatch: async (caseId: string, categoryKey: string, fileCategoriesPatchRequest: FileCategoriesPatchRequest, ifMatch?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('patchFileCategoryApiV1CasesCaseIdFileCategoriesCategoryKeyPatch', 'caseId', caseId)
            // verify required parameter 'categoryKey' is not null or undefined
            assertParamExists('patchFileCategoryApiV1CasesCaseIdFileCategoriesCategoryKeyPatch', 'categoryKey', categoryKey)
            // verify required parameter 'fileCategoriesPatchRequest' is not null or undefined
            assertParamExists('patchFileCategoryApiV1CasesCaseIdFileCategoriesCategoryKeyPatch', 'fileCategoriesPatchRequest', fileCategoriesPatchRequest)
            const localVarPath = `/api/v1/cases/{case_id}/file_categories/{category_key}`
                .replace(`{${"case_id"}}`, encodeURIComponent(String(caseId)))
                .replace(`{${"category_key"}}`, encodeURIComponent(String(categoryKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileCategoriesPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the completion status of a task. When completing a task (is_completed=true), validates that all required fields are filled and validates field values against template configuration. Requires optimistic concurrency control via If-Match header. Optionally supports If-Match-Form header for task form state etag validation to prevent race conditions when task forms are modified concurrently.
         * @summary Update task completion status
         * @param {string} caseId The unique identifier of the case (UUID7)
         * @param {string} taskKey The composite identifier of the task within the case. Format: {status_key}#{task_key} where status_key is \&#39;status\&#39; or \&#39;status-sub_status\&#39; (e.g., \&#39;open#review_task\&#39;, \&#39;pending_review-waiting_docs#approve_task\&#39;)
         * @param {string} ifMatch ETag value for optimistic concurrency control (required).
         * @param {CaseTaskCompletionPatchRequest} caseTaskCompletionPatchRequest 
         * @param {string | null} [ifMatchForm] Optional ETag for the task form state. If provided, the form must match this etag. This is required when completing a task that has a form to prevent race conditions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTaskCompletionStatusApiV1CasesCaseIdTasksTaskKeyPatch: async (caseId: string, taskKey: string, ifMatch: string, caseTaskCompletionPatchRequest: CaseTaskCompletionPatchRequest, ifMatchForm?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('patchTaskCompletionStatusApiV1CasesCaseIdTasksTaskKeyPatch', 'caseId', caseId)
            // verify required parameter 'taskKey' is not null or undefined
            assertParamExists('patchTaskCompletionStatusApiV1CasesCaseIdTasksTaskKeyPatch', 'taskKey', taskKey)
            // verify required parameter 'ifMatch' is not null or undefined
            assertParamExists('patchTaskCompletionStatusApiV1CasesCaseIdTasksTaskKeyPatch', 'ifMatch', ifMatch)
            // verify required parameter 'caseTaskCompletionPatchRequest' is not null or undefined
            assertParamExists('patchTaskCompletionStatusApiV1CasesCaseIdTasksTaskKeyPatch', 'caseTaskCompletionPatchRequest', caseTaskCompletionPatchRequest)
            const localVarPath = `/api/v1/cases/{case_id}/tasks/{task_key}`
                .replace(`{${"case_id"}}`, encodeURIComponent(String(caseId)))
                .replace(`{${"task_key"}}`, encodeURIComponent(String(taskKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (ifMatch != null) {
                localVarHeaderParameter['if-match'] = String(ifMatch);
            }
            if (ifMatchForm != null) {
                localVarHeaderParameter['If-Match-Form'] = String(ifMatchForm);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(caseTaskCompletionPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retry a specific running action for a case.
         * @summary Retry a running action
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {string} runningActionId The unique identifier of the running action (UUID)
         * @param {string} ifMatch ETag value for optimistic concurrency control. Required.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdRetryPost: async (caseId: string, runningActionId: string, ifMatch: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('retryCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdRetryPost', 'caseId', caseId)
            // verify required parameter 'runningActionId' is not null or undefined
            assertParamExists('retryCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdRetryPost', 'runningActionId', runningActionId)
            // verify required parameter 'ifMatch' is not null or undefined
            assertParamExists('retryCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdRetryPost', 'ifMatch', ifMatch)
            const localVarPath = `/api/v1/cases/{case_id}/running_actions/{running_action_id}/retry`
                .replace(`{${"case_id"}}`, encodeURIComponent(String(caseId)))
                .replace(`{${"running_action_id"}}`, encodeURIComponent(String(runningActionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            if (ifMatch != null) {
                localVarHeaderParameter['If-Match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Run a specific action for a case.
         * @summary Run an action
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {string} actionId The unique identifier of the action (str)
         * @param {string} ifMatch ETag value for optimistic concurrency control. Required.
         * @param {string | null} [ifMatchForm] Optional ETag for the action form state. If provided, the form must match this etag.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runCaseActionApiV1CasesCaseIdActionsActionIdRunPost: async (caseId: string, actionId: string, ifMatch: string, ifMatchForm?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('runCaseActionApiV1CasesCaseIdActionsActionIdRunPost', 'caseId', caseId)
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('runCaseActionApiV1CasesCaseIdActionsActionIdRunPost', 'actionId', actionId)
            // verify required parameter 'ifMatch' is not null or undefined
            assertParamExists('runCaseActionApiV1CasesCaseIdActionsActionIdRunPost', 'ifMatch', ifMatch)
            const localVarPath = `/api/v1/cases/{case_id}/actions/{action_id}/run`
                .replace(`{${"case_id"}}`, encodeURIComponent(String(caseId)))
                .replace(`{${"action_id"}}`, encodeURIComponent(String(actionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            if (ifMatch != null) {
                localVarHeaderParameter['If-Match'] = String(ifMatch);
            }
            if (ifMatchForm != null) {
                localVarHeaderParameter['If-Match-Form'] = String(ifMatchForm);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CasesApi - functional programming interface
 * @export
 */
export const CasesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CasesApiAxiosParamCreator(configuration)
    return {
        /**
         * Apply atomic operations to a file category.
         * @summary Apply atomic operations to a file category
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {FileCategoriesAtomicOperationsRequest} fileCategoriesAtomicOperationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyAtomicFileCategoryOperationsApiV1CasesCaseIdFileCategoriesOperationsPost(caseId: string, fileCategoriesAtomicOperationsRequest: FileCategoriesAtomicOperationsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileCategoriesAtomicResultsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyAtomicFileCategoryOperationsApiV1CasesCaseIdFileCategoriesOperationsPost(caseId, fileCategoriesAtomicOperationsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CasesApi.applyAtomicFileCategoryOperationsApiV1CasesCaseIdFileCategoriesOperationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Supports multiple \'update\' operations on the same case in a single request. Allowed targets: to-one relationships \'queue\' and \'assignee\', \'case_properties\' relationship (attributes map), \'case_block_data.{block_key}\' relationship for markdown and table blocks, \'case_block_config.{block_key}\' relationships for entities viewer blocks, \'case_action_forms\' for updating action form data, and \'case_task_forms\' for updating task form data.
         * @summary Apply atomic operations on a case (relationships and properties)
         * @param {string} id The unique identifier of the case (UUID4)
         * @param {CaseAtomicOperationsRequest} caseAtomicOperationsRequest 
         * @param {string | null} [runningActionID] Optional running action ID to mark action as success
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyAtomicOperationsApiV1CasesIdOperationsPost(id: string, caseAtomicOperationsRequest: CaseAtomicOperationsRequest, runningActionID?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseAtomicResultsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyAtomicOperationsApiV1CasesIdOperationsPost(id, caseAtomicOperationsRequest, runningActionID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CasesApi.applyAtomicOperationsApiV1CasesIdOperationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Supports multiple \'update\' operations across cases using JSON:API Atomic. - Assign - Archive - Run Action (execute case actions in bulk)
         * @summary Apply atomic operations across cases of the same queue
         * @param {string} queueId 
         * @param {CaseBulkAtomicOperationsRequest} caseBulkAtomicOperationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyBulkAtomicOperationsApiV1CasesOperationsQueueQueueIdPost(queueId: string, caseBulkAtomicOperationsRequest: CaseBulkAtomicOperationsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseAtomicResultsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyBulkAtomicOperationsApiV1CasesOperationsQueueQueueIdPost(queueId, caseBulkAtomicOperationsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CasesApi.applyBulkAtomicOperationsApiV1CasesOperationsQueueQueueIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a case: - Validate case data against template version\'s input JSON schema - Send create case message to SQS
         * @summary Create a case from a template version
         * @param {string} idempotencyKey UUID v4 idempotency key to ensure exactly-once case creation
         * @param {CaseCreateRequest} caseCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCaseApiV1CasesPost(idempotencyKey: string, caseCreateRequest: CaseCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseCreateAcceptedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCaseApiV1CasesPost(idempotencyKey, caseCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CasesApi.createCaseApiV1CasesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a comment for a case that will be added to the case history
         * @summary Create a case comment
         * @param {string} caseId The unique identifier of the case (UUID7)
         * @param {CaseCommentCreateRequest} caseCommentCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCaseCommentApiV1CasesCaseIdCommentsPost(caseId: string, caseCommentCreateRequest: CaseCommentCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseCommentCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCaseCommentApiV1CasesCaseIdCommentsPost(caseId, caseCommentCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CasesApi.createCaseCommentApiV1CasesCaseIdCommentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Dismiss a specific running action for a case by removing it. Can only dismiss actions in FAILED state.
         * @summary Dismiss a running action
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {string} runningActionId The unique identifier of the running action (UUID)
         * @param {string} ifMatch ETag value for optimistic concurrency control. Required.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dismissCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdDismissPost(caseId: string, runningActionId: string, ifMatch: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RunningActionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dismissCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdDismissPost(caseId, runningActionId, ifMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CasesApi.dismissCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdDismissPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a case by id
         * @param {string} id The unique identifier of the case (UUID7)
         * @param {string | null} [include] Comma-separated list of related resources to include. Supported paths: \&#39;case_blocks.external_data\&#39; to include external data for all entity details blocks
         * @param {string | null} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCaseApiV1CasesIdGet(id: string, include?: string | null, ifNoneMatch?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCaseApiV1CasesIdGet(id, include, ifNoneMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CasesApi.getCaseApiV1CasesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve paginated case history events for a specific case. Returns a chronological timeline of all events that occurred during the case lifecycle. Supports cursor-based pagination and sorting by timestamp using JSON:API conventions.
         * @summary Get case history events with pagination
         * @param {string} caseId The unique identifier of the case (UUID7)
         * @param {number} [pageSize] Number of history events to return (1-200). Default: 15 events
         * @param {string | null} [pageCursor] Pagination cursor in format \&#39;timestamp,event_id\&#39; (e.g., \&#39;2024-01-15T14:30:00Z,event-abc123\&#39;). Use the cursor from the previous response\&#39;s links.next to get the next page. Start without a cursor to get the first page.
         * @param {GetCaseHistoryApiV1CasesCaseIdHistoryGetPageDirectionEnum} [pageDirection] Pagination direction. \&#39;backward\&#39; (default): Most recent events first, paginate towards older events. \&#39;forward\&#39;: Oldest events first, paginate towards newer events.
         * @param {string | null} [sort] Sort order: Only \&#39;timestamp\&#39; (ascending) is supported to guarantee ordered results. Pagination direction is controlled by the page[direction] parameter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCaseHistoryApiV1CasesCaseIdHistoryGet(caseId: string, pageSize?: number, pageCursor?: string | null, pageDirection?: GetCaseHistoryApiV1CasesCaseIdHistoryGetPageDirectionEnum, sort?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseHistoryEventsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCaseHistoryApiV1CasesCaseIdHistoryGet(caseId, pageSize, pageCursor, pageDirection, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CasesApi.getCaseHistoryApiV1CasesCaseIdHistoryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find cases with applied property filters. Supports filtering by any template properties using exact match or contains operations. Supports cursor-based pagination and sorting by creation date.
         * @summary List cases with property filters
         * @param {GetCasesApiV1CasesGetFilterEnvEnum} filterEnv 
         * @param {string | null} [sort] Sort order: \&#39;created_at\&#39; or \&#39;-created_at\&#39;
         * @param {number} [pageSize] Maximum number of related cases to return
         * @param {string | null} [pageCursor] Cursor for pagination
         * @param {string | null} [filterColumnEntityType] Filter by entity type in template properties
         * @param {string | null} [filterCreatedAtGt] 
         * @param {string | null} [filterCreatedAtGte] 
         * @param {string | null} [filterCreatedAtLt] 
         * @param {string | null} [filterCreatedAtLte] 
         * @param {string | null} [filterUpdatedAtGt] 
         * @param {string | null} [filterUpdatedAtGte] 
         * @param {string | null} [filterUpdatedAtLt] 
         * @param {string | null} [filterUpdatedAtLte] 
         * @param {{ [key: string]: any; }} [filterProperties]  Dynamic property filters using the pattern &#x60;filter[properties][property_name]&#x3D;value&#x60;.  **How It Works:** - Filter cases by any properties stored in the case\&#39;s JSONB properties field - Each case template defines its own set of properties - You can filter on any property that exists in your case data - Uses exact match by default  **Examples:** - &#x60;filter[properties][status]&#x3D;open&#x60; - Cases with status \&quot;open\&quot; - &#x60;filter[properties][customer]&#x3D;customer123&#x60; - Cases where customer equals \&quot;customer123\&quot; - &#x60;filter[properties][priority]&#x3D;high&#x60; - Cases with priority \&quot;high\&quot;  **Note:** All property values are treated as strings for filtering purposes.                 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCasesApiV1CasesGet(filterEnv: GetCasesApiV1CasesGetFilterEnvEnum, sort?: string | null, pageSize?: number, pageCursor?: string | null, filterColumnEntityType?: string | null, filterCreatedAtGt?: string | null, filterCreatedAtGte?: string | null, filterCreatedAtLt?: string | null, filterCreatedAtLte?: string | null, filterUpdatedAtGt?: string | null, filterUpdatedAtGte?: string | null, filterUpdatedAtLt?: string | null, filterUpdatedAtLte?: string | null, filterProperties?: { [key: string]: any; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CasesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCasesApiV1CasesGet(filterEnv, sort, pageSize, pageCursor, filterColumnEntityType, filterCreatedAtGt, filterCreatedAtGte, filterCreatedAtLt, filterCreatedAtLte, filterUpdatedAtGt, filterUpdatedAtGte, filterUpdatedAtLt, filterUpdatedAtLte, filterProperties, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CasesApi.getCasesApiV1CasesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update form data for a specific case action. Requires optimistic concurrency control via If-Match header.
         * @summary Patch case action form state
         * @param {string} id The unique identifier of the case (UUID7)
         * @param {string} actionId The composite identifier of the action within the case. Format: {status_key}#{action_key} where status_key is \&#39;status\&#39; or \&#39;status-sub_status\&#39; (e.g., \&#39;open#submit\&#39;, \&#39;pending_review-waiting_docs#review\&#39;)
         * @param {string} ifMatch ETag value for optimistic concurrency control (required).
         * @param {CaseActionFormPatchRequest} caseActionFormPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCaseActionFormStateApiV1CasesIdActionActionIdFormStatePatch(id: string, actionId: string, ifMatch: string, caseActionFormPatchRequest: CaseActionFormPatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseActionFormPatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCaseActionFormStateApiV1CasesIdActionActionIdFormStatePatch(id, actionId, ifMatch, caseActionFormPatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CasesApi.patchCaseActionFormStateApiV1CasesIdActionActionIdFormStatePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update queue and/or assignee relationships of a case. Supports optional optimistic concurrency control via If-Match header. If If-Match header is not provided, last-write-wins semantics apply.
         * @summary Patch case queue and/or assignee relationships
         * @param {string} id The unique identifier of the case (UUID4)
         * @param {CasePatchRequest} casePatchRequest 
         * @param {string | null} [include] Comma-separated list of related resources to include. Supported paths: \&#39;case_blocks.external_data\&#39; to include external data for all entity details blocks
         * @param {string | null} [ifMatch] ETag value for optimistic concurrency control. If not provided, last-write-wins semantics apply.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCaseApiV1CasesIdPatch(id: string, casePatchRequest: CasePatchRequest, include?: string | null, ifMatch?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CasePatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCaseApiV1CasesIdPatch(id, casePatchRequest, include, ifMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CasesApi.patchCaseApiV1CasesIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the configuration of a related entities or events case block.
         * @summary Update related entities or events block config
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {string} blockKey The key of the related entities or events block to update
         * @param {Payload1} payload1 
         * @param {string | null} [ifMatch] ETag value for optimistic concurrency control. If not provided, last-write-wins semantics apply.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatch(caseId: string, blockKey: string, payload1: Payload1, ifMatch?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePatchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatch>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatch(caseId, blockKey, payload1, ifMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CasesApi.patchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the data content of a markdown case block.
         * @summary Update case block data
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {string} blockKey The key of the case block to update
         * @param {Payload} payload 
         * @param {string | null} [ifMatch] ETag value for optimistic concurrency control. If not provided, last-write-wins semantics apply.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatch(caseId: string, blockKey: string, payload: Payload, ifMatch?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePatchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatch>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatch(caseId, blockKey, payload, ifMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CasesApi.patchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update one or more properties of a case. Supports optional optimistic concurrency control via If-Match header. If If-Match header is not provided, last-write-wins semantics apply.
         * @summary Patch one case property
         * @param {string} id The unique identifier of the case (UUID7)
         * @param {CasePropertiesPatchRequest} casePropertiesPatchRequest 
         * @param {string | null} [ifMatch] ETag value for optimistic concurrency control. If not provided, last-write-wins semantics apply.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCasePropertyApiV1CasesIdPropertiesPatch(id: string, casePropertiesPatchRequest: CasePropertiesPatchRequest, ifMatch?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CasePropertiesPatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCasePropertyApiV1CasesIdPropertiesPatch(id, casePropertiesPatchRequest, ifMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CasesApi.patchCasePropertyApiV1CasesIdPropertiesPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update form data for a specific case task. Requires optimistic concurrency control via If-Match header.
         * @summary Patch case task form state
         * @param {string} caseId The unique identifier of the case (UUID7)
         * @param {string} taskKey The composite identifier of the task within the case. Format: {status_key}#{task_key} where status_key is \&#39;status\&#39; or \&#39;status-sub_status\&#39; (e.g., \&#39;open#submit\&#39;, \&#39;pending_review-waiting_docs#review\&#39;)
         * @param {string} ifMatch ETag value for optimistic concurrency control (required).
         * @param {CaseTaskFormPatchRequest} caseTaskFormPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCaseTaskFormStateApiV1CasesCaseIdTasksTaskKeyFormDataPatch(caseId: string, taskKey: string, ifMatch: string, caseTaskFormPatchRequest: CaseTaskFormPatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseTaskFormPatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCaseTaskFormStateApiV1CasesCaseIdTasksTaskKeyFormDataPatch(caseId, taskKey, ifMatch, caseTaskFormPatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CasesApi.patchCaseTaskFormStateApiV1CasesCaseIdTasksTaskKeyFormDataPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Patch the list of file IDs for a specific file category in a case
         * @summary Patch file category file IDs
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {string} categoryKey The key of the file category to update
         * @param {FileCategoriesPatchRequest} fileCategoriesPatchRequest 
         * @param {string | null} [ifMatch] ETag value for optimistic concurrency control. If not provided, last-write-wins semantics apply.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchFileCategoryApiV1CasesCaseIdFileCategoriesCategoryKeyPatch(caseId: string, categoryKey: string, fileCategoriesPatchRequest: FileCategoriesPatchRequest, ifMatch?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileCategoriesPatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchFileCategoryApiV1CasesCaseIdFileCategoriesCategoryKeyPatch(caseId, categoryKey, fileCategoriesPatchRequest, ifMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CasesApi.patchFileCategoryApiV1CasesCaseIdFileCategoriesCategoryKeyPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the completion status of a task. When completing a task (is_completed=true), validates that all required fields are filled and validates field values against template configuration. Requires optimistic concurrency control via If-Match header. Optionally supports If-Match-Form header for task form state etag validation to prevent race conditions when task forms are modified concurrently.
         * @summary Update task completion status
         * @param {string} caseId The unique identifier of the case (UUID7)
         * @param {string} taskKey The composite identifier of the task within the case. Format: {status_key}#{task_key} where status_key is \&#39;status\&#39; or \&#39;status-sub_status\&#39; (e.g., \&#39;open#review_task\&#39;, \&#39;pending_review-waiting_docs#approve_task\&#39;)
         * @param {string} ifMatch ETag value for optimistic concurrency control (required).
         * @param {CaseTaskCompletionPatchRequest} caseTaskCompletionPatchRequest 
         * @param {string | null} [ifMatchForm] Optional ETag for the task form state. If provided, the form must match this etag. This is required when completing a task that has a form to prevent race conditions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchTaskCompletionStatusApiV1CasesCaseIdTasksTaskKeyPatch(caseId: string, taskKey: string, ifMatch: string, caseTaskCompletionPatchRequest: CaseTaskCompletionPatchRequest, ifMatchForm?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseTaskCompletionPatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchTaskCompletionStatusApiV1CasesCaseIdTasksTaskKeyPatch(caseId, taskKey, ifMatch, caseTaskCompletionPatchRequest, ifMatchForm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CasesApi.patchTaskCompletionStatusApiV1CasesCaseIdTasksTaskKeyPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retry a specific running action for a case.
         * @summary Retry a running action
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {string} runningActionId The unique identifier of the running action (UUID)
         * @param {string} ifMatch ETag value for optimistic concurrency control. Required.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdRetryPost(caseId: string, runningActionId: string, ifMatch: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RunningActionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdRetryPost(caseId, runningActionId, ifMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CasesApi.retryCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdRetryPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Run a specific action for a case.
         * @summary Run an action
         * @param {string} caseId The unique identifier of the case (UUID)
         * @param {string} actionId The unique identifier of the action (str)
         * @param {string} ifMatch ETag value for optimistic concurrency control. Required.
         * @param {string | null} [ifMatchForm] Optional ETag for the action form state. If provided, the form must match this etag.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runCaseActionApiV1CasesCaseIdActionsActionIdRunPost(caseId: string, actionId: string, ifMatch: string, ifMatchForm?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RunningActionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runCaseActionApiV1CasesCaseIdActionsActionIdRunPost(caseId, actionId, ifMatch, ifMatchForm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CasesApi.runCaseActionApiV1CasesCaseIdActionsActionIdRunPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CasesApi - factory interface
 * @export
 */
export const CasesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CasesApiFp(configuration)
    return {
        /**
         * Apply atomic operations to a file category.
         * @summary Apply atomic operations to a file category
         * @param {CasesApiApplyAtomicFileCategoryOperationsApiV1CasesCaseIdFileCategoriesOperationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyAtomicFileCategoryOperationsApiV1CasesCaseIdFileCategoriesOperationsPost(requestParameters: CasesApiApplyAtomicFileCategoryOperationsApiV1CasesCaseIdFileCategoriesOperationsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<FileCategoriesAtomicResultsResponse> {
            return localVarFp.applyAtomicFileCategoryOperationsApiV1CasesCaseIdFileCategoriesOperationsPost(requestParameters.caseId, requestParameters.fileCategoriesAtomicOperationsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Supports multiple \'update\' operations on the same case in a single request. Allowed targets: to-one relationships \'queue\' and \'assignee\', \'case_properties\' relationship (attributes map), \'case_block_data.{block_key}\' relationship for markdown and table blocks, \'case_block_config.{block_key}\' relationships for entities viewer blocks, \'case_action_forms\' for updating action form data, and \'case_task_forms\' for updating task form data.
         * @summary Apply atomic operations on a case (relationships and properties)
         * @param {CasesApiApplyAtomicOperationsApiV1CasesIdOperationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyAtomicOperationsApiV1CasesIdOperationsPost(requestParameters: CasesApiApplyAtomicOperationsApiV1CasesIdOperationsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CaseAtomicResultsResponse> {
            return localVarFp.applyAtomicOperationsApiV1CasesIdOperationsPost(requestParameters.id, requestParameters.caseAtomicOperationsRequest, requestParameters.runningActionID, options).then((request) => request(axios, basePath));
        },
        /**
         * Supports multiple \'update\' operations across cases using JSON:API Atomic. - Assign - Archive - Run Action (execute case actions in bulk)
         * @summary Apply atomic operations across cases of the same queue
         * @param {CasesApiApplyBulkAtomicOperationsApiV1CasesOperationsQueueQueueIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyBulkAtomicOperationsApiV1CasesOperationsQueueQueueIdPost(requestParameters: CasesApiApplyBulkAtomicOperationsApiV1CasesOperationsQueueQueueIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CaseAtomicResultsResponse> {
            return localVarFp.applyBulkAtomicOperationsApiV1CasesOperationsQueueQueueIdPost(requestParameters.queueId, requestParameters.caseBulkAtomicOperationsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a case: - Validate case data against template version\'s input JSON schema - Send create case message to SQS
         * @summary Create a case from a template version
         * @param {CasesApiCreateCaseApiV1CasesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCaseApiV1CasesPost(requestParameters: CasesApiCreateCaseApiV1CasesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CaseCreateAcceptedResponse> {
            return localVarFp.createCaseApiV1CasesPost(requestParameters.idempotencyKey, requestParameters.caseCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a comment for a case that will be added to the case history
         * @summary Create a case comment
         * @param {CasesApiCreateCaseCommentApiV1CasesCaseIdCommentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCaseCommentApiV1CasesCaseIdCommentsPost(requestParameters: CasesApiCreateCaseCommentApiV1CasesCaseIdCommentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CaseCommentCreateResponse> {
            return localVarFp.createCaseCommentApiV1CasesCaseIdCommentsPost(requestParameters.caseId, requestParameters.caseCommentCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Dismiss a specific running action for a case by removing it. Can only dismiss actions in FAILED state.
         * @summary Dismiss a running action
         * @param {CasesApiDismissCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdDismissPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdDismissPost(requestParameters: CasesApiDismissCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdDismissPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<RunningActionsResponse> {
            return localVarFp.dismissCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdDismissPost(requestParameters.caseId, requestParameters.runningActionId, requestParameters.ifMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a case by id
         * @param {CasesApiGetCaseApiV1CasesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseApiV1CasesIdGet(requestParameters: CasesApiGetCaseApiV1CasesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CaseResponse> {
            return localVarFp.getCaseApiV1CasesIdGet(requestParameters.id, requestParameters.include, requestParameters.ifNoneMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve paginated case history events for a specific case. Returns a chronological timeline of all events that occurred during the case lifecycle. Supports cursor-based pagination and sorting by timestamp using JSON:API conventions.
         * @summary Get case history events with pagination
         * @param {CasesApiGetCaseHistoryApiV1CasesCaseIdHistoryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseHistoryApiV1CasesCaseIdHistoryGet(requestParameters: CasesApiGetCaseHistoryApiV1CasesCaseIdHistoryGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CaseHistoryEventsResponse> {
            return localVarFp.getCaseHistoryApiV1CasesCaseIdHistoryGet(requestParameters.caseId, requestParameters.pageSize, requestParameters.pageCursor, requestParameters.pageDirection, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Find cases with applied property filters. Supports filtering by any template properties using exact match or contains operations. Supports cursor-based pagination and sorting by creation date.
         * @summary List cases with property filters
         * @param {CasesApiGetCasesApiV1CasesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCasesApiV1CasesGet(requestParameters: CasesApiGetCasesApiV1CasesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CasesResponse> {
            return localVarFp.getCasesApiV1CasesGet(requestParameters.filterEnv, requestParameters.sort, requestParameters.pageSize, requestParameters.pageCursor, requestParameters.filterColumnEntityType, requestParameters.filterCreatedAtGt, requestParameters.filterCreatedAtGte, requestParameters.filterCreatedAtLt, requestParameters.filterCreatedAtLte, requestParameters.filterUpdatedAtGt, requestParameters.filterUpdatedAtGte, requestParameters.filterUpdatedAtLt, requestParameters.filterUpdatedAtLte, requestParameters.filterProperties, options).then((request) => request(axios, basePath));
        },
        /**
         * Update form data for a specific case action. Requires optimistic concurrency control via If-Match header.
         * @summary Patch case action form state
         * @param {CasesApiPatchCaseActionFormStateApiV1CasesIdActionActionIdFormStatePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCaseActionFormStateApiV1CasesIdActionActionIdFormStatePatch(requestParameters: CasesApiPatchCaseActionFormStateApiV1CasesIdActionActionIdFormStatePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<CaseActionFormPatchResponse> {
            return localVarFp.patchCaseActionFormStateApiV1CasesIdActionActionIdFormStatePatch(requestParameters.id, requestParameters.actionId, requestParameters.ifMatch, requestParameters.caseActionFormPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update queue and/or assignee relationships of a case. Supports optional optimistic concurrency control via If-Match header. If If-Match header is not provided, last-write-wins semantics apply.
         * @summary Patch case queue and/or assignee relationships
         * @param {CasesApiPatchCaseApiV1CasesIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCaseApiV1CasesIdPatch(requestParameters: CasesApiPatchCaseApiV1CasesIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<CasePatchResponse> {
            return localVarFp.patchCaseApiV1CasesIdPatch(requestParameters.id, requestParameters.casePatchRequest, requestParameters.include, requestParameters.ifMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the configuration of a related entities or events case block.
         * @summary Update related entities or events block config
         * @param {CasesApiPatchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatch(requestParameters: CasesApiPatchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponsePatchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatch> {
            return localVarFp.patchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatch(requestParameters.caseId, requestParameters.blockKey, requestParameters.payload1, requestParameters.ifMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the data content of a markdown case block.
         * @summary Update case block data
         * @param {CasesApiPatchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatch(requestParameters: CasesApiPatchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponsePatchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatch> {
            return localVarFp.patchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatch(requestParameters.caseId, requestParameters.blockKey, requestParameters.payload, requestParameters.ifMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Update one or more properties of a case. Supports optional optimistic concurrency control via If-Match header. If If-Match header is not provided, last-write-wins semantics apply.
         * @summary Patch one case property
         * @param {CasesApiPatchCasePropertyApiV1CasesIdPropertiesPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCasePropertyApiV1CasesIdPropertiesPatch(requestParameters: CasesApiPatchCasePropertyApiV1CasesIdPropertiesPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<CasePropertiesPatchResponse> {
            return localVarFp.patchCasePropertyApiV1CasesIdPropertiesPatch(requestParameters.id, requestParameters.casePropertiesPatchRequest, requestParameters.ifMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Update form data for a specific case task. Requires optimistic concurrency control via If-Match header.
         * @summary Patch case task form state
         * @param {CasesApiPatchCaseTaskFormStateApiV1CasesCaseIdTasksTaskKeyFormDataPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCaseTaskFormStateApiV1CasesCaseIdTasksTaskKeyFormDataPatch(requestParameters: CasesApiPatchCaseTaskFormStateApiV1CasesCaseIdTasksTaskKeyFormDataPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<CaseTaskFormPatchResponse> {
            return localVarFp.patchCaseTaskFormStateApiV1CasesCaseIdTasksTaskKeyFormDataPatch(requestParameters.caseId, requestParameters.taskKey, requestParameters.ifMatch, requestParameters.caseTaskFormPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Patch the list of file IDs for a specific file category in a case
         * @summary Patch file category file IDs
         * @param {CasesApiPatchFileCategoryApiV1CasesCaseIdFileCategoriesCategoryKeyPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchFileCategoryApiV1CasesCaseIdFileCategoriesCategoryKeyPatch(requestParameters: CasesApiPatchFileCategoryApiV1CasesCaseIdFileCategoriesCategoryKeyPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<FileCategoriesPatchResponse> {
            return localVarFp.patchFileCategoryApiV1CasesCaseIdFileCategoriesCategoryKeyPatch(requestParameters.caseId, requestParameters.categoryKey, requestParameters.fileCategoriesPatchRequest, requestParameters.ifMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the completion status of a task. When completing a task (is_completed=true), validates that all required fields are filled and validates field values against template configuration. Requires optimistic concurrency control via If-Match header. Optionally supports If-Match-Form header for task form state etag validation to prevent race conditions when task forms are modified concurrently.
         * @summary Update task completion status
         * @param {CasesApiPatchTaskCompletionStatusApiV1CasesCaseIdTasksTaskKeyPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTaskCompletionStatusApiV1CasesCaseIdTasksTaskKeyPatch(requestParameters: CasesApiPatchTaskCompletionStatusApiV1CasesCaseIdTasksTaskKeyPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<CaseTaskCompletionPatchResponse> {
            return localVarFp.patchTaskCompletionStatusApiV1CasesCaseIdTasksTaskKeyPatch(requestParameters.caseId, requestParameters.taskKey, requestParameters.ifMatch, requestParameters.caseTaskCompletionPatchRequest, requestParameters.ifMatchForm, options).then((request) => request(axios, basePath));
        },
        /**
         * Retry a specific running action for a case.
         * @summary Retry a running action
         * @param {CasesApiRetryCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdRetryPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdRetryPost(requestParameters: CasesApiRetryCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdRetryPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<RunningActionsResponse> {
            return localVarFp.retryCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdRetryPost(requestParameters.caseId, requestParameters.runningActionId, requestParameters.ifMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Run a specific action for a case.
         * @summary Run an action
         * @param {CasesApiRunCaseActionApiV1CasesCaseIdActionsActionIdRunPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runCaseActionApiV1CasesCaseIdActionsActionIdRunPost(requestParameters: CasesApiRunCaseActionApiV1CasesCaseIdActionsActionIdRunPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<RunningActionsResponse> {
            return localVarFp.runCaseActionApiV1CasesCaseIdActionsActionIdRunPost(requestParameters.caseId, requestParameters.actionId, requestParameters.ifMatch, requestParameters.ifMatchForm, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for applyAtomicFileCategoryOperationsApiV1CasesCaseIdFileCategoriesOperationsPost operation in CasesApi.
 * @export
 * @interface CasesApiApplyAtomicFileCategoryOperationsApiV1CasesCaseIdFileCategoriesOperationsPostRequest
 */
export interface CasesApiApplyAtomicFileCategoryOperationsApiV1CasesCaseIdFileCategoriesOperationsPostRequest {
    /**
     * The unique identifier of the case (UUID)
     * @type {string}
     * @memberof CasesApiApplyAtomicFileCategoryOperationsApiV1CasesCaseIdFileCategoriesOperationsPost
     */
    readonly caseId: string

    /**
     * 
     * @type {FileCategoriesAtomicOperationsRequest}
     * @memberof CasesApiApplyAtomicFileCategoryOperationsApiV1CasesCaseIdFileCategoriesOperationsPost
     */
    readonly fileCategoriesAtomicOperationsRequest: FileCategoriesAtomicOperationsRequest
}

/**
 * Request parameters for applyAtomicOperationsApiV1CasesIdOperationsPost operation in CasesApi.
 * @export
 * @interface CasesApiApplyAtomicOperationsApiV1CasesIdOperationsPostRequest
 */
export interface CasesApiApplyAtomicOperationsApiV1CasesIdOperationsPostRequest {
    /**
     * The unique identifier of the case (UUID4)
     * @type {string}
     * @memberof CasesApiApplyAtomicOperationsApiV1CasesIdOperationsPost
     */
    readonly id: string

    /**
     * 
     * @type {CaseAtomicOperationsRequest}
     * @memberof CasesApiApplyAtomicOperationsApiV1CasesIdOperationsPost
     */
    readonly caseAtomicOperationsRequest: CaseAtomicOperationsRequest

    /**
     * Optional running action ID to mark action as success
     * @type {string}
     * @memberof CasesApiApplyAtomicOperationsApiV1CasesIdOperationsPost
     */
    readonly runningActionID?: string | null
}

/**
 * Request parameters for applyBulkAtomicOperationsApiV1CasesOperationsQueueQueueIdPost operation in CasesApi.
 * @export
 * @interface CasesApiApplyBulkAtomicOperationsApiV1CasesOperationsQueueQueueIdPostRequest
 */
export interface CasesApiApplyBulkAtomicOperationsApiV1CasesOperationsQueueQueueIdPostRequest {
    /**
     * 
     * @type {string}
     * @memberof CasesApiApplyBulkAtomicOperationsApiV1CasesOperationsQueueQueueIdPost
     */
    readonly queueId: string

    /**
     * 
     * @type {CaseBulkAtomicOperationsRequest}
     * @memberof CasesApiApplyBulkAtomicOperationsApiV1CasesOperationsQueueQueueIdPost
     */
    readonly caseBulkAtomicOperationsRequest: CaseBulkAtomicOperationsRequest
}

/**
 * Request parameters for createCaseApiV1CasesPost operation in CasesApi.
 * @export
 * @interface CasesApiCreateCaseApiV1CasesPostRequest
 */
export interface CasesApiCreateCaseApiV1CasesPostRequest {
    /**
     * UUID v4 idempotency key to ensure exactly-once case creation
     * @type {string}
     * @memberof CasesApiCreateCaseApiV1CasesPost
     */
    readonly idempotencyKey: string

    /**
     * 
     * @type {CaseCreateRequest}
     * @memberof CasesApiCreateCaseApiV1CasesPost
     */
    readonly caseCreateRequest: CaseCreateRequest
}

/**
 * Request parameters for createCaseCommentApiV1CasesCaseIdCommentsPost operation in CasesApi.
 * @export
 * @interface CasesApiCreateCaseCommentApiV1CasesCaseIdCommentsPostRequest
 */
export interface CasesApiCreateCaseCommentApiV1CasesCaseIdCommentsPostRequest {
    /**
     * The unique identifier of the case (UUID7)
     * @type {string}
     * @memberof CasesApiCreateCaseCommentApiV1CasesCaseIdCommentsPost
     */
    readonly caseId: string

    /**
     * 
     * @type {CaseCommentCreateRequest}
     * @memberof CasesApiCreateCaseCommentApiV1CasesCaseIdCommentsPost
     */
    readonly caseCommentCreateRequest: CaseCommentCreateRequest
}

/**
 * Request parameters for dismissCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdDismissPost operation in CasesApi.
 * @export
 * @interface CasesApiDismissCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdDismissPostRequest
 */
export interface CasesApiDismissCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdDismissPostRequest {
    /**
     * The unique identifier of the case (UUID)
     * @type {string}
     * @memberof CasesApiDismissCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdDismissPost
     */
    readonly caseId: string

    /**
     * The unique identifier of the running action (UUID)
     * @type {string}
     * @memberof CasesApiDismissCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdDismissPost
     */
    readonly runningActionId: string

    /**
     * ETag value for optimistic concurrency control. Required.
     * @type {string}
     * @memberof CasesApiDismissCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdDismissPost
     */
    readonly ifMatch: string
}

/**
 * Request parameters for getCaseApiV1CasesIdGet operation in CasesApi.
 * @export
 * @interface CasesApiGetCaseApiV1CasesIdGetRequest
 */
export interface CasesApiGetCaseApiV1CasesIdGetRequest {
    /**
     * The unique identifier of the case (UUID7)
     * @type {string}
     * @memberof CasesApiGetCaseApiV1CasesIdGet
     */
    readonly id: string

    /**
     * Comma-separated list of related resources to include. Supported paths: \&#39;case_blocks.external_data\&#39; to include external data for all entity details blocks
     * @type {string}
     * @memberof CasesApiGetCaseApiV1CasesIdGet
     */
    readonly include?: string | null

    /**
     * 
     * @type {string}
     * @memberof CasesApiGetCaseApiV1CasesIdGet
     */
    readonly ifNoneMatch?: string | null
}

/**
 * Request parameters for getCaseHistoryApiV1CasesCaseIdHistoryGet operation in CasesApi.
 * @export
 * @interface CasesApiGetCaseHistoryApiV1CasesCaseIdHistoryGetRequest
 */
export interface CasesApiGetCaseHistoryApiV1CasesCaseIdHistoryGetRequest {
    /**
     * The unique identifier of the case (UUID7)
     * @type {string}
     * @memberof CasesApiGetCaseHistoryApiV1CasesCaseIdHistoryGet
     */
    readonly caseId: string

    /**
     * Number of history events to return (1-200). Default: 15 events
     * @type {number}
     * @memberof CasesApiGetCaseHistoryApiV1CasesCaseIdHistoryGet
     */
    readonly pageSize?: number

    /**
     * Pagination cursor in format \&#39;timestamp,event_id\&#39; (e.g., \&#39;2024-01-15T14:30:00Z,event-abc123\&#39;). Use the cursor from the previous response\&#39;s links.next to get the next page. Start without a cursor to get the first page.
     * @type {string}
     * @memberof CasesApiGetCaseHistoryApiV1CasesCaseIdHistoryGet
     */
    readonly pageCursor?: string | null

    /**
     * Pagination direction. \&#39;backward\&#39; (default): Most recent events first, paginate towards older events. \&#39;forward\&#39;: Oldest events first, paginate towards newer events.
     * @type {'forward' | 'backward'}
     * @memberof CasesApiGetCaseHistoryApiV1CasesCaseIdHistoryGet
     */
    readonly pageDirection?: GetCaseHistoryApiV1CasesCaseIdHistoryGetPageDirectionEnum

    /**
     * Sort order: Only \&#39;timestamp\&#39; (ascending) is supported to guarantee ordered results. Pagination direction is controlled by the page[direction] parameter.
     * @type {string}
     * @memberof CasesApiGetCaseHistoryApiV1CasesCaseIdHistoryGet
     */
    readonly sort?: string | null
}

/**
 * Request parameters for getCasesApiV1CasesGet operation in CasesApi.
 * @export
 * @interface CasesApiGetCasesApiV1CasesGetRequest
 */
export interface CasesApiGetCasesApiV1CasesGetRequest {
    /**
     * 
     * @type {'live' | 'sandbox'}
     * @memberof CasesApiGetCasesApiV1CasesGet
     */
    readonly filterEnv: GetCasesApiV1CasesGetFilterEnvEnum

    /**
     * Sort order: \&#39;created_at\&#39; or \&#39;-created_at\&#39;
     * @type {string}
     * @memberof CasesApiGetCasesApiV1CasesGet
     */
    readonly sort?: string | null

    /**
     * Maximum number of related cases to return
     * @type {number}
     * @memberof CasesApiGetCasesApiV1CasesGet
     */
    readonly pageSize?: number

    /**
     * Cursor for pagination
     * @type {string}
     * @memberof CasesApiGetCasesApiV1CasesGet
     */
    readonly pageCursor?: string | null

    /**
     * Filter by entity type in template properties
     * @type {string}
     * @memberof CasesApiGetCasesApiV1CasesGet
     */
    readonly filterColumnEntityType?: string | null

    /**
     * 
     * @type {string}
     * @memberof CasesApiGetCasesApiV1CasesGet
     */
    readonly filterCreatedAtGt?: string | null

    /**
     * 
     * @type {string}
     * @memberof CasesApiGetCasesApiV1CasesGet
     */
    readonly filterCreatedAtGte?: string | null

    /**
     * 
     * @type {string}
     * @memberof CasesApiGetCasesApiV1CasesGet
     */
    readonly filterCreatedAtLt?: string | null

    /**
     * 
     * @type {string}
     * @memberof CasesApiGetCasesApiV1CasesGet
     */
    readonly filterCreatedAtLte?: string | null

    /**
     * 
     * @type {string}
     * @memberof CasesApiGetCasesApiV1CasesGet
     */
    readonly filterUpdatedAtGt?: string | null

    /**
     * 
     * @type {string}
     * @memberof CasesApiGetCasesApiV1CasesGet
     */
    readonly filterUpdatedAtGte?: string | null

    /**
     * 
     * @type {string}
     * @memberof CasesApiGetCasesApiV1CasesGet
     */
    readonly filterUpdatedAtLt?: string | null

    /**
     * 
     * @type {string}
     * @memberof CasesApiGetCasesApiV1CasesGet
     */
    readonly filterUpdatedAtLte?: string | null

    /**
     *  Dynamic property filters using the pattern &#x60;filter[properties][property_name]&#x3D;value&#x60;.  **How It Works:** - Filter cases by any properties stored in the case\&#39;s JSONB properties field - Each case template defines its own set of properties - You can filter on any property that exists in your case data - Uses exact match by default  **Examples:** - &#x60;filter[properties][status]&#x3D;open&#x60; - Cases with status \&quot;open\&quot; - &#x60;filter[properties][customer]&#x3D;customer123&#x60; - Cases where customer equals \&quot;customer123\&quot; - &#x60;filter[properties][priority]&#x3D;high&#x60; - Cases with priority \&quot;high\&quot;  **Note:** All property values are treated as strings for filtering purposes.                 
     * @type {{ [key: string]: any; }}
     * @memberof CasesApiGetCasesApiV1CasesGet
     */
    readonly filterProperties?: { [key: string]: any; }
}

/**
 * Request parameters for patchCaseActionFormStateApiV1CasesIdActionActionIdFormStatePatch operation in CasesApi.
 * @export
 * @interface CasesApiPatchCaseActionFormStateApiV1CasesIdActionActionIdFormStatePatchRequest
 */
export interface CasesApiPatchCaseActionFormStateApiV1CasesIdActionActionIdFormStatePatchRequest {
    /**
     * The unique identifier of the case (UUID7)
     * @type {string}
     * @memberof CasesApiPatchCaseActionFormStateApiV1CasesIdActionActionIdFormStatePatch
     */
    readonly id: string

    /**
     * The composite identifier of the action within the case. Format: {status_key}#{action_key} where status_key is \&#39;status\&#39; or \&#39;status-sub_status\&#39; (e.g., \&#39;open#submit\&#39;, \&#39;pending_review-waiting_docs#review\&#39;)
     * @type {string}
     * @memberof CasesApiPatchCaseActionFormStateApiV1CasesIdActionActionIdFormStatePatch
     */
    readonly actionId: string

    /**
     * ETag value for optimistic concurrency control (required).
     * @type {string}
     * @memberof CasesApiPatchCaseActionFormStateApiV1CasesIdActionActionIdFormStatePatch
     */
    readonly ifMatch: string

    /**
     * 
     * @type {CaseActionFormPatchRequest}
     * @memberof CasesApiPatchCaseActionFormStateApiV1CasesIdActionActionIdFormStatePatch
     */
    readonly caseActionFormPatchRequest: CaseActionFormPatchRequest
}

/**
 * Request parameters for patchCaseApiV1CasesIdPatch operation in CasesApi.
 * @export
 * @interface CasesApiPatchCaseApiV1CasesIdPatchRequest
 */
export interface CasesApiPatchCaseApiV1CasesIdPatchRequest {
    /**
     * The unique identifier of the case (UUID4)
     * @type {string}
     * @memberof CasesApiPatchCaseApiV1CasesIdPatch
     */
    readonly id: string

    /**
     * 
     * @type {CasePatchRequest}
     * @memberof CasesApiPatchCaseApiV1CasesIdPatch
     */
    readonly casePatchRequest: CasePatchRequest

    /**
     * Comma-separated list of related resources to include. Supported paths: \&#39;case_blocks.external_data\&#39; to include external data for all entity details blocks
     * @type {string}
     * @memberof CasesApiPatchCaseApiV1CasesIdPatch
     */
    readonly include?: string | null

    /**
     * ETag value for optimistic concurrency control. If not provided, last-write-wins semantics apply.
     * @type {string}
     * @memberof CasesApiPatchCaseApiV1CasesIdPatch
     */
    readonly ifMatch?: string | null
}

/**
 * Request parameters for patchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatch operation in CasesApi.
 * @export
 * @interface CasesApiPatchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatchRequest
 */
export interface CasesApiPatchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatchRequest {
    /**
     * The unique identifier of the case (UUID)
     * @type {string}
     * @memberof CasesApiPatchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatch
     */
    readonly caseId: string

    /**
     * The key of the related entities or events block to update
     * @type {string}
     * @memberof CasesApiPatchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatch
     */
    readonly blockKey: string

    /**
     * 
     * @type {Payload1}
     * @memberof CasesApiPatchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatch
     */
    readonly payload1: Payload1

    /**
     * ETag value for optimistic concurrency control. If not provided, last-write-wins semantics apply.
     * @type {string}
     * @memberof CasesApiPatchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatch
     */
    readonly ifMatch?: string | null
}

/**
 * Request parameters for patchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatch operation in CasesApi.
 * @export
 * @interface CasesApiPatchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatchRequest
 */
export interface CasesApiPatchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatchRequest {
    /**
     * The unique identifier of the case (UUID)
     * @type {string}
     * @memberof CasesApiPatchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatch
     */
    readonly caseId: string

    /**
     * The key of the case block to update
     * @type {string}
     * @memberof CasesApiPatchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatch
     */
    readonly blockKey: string

    /**
     * 
     * @type {Payload}
     * @memberof CasesApiPatchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatch
     */
    readonly payload: Payload

    /**
     * ETag value for optimistic concurrency control. If not provided, last-write-wins semantics apply.
     * @type {string}
     * @memberof CasesApiPatchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatch
     */
    readonly ifMatch?: string | null
}

/**
 * Request parameters for patchCasePropertyApiV1CasesIdPropertiesPatch operation in CasesApi.
 * @export
 * @interface CasesApiPatchCasePropertyApiV1CasesIdPropertiesPatchRequest
 */
export interface CasesApiPatchCasePropertyApiV1CasesIdPropertiesPatchRequest {
    /**
     * The unique identifier of the case (UUID7)
     * @type {string}
     * @memberof CasesApiPatchCasePropertyApiV1CasesIdPropertiesPatch
     */
    readonly id: string

    /**
     * 
     * @type {CasePropertiesPatchRequest}
     * @memberof CasesApiPatchCasePropertyApiV1CasesIdPropertiesPatch
     */
    readonly casePropertiesPatchRequest: CasePropertiesPatchRequest

    /**
     * ETag value for optimistic concurrency control. If not provided, last-write-wins semantics apply.
     * @type {string}
     * @memberof CasesApiPatchCasePropertyApiV1CasesIdPropertiesPatch
     */
    readonly ifMatch?: string | null
}

/**
 * Request parameters for patchCaseTaskFormStateApiV1CasesCaseIdTasksTaskKeyFormDataPatch operation in CasesApi.
 * @export
 * @interface CasesApiPatchCaseTaskFormStateApiV1CasesCaseIdTasksTaskKeyFormDataPatchRequest
 */
export interface CasesApiPatchCaseTaskFormStateApiV1CasesCaseIdTasksTaskKeyFormDataPatchRequest {
    /**
     * The unique identifier of the case (UUID7)
     * @type {string}
     * @memberof CasesApiPatchCaseTaskFormStateApiV1CasesCaseIdTasksTaskKeyFormDataPatch
     */
    readonly caseId: string

    /**
     * The composite identifier of the task within the case. Format: {status_key}#{task_key} where status_key is \&#39;status\&#39; or \&#39;status-sub_status\&#39; (e.g., \&#39;open#submit\&#39;, \&#39;pending_review-waiting_docs#review\&#39;)
     * @type {string}
     * @memberof CasesApiPatchCaseTaskFormStateApiV1CasesCaseIdTasksTaskKeyFormDataPatch
     */
    readonly taskKey: string

    /**
     * ETag value for optimistic concurrency control (required).
     * @type {string}
     * @memberof CasesApiPatchCaseTaskFormStateApiV1CasesCaseIdTasksTaskKeyFormDataPatch
     */
    readonly ifMatch: string

    /**
     * 
     * @type {CaseTaskFormPatchRequest}
     * @memberof CasesApiPatchCaseTaskFormStateApiV1CasesCaseIdTasksTaskKeyFormDataPatch
     */
    readonly caseTaskFormPatchRequest: CaseTaskFormPatchRequest
}

/**
 * Request parameters for patchFileCategoryApiV1CasesCaseIdFileCategoriesCategoryKeyPatch operation in CasesApi.
 * @export
 * @interface CasesApiPatchFileCategoryApiV1CasesCaseIdFileCategoriesCategoryKeyPatchRequest
 */
export interface CasesApiPatchFileCategoryApiV1CasesCaseIdFileCategoriesCategoryKeyPatchRequest {
    /**
     * The unique identifier of the case (UUID)
     * @type {string}
     * @memberof CasesApiPatchFileCategoryApiV1CasesCaseIdFileCategoriesCategoryKeyPatch
     */
    readonly caseId: string

    /**
     * The key of the file category to update
     * @type {string}
     * @memberof CasesApiPatchFileCategoryApiV1CasesCaseIdFileCategoriesCategoryKeyPatch
     */
    readonly categoryKey: string

    /**
     * 
     * @type {FileCategoriesPatchRequest}
     * @memberof CasesApiPatchFileCategoryApiV1CasesCaseIdFileCategoriesCategoryKeyPatch
     */
    readonly fileCategoriesPatchRequest: FileCategoriesPatchRequest

    /**
     * ETag value for optimistic concurrency control. If not provided, last-write-wins semantics apply.
     * @type {string}
     * @memberof CasesApiPatchFileCategoryApiV1CasesCaseIdFileCategoriesCategoryKeyPatch
     */
    readonly ifMatch?: string | null
}

/**
 * Request parameters for patchTaskCompletionStatusApiV1CasesCaseIdTasksTaskKeyPatch operation in CasesApi.
 * @export
 * @interface CasesApiPatchTaskCompletionStatusApiV1CasesCaseIdTasksTaskKeyPatchRequest
 */
export interface CasesApiPatchTaskCompletionStatusApiV1CasesCaseIdTasksTaskKeyPatchRequest {
    /**
     * The unique identifier of the case (UUID7)
     * @type {string}
     * @memberof CasesApiPatchTaskCompletionStatusApiV1CasesCaseIdTasksTaskKeyPatch
     */
    readonly caseId: string

    /**
     * The composite identifier of the task within the case. Format: {status_key}#{task_key} where status_key is \&#39;status\&#39; or \&#39;status-sub_status\&#39; (e.g., \&#39;open#review_task\&#39;, \&#39;pending_review-waiting_docs#approve_task\&#39;)
     * @type {string}
     * @memberof CasesApiPatchTaskCompletionStatusApiV1CasesCaseIdTasksTaskKeyPatch
     */
    readonly taskKey: string

    /**
     * ETag value for optimistic concurrency control (required).
     * @type {string}
     * @memberof CasesApiPatchTaskCompletionStatusApiV1CasesCaseIdTasksTaskKeyPatch
     */
    readonly ifMatch: string

    /**
     * 
     * @type {CaseTaskCompletionPatchRequest}
     * @memberof CasesApiPatchTaskCompletionStatusApiV1CasesCaseIdTasksTaskKeyPatch
     */
    readonly caseTaskCompletionPatchRequest: CaseTaskCompletionPatchRequest

    /**
     * Optional ETag for the task form state. If provided, the form must match this etag. This is required when completing a task that has a form to prevent race conditions.
     * @type {string}
     * @memberof CasesApiPatchTaskCompletionStatusApiV1CasesCaseIdTasksTaskKeyPatch
     */
    readonly ifMatchForm?: string | null
}

/**
 * Request parameters for retryCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdRetryPost operation in CasesApi.
 * @export
 * @interface CasesApiRetryCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdRetryPostRequest
 */
export interface CasesApiRetryCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdRetryPostRequest {
    /**
     * The unique identifier of the case (UUID)
     * @type {string}
     * @memberof CasesApiRetryCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdRetryPost
     */
    readonly caseId: string

    /**
     * The unique identifier of the running action (UUID)
     * @type {string}
     * @memberof CasesApiRetryCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdRetryPost
     */
    readonly runningActionId: string

    /**
     * ETag value for optimistic concurrency control. Required.
     * @type {string}
     * @memberof CasesApiRetryCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdRetryPost
     */
    readonly ifMatch: string
}

/**
 * Request parameters for runCaseActionApiV1CasesCaseIdActionsActionIdRunPost operation in CasesApi.
 * @export
 * @interface CasesApiRunCaseActionApiV1CasesCaseIdActionsActionIdRunPostRequest
 */
export interface CasesApiRunCaseActionApiV1CasesCaseIdActionsActionIdRunPostRequest {
    /**
     * The unique identifier of the case (UUID)
     * @type {string}
     * @memberof CasesApiRunCaseActionApiV1CasesCaseIdActionsActionIdRunPost
     */
    readonly caseId: string

    /**
     * The unique identifier of the action (str)
     * @type {string}
     * @memberof CasesApiRunCaseActionApiV1CasesCaseIdActionsActionIdRunPost
     */
    readonly actionId: string

    /**
     * ETag value for optimistic concurrency control. Required.
     * @type {string}
     * @memberof CasesApiRunCaseActionApiV1CasesCaseIdActionsActionIdRunPost
     */
    readonly ifMatch: string

    /**
     * Optional ETag for the action form state. If provided, the form must match this etag.
     * @type {string}
     * @memberof CasesApiRunCaseActionApiV1CasesCaseIdActionsActionIdRunPost
     */
    readonly ifMatchForm?: string | null
}

/**
 * CasesApi - object-oriented interface
 * @export
 * @class CasesApi
 * @extends {BaseAPI}
 */
export class CasesApi extends BaseAPI {
    /**
     * Apply atomic operations to a file category.
     * @summary Apply atomic operations to a file category
     * @param {CasesApiApplyAtomicFileCategoryOperationsApiV1CasesCaseIdFileCategoriesOperationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApi
     */
    public applyAtomicFileCategoryOperationsApiV1CasesCaseIdFileCategoriesOperationsPost(requestParameters: CasesApiApplyAtomicFileCategoryOperationsApiV1CasesCaseIdFileCategoriesOperationsPostRequest, options?: RawAxiosRequestConfig) {
        return CasesApiFp(this.configuration).applyAtomicFileCategoryOperationsApiV1CasesCaseIdFileCategoriesOperationsPost(requestParameters.caseId, requestParameters.fileCategoriesAtomicOperationsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Supports multiple \'update\' operations on the same case in a single request. Allowed targets: to-one relationships \'queue\' and \'assignee\', \'case_properties\' relationship (attributes map), \'case_block_data.{block_key}\' relationship for markdown and table blocks, \'case_block_config.{block_key}\' relationships for entities viewer blocks, \'case_action_forms\' for updating action form data, and \'case_task_forms\' for updating task form data.
     * @summary Apply atomic operations on a case (relationships and properties)
     * @param {CasesApiApplyAtomicOperationsApiV1CasesIdOperationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApi
     */
    public applyAtomicOperationsApiV1CasesIdOperationsPost(requestParameters: CasesApiApplyAtomicOperationsApiV1CasesIdOperationsPostRequest, options?: RawAxiosRequestConfig) {
        return CasesApiFp(this.configuration).applyAtomicOperationsApiV1CasesIdOperationsPost(requestParameters.id, requestParameters.caseAtomicOperationsRequest, requestParameters.runningActionID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Supports multiple \'update\' operations across cases using JSON:API Atomic. - Assign - Archive - Run Action (execute case actions in bulk)
     * @summary Apply atomic operations across cases of the same queue
     * @param {CasesApiApplyBulkAtomicOperationsApiV1CasesOperationsQueueQueueIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApi
     */
    public applyBulkAtomicOperationsApiV1CasesOperationsQueueQueueIdPost(requestParameters: CasesApiApplyBulkAtomicOperationsApiV1CasesOperationsQueueQueueIdPostRequest, options?: RawAxiosRequestConfig) {
        return CasesApiFp(this.configuration).applyBulkAtomicOperationsApiV1CasesOperationsQueueQueueIdPost(requestParameters.queueId, requestParameters.caseBulkAtomicOperationsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a case: - Validate case data against template version\'s input JSON schema - Send create case message to SQS
     * @summary Create a case from a template version
     * @param {CasesApiCreateCaseApiV1CasesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApi
     */
    public createCaseApiV1CasesPost(requestParameters: CasesApiCreateCaseApiV1CasesPostRequest, options?: RawAxiosRequestConfig) {
        return CasesApiFp(this.configuration).createCaseApiV1CasesPost(requestParameters.idempotencyKey, requestParameters.caseCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a comment for a case that will be added to the case history
     * @summary Create a case comment
     * @param {CasesApiCreateCaseCommentApiV1CasesCaseIdCommentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApi
     */
    public createCaseCommentApiV1CasesCaseIdCommentsPost(requestParameters: CasesApiCreateCaseCommentApiV1CasesCaseIdCommentsPostRequest, options?: RawAxiosRequestConfig) {
        return CasesApiFp(this.configuration).createCaseCommentApiV1CasesCaseIdCommentsPost(requestParameters.caseId, requestParameters.caseCommentCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Dismiss a specific running action for a case by removing it. Can only dismiss actions in FAILED state.
     * @summary Dismiss a running action
     * @param {CasesApiDismissCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdDismissPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApi
     */
    public dismissCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdDismissPost(requestParameters: CasesApiDismissCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdDismissPostRequest, options?: RawAxiosRequestConfig) {
        return CasesApiFp(this.configuration).dismissCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdDismissPost(requestParameters.caseId, requestParameters.runningActionId, requestParameters.ifMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a case by id
     * @param {CasesApiGetCaseApiV1CasesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApi
     */
    public getCaseApiV1CasesIdGet(requestParameters: CasesApiGetCaseApiV1CasesIdGetRequest, options?: RawAxiosRequestConfig) {
        return CasesApiFp(this.configuration).getCaseApiV1CasesIdGet(requestParameters.id, requestParameters.include, requestParameters.ifNoneMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve paginated case history events for a specific case. Returns a chronological timeline of all events that occurred during the case lifecycle. Supports cursor-based pagination and sorting by timestamp using JSON:API conventions.
     * @summary Get case history events with pagination
     * @param {CasesApiGetCaseHistoryApiV1CasesCaseIdHistoryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApi
     */
    public getCaseHistoryApiV1CasesCaseIdHistoryGet(requestParameters: CasesApiGetCaseHistoryApiV1CasesCaseIdHistoryGetRequest, options?: RawAxiosRequestConfig) {
        return CasesApiFp(this.configuration).getCaseHistoryApiV1CasesCaseIdHistoryGet(requestParameters.caseId, requestParameters.pageSize, requestParameters.pageCursor, requestParameters.pageDirection, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find cases with applied property filters. Supports filtering by any template properties using exact match or contains operations. Supports cursor-based pagination and sorting by creation date.
     * @summary List cases with property filters
     * @param {CasesApiGetCasesApiV1CasesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApi
     */
    public getCasesApiV1CasesGet(requestParameters: CasesApiGetCasesApiV1CasesGetRequest, options?: RawAxiosRequestConfig) {
        return CasesApiFp(this.configuration).getCasesApiV1CasesGet(requestParameters.filterEnv, requestParameters.sort, requestParameters.pageSize, requestParameters.pageCursor, requestParameters.filterColumnEntityType, requestParameters.filterCreatedAtGt, requestParameters.filterCreatedAtGte, requestParameters.filterCreatedAtLt, requestParameters.filterCreatedAtLte, requestParameters.filterUpdatedAtGt, requestParameters.filterUpdatedAtGte, requestParameters.filterUpdatedAtLt, requestParameters.filterUpdatedAtLte, requestParameters.filterProperties, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update form data for a specific case action. Requires optimistic concurrency control via If-Match header.
     * @summary Patch case action form state
     * @param {CasesApiPatchCaseActionFormStateApiV1CasesIdActionActionIdFormStatePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApi
     */
    public patchCaseActionFormStateApiV1CasesIdActionActionIdFormStatePatch(requestParameters: CasesApiPatchCaseActionFormStateApiV1CasesIdActionActionIdFormStatePatchRequest, options?: RawAxiosRequestConfig) {
        return CasesApiFp(this.configuration).patchCaseActionFormStateApiV1CasesIdActionActionIdFormStatePatch(requestParameters.id, requestParameters.actionId, requestParameters.ifMatch, requestParameters.caseActionFormPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update queue and/or assignee relationships of a case. Supports optional optimistic concurrency control via If-Match header. If If-Match header is not provided, last-write-wins semantics apply.
     * @summary Patch case queue and/or assignee relationships
     * @param {CasesApiPatchCaseApiV1CasesIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApi
     */
    public patchCaseApiV1CasesIdPatch(requestParameters: CasesApiPatchCaseApiV1CasesIdPatchRequest, options?: RawAxiosRequestConfig) {
        return CasesApiFp(this.configuration).patchCaseApiV1CasesIdPatch(requestParameters.id, requestParameters.casePatchRequest, requestParameters.include, requestParameters.ifMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the configuration of a related entities or events case block.
     * @summary Update related entities or events block config
     * @param {CasesApiPatchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApi
     */
    public patchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatch(requestParameters: CasesApiPatchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatchRequest, options?: RawAxiosRequestConfig) {
        return CasesApiFp(this.configuration).patchCaseBlockConfigApiV1CasesCaseIdBlocksBlockKeyConfigPatch(requestParameters.caseId, requestParameters.blockKey, requestParameters.payload1, requestParameters.ifMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the data content of a markdown case block.
     * @summary Update case block data
     * @param {CasesApiPatchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApi
     */
    public patchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatch(requestParameters: CasesApiPatchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatchRequest, options?: RawAxiosRequestConfig) {
        return CasesApiFp(this.configuration).patchCaseBlockDataApiV1CasesCaseIdBlocksBlockKeyDataPatch(requestParameters.caseId, requestParameters.blockKey, requestParameters.payload, requestParameters.ifMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update one or more properties of a case. Supports optional optimistic concurrency control via If-Match header. If If-Match header is not provided, last-write-wins semantics apply.
     * @summary Patch one case property
     * @param {CasesApiPatchCasePropertyApiV1CasesIdPropertiesPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApi
     */
    public patchCasePropertyApiV1CasesIdPropertiesPatch(requestParameters: CasesApiPatchCasePropertyApiV1CasesIdPropertiesPatchRequest, options?: RawAxiosRequestConfig) {
        return CasesApiFp(this.configuration).patchCasePropertyApiV1CasesIdPropertiesPatch(requestParameters.id, requestParameters.casePropertiesPatchRequest, requestParameters.ifMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update form data for a specific case task. Requires optimistic concurrency control via If-Match header.
     * @summary Patch case task form state
     * @param {CasesApiPatchCaseTaskFormStateApiV1CasesCaseIdTasksTaskKeyFormDataPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApi
     */
    public patchCaseTaskFormStateApiV1CasesCaseIdTasksTaskKeyFormDataPatch(requestParameters: CasesApiPatchCaseTaskFormStateApiV1CasesCaseIdTasksTaskKeyFormDataPatchRequest, options?: RawAxiosRequestConfig) {
        return CasesApiFp(this.configuration).patchCaseTaskFormStateApiV1CasesCaseIdTasksTaskKeyFormDataPatch(requestParameters.caseId, requestParameters.taskKey, requestParameters.ifMatch, requestParameters.caseTaskFormPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Patch the list of file IDs for a specific file category in a case
     * @summary Patch file category file IDs
     * @param {CasesApiPatchFileCategoryApiV1CasesCaseIdFileCategoriesCategoryKeyPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApi
     */
    public patchFileCategoryApiV1CasesCaseIdFileCategoriesCategoryKeyPatch(requestParameters: CasesApiPatchFileCategoryApiV1CasesCaseIdFileCategoriesCategoryKeyPatchRequest, options?: RawAxiosRequestConfig) {
        return CasesApiFp(this.configuration).patchFileCategoryApiV1CasesCaseIdFileCategoriesCategoryKeyPatch(requestParameters.caseId, requestParameters.categoryKey, requestParameters.fileCategoriesPatchRequest, requestParameters.ifMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the completion status of a task. When completing a task (is_completed=true), validates that all required fields are filled and validates field values against template configuration. Requires optimistic concurrency control via If-Match header. Optionally supports If-Match-Form header for task form state etag validation to prevent race conditions when task forms are modified concurrently.
     * @summary Update task completion status
     * @param {CasesApiPatchTaskCompletionStatusApiV1CasesCaseIdTasksTaskKeyPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApi
     */
    public patchTaskCompletionStatusApiV1CasesCaseIdTasksTaskKeyPatch(requestParameters: CasesApiPatchTaskCompletionStatusApiV1CasesCaseIdTasksTaskKeyPatchRequest, options?: RawAxiosRequestConfig) {
        return CasesApiFp(this.configuration).patchTaskCompletionStatusApiV1CasesCaseIdTasksTaskKeyPatch(requestParameters.caseId, requestParameters.taskKey, requestParameters.ifMatch, requestParameters.caseTaskCompletionPatchRequest, requestParameters.ifMatchForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retry a specific running action for a case.
     * @summary Retry a running action
     * @param {CasesApiRetryCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdRetryPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApi
     */
    public retryCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdRetryPost(requestParameters: CasesApiRetryCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdRetryPostRequest, options?: RawAxiosRequestConfig) {
        return CasesApiFp(this.configuration).retryCaseRunningActionApiV1CasesCaseIdRunningActionsRunningActionIdRetryPost(requestParameters.caseId, requestParameters.runningActionId, requestParameters.ifMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Run a specific action for a case.
     * @summary Run an action
     * @param {CasesApiRunCaseActionApiV1CasesCaseIdActionsActionIdRunPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApi
     */
    public runCaseActionApiV1CasesCaseIdActionsActionIdRunPost(requestParameters: CasesApiRunCaseActionApiV1CasesCaseIdActionsActionIdRunPostRequest, options?: RawAxiosRequestConfig) {
        return CasesApiFp(this.configuration).runCaseActionApiV1CasesCaseIdActionsActionIdRunPost(requestParameters.caseId, requestParameters.actionId, requestParameters.ifMatch, requestParameters.ifMatchForm, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetCaseHistoryApiV1CasesCaseIdHistoryGetPageDirectionEnum = {
    FORWARD: 'forward',
    BACKWARD: 'backward'
} as const;
export type GetCaseHistoryApiV1CasesCaseIdHistoryGetPageDirectionEnum = typeof GetCaseHistoryApiV1CasesCaseIdHistoryGetPageDirectionEnum[keyof typeof GetCaseHistoryApiV1CasesCaseIdHistoryGetPageDirectionEnum];
/**
 * @export
 */
export const GetCasesApiV1CasesGetFilterEnvEnum = {
    LIVE: 'live',
    SANDBOX: 'sandbox'
} as const;
export type GetCasesApiV1CasesGetFilterEnvEnum = typeof GetCasesApiV1CasesGetFilterEnvEnum[keyof typeof GetCasesApiV1CasesGetFilterEnvEnum];


